import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type APIKey = {
  __typename?: 'APIKey';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  scope: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type Analytics = {
  __typename?: 'Analytics';
  analyticsId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dataset: Scalars['String']['output'];
  datasetId: Scalars['String']['output'];
  result?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type AnalyticsFilter = {
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  status?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type AnalyticsLog = {
  __typename?: 'AnalyticsLog';
  analyticsId: Scalars['String']['output'];
  datasetId: Scalars['String']['output'];
  log?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type AnalyticsSearchDetail = {
  __typename?: 'AnalyticsSearchDetail';
  status?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type Annotation = {
  __typename?: 'Annotation';
  annotationId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasetId: Scalars['String']['output'];
  format: Scalars['String']['output'];
  map?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type AnnotationFilter = {
  datasets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  status?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type AnnotationLog = {
  __typename?: 'AnnotationLog';
  annotationId: Scalars['String']['output'];
  datasetId: Scalars['String']['output'];
  log?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type AnnotationMap = {
  __typename?: 'AnnotationMap';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  mapId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AnnotationMapFilter = {
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type AnnotationMapSearchDetail = {
  __typename?: 'AnnotationMapSearchDetail';
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type AnnotationSearchDetail = {
  __typename?: 'AnnotationSearchDetail';
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type Banner = {
  __typename?: 'Banner';
  bannerColor?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
};

export type Channel = {
  __typename?: 'Channel';
  channelId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  documentation?: Maybe<Scalars['Boolean']['output']>;
  instanceType?: Maybe<Scalars['String']['output']>;
  interfaceVersion?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  /** @deprecated Support for organizations has ended, please upgrade your client. */
  organizations?: Maybe<Array<Maybe<ChannelOrganization>>>;
  /** @deprecated Support for preview parameter has ended, please remove from your client. */
  preview?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timeavg?: Maybe<Scalars['Int']['output']>;
  timeout?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  volumes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ChannelDeployment = {
  __typename?: 'ChannelDeployment';
  channelId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  deploymentId: Scalars['String']['output'];
  status: ChannelDeploymentStatus;
  updatedAt: Scalars['String']['output'];
};

export type ChannelDeploymentStatus = {
  __typename?: 'ChannelDeploymentStatus';
  message: Scalars['String']['output'];
  state: Scalars['String']['output'];
  step: Scalars['String']['output'];
};

export type ChannelDocumentationUpload = {
  __typename?: 'ChannelDocumentationUpload';
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ChannelFilter = {
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type ChannelOrganization = {
  __typename?: 'ChannelOrganization';
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type ChannelSearchDetail = {
  __typename?: 'ChannelSearchDetail';
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type ContentCode = {
  __typename?: 'ContentCode';
  code: Scalars['String']['output'];
  contactUs: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type Dataset = {
  __typename?: 'Dataset';
  annotations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  channel?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['String']['output']>;
  classes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Support for count has ended, please upgrade your client */
  count?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Support for datasetid has ended, please upgrade your client */
  datasetid?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Scalars['Int']['output']>;
  graph?: Maybe<Scalars['String']['output']>;
  graphId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  runs?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Support for scenarios has ended, please upgrade your client */
  scenarios?: Maybe<Scalars['String']['output']>;
  seed?: Maybe<Scalars['String']['output']>;
  services?: Maybe<MicroserviceSupport>;
  size?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** @deprecated Support for user has ended, please upgrade your client */
  user?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type DatasetFilter = {
  channels?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  graphs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  runs?: InputMaybe<Array<InputMaybe<IntComparator>>>;
  size?: InputMaybe<Array<InputMaybe<FloatComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type DatasetJob = {
  __typename?: 'DatasetJob';
  averageRuntime?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  estimatedEndAt?: Maybe<Scalars['String']['output']>;
  graph?: Maybe<Scalars['String']['output']>;
  graphId?: Maybe<Scalars['String']['output']>;
  instancesQueued?: Maybe<Scalars['Int']['output']>;
  instancesRunning?: Maybe<Scalars['Int']['output']>;
  instancesStarting?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  runs?: Maybe<Scalars['Int']['output']>;
  runsCancelled?: Maybe<Scalars['Int']['output']>;
  runsFailed?: Maybe<Scalars['Int']['output']>;
  runsQueued?: Maybe<Scalars['Int']['output']>;
  runsRunning?: Maybe<Scalars['Int']['output']>;
  runsStarting?: Maybe<Scalars['Int']['output']>;
  runsSuccess?: Maybe<Scalars['Int']['output']>;
  runsTimeout?: Maybe<Scalars['Int']['output']>;
  seed?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type DatasetJobFilter = {
  channels?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  graphs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  runs?: InputMaybe<Array<InputMaybe<IntComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type DatasetJobSearchDetail = {
  __typename?: 'DatasetJobSearchDetail';
  channels?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  type?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type DatasetLog = {
  __typename?: 'DatasetLog';
  channelId?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  log?: Maybe<Scalars['String']['output']>;
  run?: Maybe<Scalars['Int']['output']>;
  runId?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type DatasetMetrics = {
  __typename?: 'DatasetMetrics';
  channelId?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<Scalars['String']['output']>;
  run?: Maybe<Scalars['Int']['output']>;
  runId?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type DatasetRun = {
  __typename?: 'DatasetRun';
  channelId?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  run?: Maybe<Scalars['Int']['output']>;
  runId?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type DatasetSearchDetail = {
  __typename?: 'DatasetSearchDetail';
  channels?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  type?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type DateComparator = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteRemoteSessionResponse = {
  __typename?: 'DeleteRemoteSessionResponse';
  editorSessionId: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<RemoteDevelopmentStatus>;
};

export type ECRDeployment = {
  __typename?: 'ECRDeployment';
  deploymentId: Scalars['String']['output'];
  ecrEndpoint: Scalars['String']['output'];
  ecrPassword: Scalars['String']['output'];
};

export type ExactComparator = {
  eq?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
};

export type Feedback = {
  __typename?: 'Feedback';
  feedbackId: Scalars['String']['output'];
  uploads?: Maybe<Array<Maybe<FeedbackUpload>>>;
};

export type FeedbackUpload = {
  __typename?: 'FeedbackUpload';
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FloatComparator = {
  gte?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

export type GANDataset = {
  __typename?: 'GANDataset';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  datasetId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parentId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type GANDatasetLog = {
  __typename?: 'GANDatasetLog';
  datasetId: Scalars['String']['output'];
  log?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type GANModel = {
  __typename?: 'GANModel';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type GANModelFilter = {
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type GANModelSearchDetail = {
  __typename?: 'GANModelSearchDetail';
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type Graph = {
  __typename?: 'Graph';
  channel: Scalars['String']['output'];
  channelId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  graphId: Scalars['String']['output'];
  /** @deprecated Support for graphid has ended, please upgrade your client */
  graphid?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  previewId?: Maybe<Scalars['String']['output']>;
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  showPreview?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** @deprecated Support for user has ended, please upgrade your client */
  user?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type GraphFilter = {
  channels?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type GraphSearchDetail = {
  __typename?: 'GraphSearchDetail';
  channels?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type GraphUpdateReponse = {
  __typename?: 'GraphUpdateReponse';
  description?: Maybe<Scalars['String']['output']>;
  graph?: Maybe<Scalars['String']['output']>;
  graphId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  showPreview?: Maybe<Scalars['Boolean']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type GraphValidationError = {
  __typename?: 'GraphValidationError';
  errorMessage?: Maybe<Scalars['String']['output']>;
  input?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Hyperparameter = {
  __typename?: 'Hyperparameter';
  default?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  step?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type ImageInference = {
  __typename?: 'ImageInference';
  dataset?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  inferenceId?: Maybe<Scalars['String']['output']>;
  inferences?: Maybe<Array<Maybe<Inference>>>;
  model?: Maybe<Scalars['String']['output']>;
  modelId?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type Inference = {
  __typename?: 'Inference';
  bbox?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  class?: Maybe<Scalars['Int']['output']>;
  className?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['String']['output']>;
};

export type Inpaint = {
  __typename?: 'Inpaint';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  dilation?: Maybe<Scalars['Int']['output']>;
  inpaintId: Scalars['String']['output'];
  inputType?: Maybe<InpaintInputType>;
  location: Scalars['String']['output'];
  outputType?: Maybe<InpaintOutputType>;
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  volumeId: Scalars['String']['output'];
};

export type InpaintFormat = {
  __typename?: 'InpaintFormat';
  info?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum InpaintInputType {
  COCO = 'COCO',
  GEOJSON = 'GEOJSON',
  KITTI = 'KITTI',
  MASK = 'MASK',
  PASCAL = 'PASCAL',
  YOLO = 'YOLO'
}

export type InpaintLog = {
  __typename?: 'InpaintLog';
  inpaintId: Scalars['String']['output'];
  log?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  volumeId: Scalars['String']['output'];
};

export enum InpaintOutputType {
  JPG = 'JPG',
  PNG = 'PNG',
  SATRGB_BACKGROUND = 'SATRGB_BACKGROUND'
}

export type IntComparator = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
};

export type Invitation = {
  __typename?: 'Invitation';
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  role?: Maybe<RoleType>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type LLMChannelNodeTypes = {
  __typename?: 'LLMChannelNodeTypes';
  baseChannel: Scalars['String']['output'];
  nodeTypes?: Maybe<Array<Scalars['String']['output']>>;
};

export type LLMResponse = {
  __typename?: 'LLMResponse';
  baseChannel: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  nodeName: Scalars['String']['output'];
  nodeResponse?: Maybe<Scalars['String']['output']>;
  nodeType: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  promptId: Scalars['String']['output'];
  schemaResponse?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type LinkedApp = {
  __typename?: 'LinkedApp';
  appId: Scalars['String']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  linked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type MLArchitecture = {
  __typename?: 'MLArchitecture';
  annotations?: Maybe<Scalars['String']['output']>;
  architectureId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hyperparameters?: Maybe<Array<Maybe<Hyperparameter>>>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MLInference = {
  __typename?: 'MLInference';
  architecture?: Maybe<Scalars['String']['output']>;
  architectureId?: Maybe<Scalars['String']['output']>;
  architectureType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dataset: Scalars['String']['output'];
  datasetId: Scalars['String']['output'];
  inferenceId: Scalars['String']['output'];
  map?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type MLInferenceFilter = {
  architectures?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type MLInferenceLog = {
  __typename?: 'MLInferenceLog';
  inferenceId: Scalars['String']['output'];
  log?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type MLInferenceSearchDetail = {
  __typename?: 'MLInferenceSearchDetail';
  architectures?: Maybe<Array<Maybe<SearchDetail>>>;
  status?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type MLModel = {
  __typename?: 'MLModel';
  architecture: Scalars['String']['output'];
  architectureId: Scalars['String']['output'];
  architectureType?: Maybe<Scalars['String']['output']>;
  checkpoints?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  classes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dataset: Scalars['String']['output'];
  datasetId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  map?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parameters?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type MLModelFilter = {
  architectures?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type MLModelLog = {
  __typename?: 'MLModelLog';
  log?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type MLModelSearchDetail = {
  __typename?: 'MLModelSearchDetail';
  architectures?: Maybe<Array<Maybe<SearchDetail>>>;
  status?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type MapData = {
  __typename?: 'MapData';
  fields?: Maybe<UploadFields>;
  key?: Maybe<Scalars['String']['output']>;
  mapId: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type Member = {
  __typename?: 'Member';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  role: RoleType;
  userId: Scalars['String']['output'];
};

export type MicroserviceSupport = {
  __typename?: 'MicroserviceSupport';
  analytics?: Maybe<Scalars['Boolean']['output']>;
  annotations?: Maybe<Scalars['Boolean']['output']>;
  gan?: Maybe<Scalars['Boolean']['output']>;
  inference?: Maybe<Scalars['Boolean']['output']>;
  training?: Maybe<Scalars['Boolean']['output']>;
  umap?: Maybe<Scalars['Boolean']['output']>;
};

export type MultipartInput = {
  eTag: Scalars['String']['input'];
  partNumber: Scalars['Int']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addMember?: Maybe<Scalars['Boolean']['output']>;
  clearDatasetJobs?: Maybe<Scalars['Boolean']['output']>;
  createAPIKey: Scalars['String']['output'];
  createAnalytics: Scalars['String']['output'];
  createAnnotation: Scalars['String']['output'];
  createChannel: Scalars['String']['output'];
  createDataset?: Maybe<Scalars['String']['output']>;
  createFeedback: Feedback;
  createGANDataset: Scalars['String']['output'];
  /** @deprecated Support for createGraph has ended, please upgrade your client */
  createGraph: Scalars['String']['output'];
  createInpaint: Scalars['String']['output'];
  createLLMPrompt: Scalars['String']['output'];
  createMLInference: Scalars['String']['output'];
  createMLModel: Scalars['String']['output'];
  /** @deprecated Support for createManagedChannel has ended, please upgrade your client. */
  createManagedChannel: Scalars['String']['output'];
  /** @deprecated Support for createManagedGANV2 has ended, please upgrade your client. */
  createManagedGANV2: UploadGANResponse;
  /** @deprecated Support for createManagedGANV2Finalizer has ended, please upgrade your client. */
  createManagedGANV2Finalizer?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for createManagedMap has ended, please upgrade your client. */
  createManagedMap: MapData;
  /** @deprecated Support for createManagedVolume has ended, please upgrade your client. */
  createManagedVolume: Scalars['String']['output'];
  createMixedDataset: Scalars['String']['output'];
  createPreview: Scalars['String']['output'];
  createRemoteDevelopment: RemoteDevelopment;
  createSSHKey: Scalars['Boolean']['output'];
  createUMAP: Scalars['String']['output'];
  createVolume: Scalars['String']['output'];
  createWorkspace: Scalars['String']['output'];
  deleteAPIKey?: Maybe<Scalars['Boolean']['output']>;
  deleteAnalytics: Scalars['Boolean']['output'];
  deleteAnnotation: Scalars['Boolean']['output'];
  deleteAnnotationMap: Scalars['Boolean']['output'];
  deleteChannel?: Maybe<Scalars['Boolean']['output']>;
  deleteDataset?: Maybe<Scalars['Boolean']['output']>;
  deleteGANDataset?: Maybe<Scalars['Boolean']['output']>;
  deleteGANModel?: Maybe<Scalars['Boolean']['output']>;
  deleteGraph?: Maybe<Scalars['Boolean']['output']>;
  deleteInpaint: Scalars['Boolean']['output'];
  deleteLLMPrompt: Scalars['Boolean']['output'];
  deleteMLInference: Scalars['Boolean']['output'];
  deleteMLModel: Scalars['Boolean']['output'];
  /** @deprecated Support for deleteManagedChannel has ended, please upgrade your client. */
  deleteManagedChannel?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for deleteManagedGAN has ended, please upgrade your client. */
  deleteManagedGAN?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for deleteManagedMap has ended, please upgrade your client. */
  deleteManagedMap: Scalars['Boolean']['output'];
  /** @deprecated Support for deleteManagedVolume has ended, please upgrade your client. */
  deleteManagedVolume?: Maybe<Scalars['Boolean']['output']>;
  deleteOrganization?: Maybe<Scalars['Boolean']['output']>;
  deletePreview?: Maybe<Scalars['Boolean']['output']>;
  deleteRemoteDevelopment: DeleteRemoteSessionResponse;
  deleteSSHKey: Scalars['Boolean']['output'];
  deleteUMAP: Scalars['Boolean']['output'];
  deleteUser?: Maybe<Array<Maybe<OrganizationAdmin>>>;
  deleteVolume?: Maybe<Scalars['Boolean']['output']>;
  deleteVolumeData: Array<Maybe<Scalars['String']['output']>>;
  deleteWorkspace: Scalars['String']['output'];
  deployChannel: ECRDeployment;
  /** @deprecated Support for deployManagedChannel has ended, please upgrade your client. */
  deployManagedChannel: ECRDeployment;
  downloadAnnotation: Scalars['String']['output'];
  downloadAnnotationMap: Scalars['String']['output'];
  downloadDataset?: Maybe<Scalars['String']['output']>;
  downloadGANModel: Scalars['String']['output'];
  downloadGraph?: Maybe<Scalars['String']['output']>;
  downloadMLInference: Scalars['String']['output'];
  downloadMLModel: Scalars['String']['output'];
  /** @deprecated Support for downloadManagedGAN has ended, please upgrade your client. */
  downloadManagedGAN: Scalars['String']['output'];
  /** @deprecated Support for downloadManagedMap has ended, please upgrade your client. */
  downloadManagedMap: Scalars['String']['output'];
  duplicateGraph?: Maybe<Scalars['String']['output']>;
  editAnalytics: Scalars['Boolean']['output'];
  editAnnotation: Scalars['Boolean']['output'];
  editAnnotationMap: Scalars['Boolean']['output'];
  editChannel?: Maybe<Scalars['Boolean']['output']>;
  editDataset?: Maybe<Scalars['Boolean']['output']>;
  editDefaultGraph?: Maybe<Scalars['Boolean']['output']>;
  editGANModel?: Maybe<Scalars['Boolean']['output']>;
  editGraph?: Maybe<Scalars['Boolean']['output']>;
  editMLInference: Scalars['Boolean']['output'];
  editMLModel: Scalars['Boolean']['output'];
  /** @deprecated Support for editManagedChannel has ended, please upgrade your client. */
  editManagedChannel?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for editManagedGAN has ended, please upgrade your client. */
  editManagedGAN?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for editManagedMap has ended, please upgrade your client. */
  editManagedMap: Scalars['Boolean']['output'];
  /** @deprecated Support for editManagedVolume has ended, please upgrade your client. */
  editManagedVolume?: Maybe<Scalars['Boolean']['output']>;
  editMember?: Maybe<Scalars['Boolean']['output']>;
  editOrganization?: Maybe<Scalars['Boolean']['output']>;
  editUMAP: Scalars['Boolean']['output'];
  editUser?: Maybe<Scalars['Boolean']['output']>;
  editVolume?: Maybe<Scalars['Boolean']['output']>;
  editVolumeData?: Maybe<Scalars['Boolean']['output']>;
  editWorkspace: Scalars['String']['output'];
  editWorkspaceThumbnail: Scalars['String']['output'];
  initializeUser?: Maybe<Scalars['Boolean']['output']>;
  inviteRemoteDevelopment: Scalars['Boolean']['output'];
  mountVolumes?: Maybe<VolumeCredentials>;
  mountWorkspaces?: Maybe<WorkspaceCredentials>;
  pingPreview?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for putVolumeDataV2 has ended, please upgrade your client. */
  putVolumeDataV2: UploadVolumeDataResponse;
  /** @deprecated Support for putVolumeDataV2Finalizer has ended, please upgrade your client. */
  putVolumeDataV2Finalizer?: Maybe<Scalars['Boolean']['output']>;
  removeMember?: Maybe<Scalars['Boolean']['output']>;
  setChannelGraph?: Maybe<Scalars['Boolean']['output']>;
  signIn?: Maybe<UserCredentials>;
  startRemoteDevelopment: UpdatedRemoteDevelopmentResponse;
  stopRemoteDevelopment: UpdatedRemoteDevelopmentResponse;
  uploadAnnotationMap: UploadAnnotationMapResponse;
  uploadAnnotationMapFinalizer: Scalars['Boolean']['output'];
  uploadChannelDocumentation?: Maybe<Array<Maybe<ChannelDocumentationUpload>>>;
  uploadDataset: UploadDatasetResponse;
  uploadDatasetFinalizer?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for uploadDatasetV2 has ended, please upgrade your client. */
  uploadDatasetV2: UploadDatasetResponse;
  /** @deprecated Support for uploadDatasetV2Finalizer has ended, please upgrade your client. */
  uploadDatasetV2Finalizer?: Maybe<Scalars['Boolean']['output']>;
  uploadGANModel: UploadGANResponse;
  uploadGANModelFinalizer?: Maybe<Scalars['Boolean']['output']>;
  uploadGraph: Scalars['String']['output'];
  uploadMLModel: UploadMLModelResponse;
  uploadMLModelFinalizer?: Maybe<Scalars['Boolean']['output']>;
  uploadVolumeData: UploadVolumeDataResponse;
  uploadVolumeDataFinalizer?: Maybe<Scalars['Boolean']['output']>;
  uploadVolumeDataThumbnail: UploadVolumeDataThumbnailResponse;
  validateGraph?: Maybe<Array<Maybe<GraphValidationError>>>;
};


export type MutationaddMemberArgs = {
  email: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};


export type MutationclearDatasetJobsArgs = {
  datasetId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreateAPIKeyArgs = {
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreateAnalyticsArgs = {
  datasetId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationcreateAnnotationArgs = {
  datasetId: Scalars['String']['input'];
  format: Scalars['String']['input'];
  mapId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationcreateChannelArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  instance?: InputMaybe<Scalars['String']['input']>;
  interfaceVersion?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationcreateDatasetArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  graphId: Scalars['String']['input'];
  instanceType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  runs?: InputMaybe<Scalars['Int']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationcreateFeedbackArgs = {
  description: Scalars['String']['input'];
  files: Array<InputMaybe<Scalars['String']['input']>>;
  summary: Scalars['String']['input'];
};


export type MutationcreateGANDatasetArgs = {
  datasetId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationcreateGraphArgs = {
  channelId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  graph: Scalars['String']['input'];
  name: Scalars['String']['input'];
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationcreateInpaintArgs = {
  destination?: InputMaybe<Scalars['String']['input']>;
  dilation?: InputMaybe<Scalars['Int']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inputType?: InputMaybe<InpaintInputType>;
  location: Scalars['String']['input'];
  outputType?: InputMaybe<InpaintOutputType>;
  volumeId: Scalars['String']['input'];
};


export type MutationcreateLLMPromptArgs = {
  baseChannel: Scalars['String']['input'];
  nodeName: Scalars['String']['input'];
  nodeType: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};


export type MutationcreateMLInferenceArgs = {
  datasetId: Scalars['String']['input'];
  mapId?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationcreateMLModelArgs = {
  architectureId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationcreateManagedChannelArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  instance?: InputMaybe<Scalars['String']['input']>;
  interfaceVersion?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationcreateManagedGANV2Args = {
  description?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationcreateManagedGANV2FinalizerArgs = {
  key: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreateManagedMapArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationcreateManagedVolumeArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  permission?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationcreateMixedDatasetArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parameters: Scalars['String']['input'];
  seed?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationcreatePreviewArgs = {
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationcreateRemoteDevelopmentArgs = {
  channelId: Scalars['String']['input'];
  channelVersion?: InputMaybe<Scalars['String']['input']>;
  instanceType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationcreateSSHKeyArgs = {
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationcreateUMAPArgs = {
  datasetIds: Array<InputMaybe<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  samples: Array<InputMaybe<Scalars['Int']['input']>>;
  seed?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationcreateVolumeArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  permission?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationcreateWorkspaceArgs = {
  channelIds: Array<InputMaybe<Scalars['String']['input']>>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationdeleteAPIKeyArgs = {
  name: Scalars['String']['input'];
};


export type MutationdeleteAnalyticsArgs = {
  analyticsId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdeleteAnnotationArgs = {
  annotationId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdeleteAnnotationMapArgs = {
  mapId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationdeleteChannelArgs = {
  channelId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationdeleteDatasetArgs = {
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdeleteGANDatasetArgs = {
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdeleteGANModelArgs = {
  modelId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationdeleteGraphArgs = {
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdeleteInpaintArgs = {
  inpaintId: Scalars['String']['input'];
  volumeId: Scalars['String']['input'];
};


export type MutationdeleteLLMPromptArgs = {
  promptId: Scalars['String']['input'];
};


export type MutationdeleteMLInferenceArgs = {
  inferenceId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdeleteMLModelArgs = {
  modelId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdeleteManagedChannelArgs = {
  channelId: Scalars['String']['input'];
};


export type MutationdeleteManagedGANArgs = {
  modelId: Scalars['String']['input'];
};


export type MutationdeleteManagedMapArgs = {
  mapId: Scalars['String']['input'];
};


export type MutationdeleteManagedVolumeArgs = {
  volumeId: Scalars['String']['input'];
};


export type MutationdeleteOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationdeletePreviewArgs = {
  previewId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdeleteRemoteDevelopmentArgs = {
  editorSessionId: Scalars['String']['input'];
};


export type MutationdeleteSSHKeyArgs = {
  name: Scalars['String']['input'];
};


export type MutationdeleteUMAPArgs = {
  umapId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdeleteUserArgs = {
  isDeleting?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationdeleteVolumeArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  volumeId: Scalars['String']['input'];
};


export type MutationdeleteVolumeDataArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId: Scalars['String']['input'];
};


export type MutationdeleteWorkspaceArgs = {
  workspaceId: Scalars['String']['input'];
};


export type MutationdeployChannelArgs = {
  alias?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['String']['input'];
  interface?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationdeployManagedChannelArgs = {
  alias?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['String']['input'];
  interface?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationdownloadAnnotationArgs = {
  annotationId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdownloadAnnotationMapArgs = {
  mapId: Scalars['String']['input'];
};


export type MutationdownloadDatasetArgs = {
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdownloadGANModelArgs = {
  modelId: Scalars['String']['input'];
};


export type MutationdownloadGraphArgs = {
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdownloadMLInferenceArgs = {
  inferenceId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdownloadMLModelArgs = {
  checkpoint?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationdownloadManagedGANArgs = {
  modelId: Scalars['String']['input'];
};


export type MutationdownloadManagedMapArgs = {
  mapId: Scalars['String']['input'];
};


export type MutationduplicateGraphArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  graphId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationeditAnalyticsArgs = {
  analyticsId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationeditAnnotationArgs = {
  annotationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationeditAnnotationMapArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  mapId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationeditChannelArgs = {
  channelId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  instance?: InputMaybe<Scalars['String']['input']>;
  interfaceVersion?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationeditDatasetArgs = {
  datasetId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  showJob?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationeditDefaultGraphArgs = {
  channelId: Scalars['String']['input'];
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationeditGANModelArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationeditGraphArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  graph?: InputMaybe<Scalars['String']['input']>;
  graphId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationeditMLInferenceArgs = {
  inferenceId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationeditMLModelArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationeditManagedChannelArgs = {
  channelId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  instance?: InputMaybe<Scalars['String']['input']>;
  interfaceVersion?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationeditManagedGANArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationeditManagedMapArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  mapId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationeditManagedVolumeArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId: Scalars['String']['input'];
};


export type MutationeditMemberArgs = {
  email: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
};


export type MutationeditOrganizationArgs = {
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationeditUMAPArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  umapId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationeditUserArgs = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationeditVolumeArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId: Scalars['String']['input'];
};


export type MutationeditVolumeDataArgs = {
  key: Scalars['String']['input'];
  source: Scalars['String']['input'];
  volumeId: Scalars['String']['input'];
};


export type MutationeditWorkspaceArgs = {
  channelIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  ganIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mapIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationeditWorkspaceThumbnailArgs = {
  thumbnail: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationinitializeUserArgs = {
  email: Scalars['String']['input'];
};


export type MutationinviteRemoteDevelopmentArgs = {
  editorSessionId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationmountVolumesArgs = {
  volumes: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationmountWorkspacesArgs = {
  workspaces: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationpingPreviewArgs = {
  channelId: Scalars['String']['input'];
};


export type MutationputVolumeDataV2Args = {
  key: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  volumeId: Scalars['String']['input'];
};


export type MutationputVolumeDataV2FinalizerArgs = {
  key: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
  volumeId: Scalars['String']['input'];
};


export type MutationremoveMemberArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsetChannelGraphArgs = {
  channelId: Scalars['String']['input'];
  graphId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type MutationsignInArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationstartRemoteDevelopmentArgs = {
  editorSessionId: Scalars['String']['input'];
};


export type MutationstopRemoteDevelopmentArgs = {
  editorSessionId: Scalars['String']['input'];
};


export type MutationuploadAnnotationMapArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationuploadAnnotationMapFinalizerArgs = {
  key: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId: Scalars['String']['input'];
};


export type MutationuploadChannelDocumentationArgs = {
  channelId: Scalars['String']['input'];
  keys: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationuploadDatasetArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationuploadDatasetFinalizerArgs = {
  key: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationuploadDatasetV2Args = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationuploadDatasetV2FinalizerArgs = {
  key: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type MutationuploadGANModelArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationuploadGANModelFinalizerArgs = {
  key: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationuploadGraphArgs = {
  channelId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  graph: Scalars['String']['input'];
  name: Scalars['String']['input'];
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationuploadMLModelArgs = {
  architectureId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Float']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationuploadMLModelFinalizerArgs = {
  key: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationuploadVolumeDataArgs = {
  key: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  volumeId: Scalars['String']['input'];
};


export type MutationuploadVolumeDataFinalizerArgs = {
  key: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationuploadVolumeDataThumbnailArgs = {
  key: Scalars['String']['input'];
  volumeId: Scalars['String']['input'];
};


export type MutationvalidateGraphArgs = {
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type NodeDocumentation = {
  __typename?: 'NodeDocumentation';
  documentation: Scalars['String']['output'];
  nodeClass: Scalars['String']['output'];
  preview?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type OldUMAP = {
  __typename?: 'OldUMAP';
  datasets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  results?: Maybe<OldUMAPResult>;
  samples?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  seed?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type OldUMAPDatasets = {
  __typename?: 'OldUMAPDatasets';
  datasetId?: Maybe<Scalars['String']['output']>;
  datasetName?: Maybe<Scalars['String']['output']>;
  points?: Maybe<OldUMAPPoints>;
};

export type OldUMAPPoints = {
  __typename?: 'OldUMAPPoints';
  image?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['String']['output']>;
  y?: Maybe<Scalars['String']['output']>;
  z?: Maybe<Scalars['String']['output']>;
};

export type OldUMAPResult = {
  __typename?: 'OldUMAPResult';
  datasets?: Maybe<OldUMAPDatasets>;
  featureSize?: Maybe<Scalars['String']['output']>;
  featuresize?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type Organization = {
  __typename?: 'Organization';
  expirationDate?: Maybe<Scalars['String']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  plan?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type OrganizationAdmin = {
  __typename?: 'OrganizationAdmin';
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
};

export type OrganizationSetting = {
  __typename?: 'OrganizationSetting';
  limit: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  setting: Scalars['String']['output'];
  units: Scalars['String']['output'];
  usage: Scalars['Float']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalItems: Scalars['Int']['output'];
};

export type PlatformSetting = {
  __typename?: 'PlatformSetting';
  setting?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Preview = {
  __typename?: 'Preview';
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  graphId: Scalars['String']['output'];
  previewId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type PreviewLog = {
  __typename?: 'PreviewLog';
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  graphId: Scalars['String']['output'];
  log?: Maybe<Scalars['String']['output']>;
  previewId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  getAPIKeyContext: APIKey;
  getAPIKeys: Array<Maybe<APIKey>>;
  getAnalytics: Array<Maybe<Analytics>>;
  getAnalyticsLog: AnalyticsLog;
  getAnalyticsSearchDetail: AnalyticsSearchDetail;
  getAnalyticsTypes: Array<Maybe<Scalars['String']['output']>>;
  getAnnotationFormats?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getAnnotationLog: AnnotationLog;
  getAnnotationMaps: Array<Maybe<AnnotationMap>>;
  getAnnotationMapsSearchDetail: AnnotationMapSearchDetail;
  getAnnotations: Array<Maybe<Annotation>>;
  getAnnotationsSearchDetail: AnnotationSearchDetail;
  getBanner: Banner;
  getChannelDeployment?: Maybe<ChannelDeployment>;
  getChannelDocumentation: Scalars['String']['output'];
  getChannelSchema: Scalars['String']['output'];
  getChannels?: Maybe<Array<Maybe<Channel>>>;
  getChannelsSearchDetail?: Maybe<ChannelSearchDetail>;
  getContentCodes?: Maybe<Array<Maybe<ContentCode>>>;
  getCurrentUser?: Maybe<User>;
  getDatasetDirectories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getDatasetFiles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getDatasetImage?: Maybe<RunData>;
  getDatasetJobs?: Maybe<Array<Maybe<DatasetJob>>>;
  getDatasetJobsSearchDetail?: Maybe<DatasetJobSearchDetail>;
  getDatasetLog?: Maybe<DatasetLog>;
  getDatasetMetrics?: Maybe<DatasetMetrics>;
  getDatasetRuns?: Maybe<Array<Maybe<DatasetRun>>>;
  getDatasetThumbnails: Array<Maybe<Scalars['String']['output']>>;
  getDatasets?: Maybe<Array<Maybe<Dataset>>>;
  getDatasetsSearchDetail?: Maybe<DatasetSearchDetail>;
  getDefaultGraph: Scalars['String']['output'];
  getGANDatasetLog: GANDatasetLog;
  getGANDatasets: Array<Maybe<GANDataset>>;
  getGANModels: Array<Maybe<GANModel>>;
  getGANModelsSearchDetail: GANModelSearchDetail;
  getGraphs?: Maybe<Array<Maybe<Graph>>>;
  getGraphsSearchDetail?: Maybe<GraphSearchDetail>;
  getImageAnnotation?: Maybe<RunData>;
  getImageInference: ImageInference;
  getImageMask?: Maybe<RunData>;
  getImageMetadata?: Maybe<RunData>;
  getInpaintFormats?: Maybe<Array<Maybe<InpaintFormat>>>;
  getInpaintLog: InpaintLog;
  getInpaints: Array<Maybe<Inpaint>>;
  getInvitations?: Maybe<Array<Maybe<Invitation>>>;
  getLLMBaseChannels: Array<Maybe<Scalars['String']['output']>>;
  getLLMChannelNodeTypes: Array<Maybe<LLMChannelNodeTypes>>;
  getLLMResponse: LLMResponse;
  getMLArchitectures?: Maybe<Array<Maybe<MLArchitecture>>>;
  getMLInferenceLog: MLInferenceLog;
  getMLInferenceMetrics: Scalars['String']['output'];
  getMLInferences: Array<Maybe<MLInference>>;
  getMLInferencesSearchDetail: MLInferenceSearchDetail;
  getMLModelLog: MLModelLog;
  getMLModels: Array<Maybe<MLModel>>;
  getMLModelsSearchDetail: MLModelSearchDetail;
  /** @deprecated Support for getManagedChannels has ended, please upgrade your client. */
  getManagedChannels: Array<Maybe<Channel>>;
  /** @deprecated Support for getManagedGANs has ended, please upgrade your client. */
  getManagedGANs: Array<Maybe<GANModel>>;
  /** @deprecated Support for getManagedVolumes has ended, please upgrade your client. */
  getManagedVolumes: Array<Maybe<Volume>>;
  getMembers?: Maybe<Array<Maybe<Member>>>;
  getNodeDocumentation: NodeDocumentation;
  getOrganizationSettings?: Maybe<Array<Maybe<OrganizationSetting>>>;
  getOrganizations: Array<Maybe<Organization>>;
  getPlatformSettings: Array<Maybe<PlatformSetting>>;
  getPreview?: Maybe<Preview>;
  getPreviewLog?: Maybe<PreviewLog>;
  getSDKCompatibility: SDKCompatibility;
  getSSHKeys: Array<Maybe<SSHKey>>;
  getUMAPLog?: Maybe<UMAPLog>;
  getUMAPPoint: UMAPImages;
  getUMAPs: Array<Maybe<UMAP>>;
  getUMAPsSearchDetail: UMAPSearchDetail;
  getVolumeData: getVolumeData;
  getVolumes?: Maybe<Array<Maybe<Volume>>>;
  getVolumesSearchDetail?: Maybe<VolumeSearchDetail>;
  getWorkspaceSettings?: Maybe<Array<Maybe<WorkspaceSetting>>>;
  getWorkspaces?: Maybe<Array<Maybe<Workspace>>>;
  getWorkspacesSearchDetail?: Maybe<WorkspaceSearchDetail>;
  helloAnalytics: Scalars['String']['output'];
  helloAnnotations: Scalars['String']['output'];
  helloCore: Scalars['String']['output'];
  helloGAN: Scalars['String']['output'];
  helloInpaint: Scalars['String']['output'];
  helloLLM: Scalars['String']['output'];
  helloUMAP: Scalars['String']['output'];
  listRemoteDevelopment: Array<Maybe<RemoteDevelopment>>;
  validateContentCode?: Maybe<Scalars['Boolean']['output']>;
};


export type QuerygetAPIKeyContextArgs = {
  apiKey: Scalars['String']['input'];
};


export type QuerygetAPIKeysArgs = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetAnalyticsArgs = {
  analyticsId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AnalyticsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetAnalyticsLogArgs = {
  analyticsId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetAnalyticsSearchDetailArgs = {
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AnalyticsFilter>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetAnnotationLogArgs = {
  annotationId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetAnnotationMapsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AnnotationMapFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mapId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetAnnotationMapsSearchDetailArgs = {
  filters?: InputMaybe<AnnotationMapFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetAnnotationsArgs = {
  annotationId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AnnotationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetAnnotationsSearchDetailArgs = {
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AnnotationFilter>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetChannelDeploymentArgs = {
  deploymentId: Scalars['String']['input'];
};


export type QuerygetChannelDocumentationArgs = {
  channelId: Scalars['String']['input'];
};


export type QuerygetChannelSchemaArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetChannelsArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ChannelFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetChannelsSearchDetailArgs = {
  filters?: InputMaybe<ChannelFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetDatasetDirectoriesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetDatasetFilesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetDatasetImageArgs = {
  datasetId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetDatasetJobsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<DatasetJobFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetDatasetJobsSearchDetailArgs = {
  filters?: InputMaybe<DatasetJobFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetDatasetLogArgs = {
  datasetId: Scalars['String']['input'];
  runId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetDatasetMetricsArgs = {
  datasetId: Scalars['String']['input'];
  runId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetDatasetRunsArgs = {
  datasetId: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetDatasetThumbnailsArgs = {
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetDatasetsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<DatasetFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetDatasetsSearchDetailArgs = {
  filters?: InputMaybe<DatasetFilter>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetDefaultGraphArgs = {
  channelId: Scalars['String']['input'];
};


export type QuerygetGANDatasetLogArgs = {
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetGANDatasetsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  gandatasetId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetGANModelsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<GANModelFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetGANModelsSearchDetailArgs = {
  filters?: InputMaybe<GANModelFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetGraphsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<GraphFilter>;
  graphId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetGraphsSearchDetailArgs = {
  filters?: InputMaybe<GraphFilter>;
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetImageAnnotationArgs = {
  datasetId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetImageInferenceArgs = {
  filename: Scalars['String']['input'];
  inferenceId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetImageMaskArgs = {
  datasetId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetImageMetadataArgs = {
  datasetId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetInpaintLogArgs = {
  inpaintId: Scalars['String']['input'];
  volumeId: Scalars['String']['input'];
};


export type QuerygetInpaintsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  inpaintId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  volumeId: Scalars['String']['input'];
};


export type QuerygetInvitationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetLLMResponseArgs = {
  promptId: Scalars['String']['input'];
};


export type QuerygetMLInferenceLogArgs = {
  inferenceId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetMLInferenceMetricsArgs = {
  inferenceId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetMLInferencesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MLInferenceFilter>;
  inferenceId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetMLInferencesSearchDetailArgs = {
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MLInferenceFilter>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetMLModelLogArgs = {
  modelId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetMLModelsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MLModelFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetMLModelsSearchDetailArgs = {
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MLModelFilter>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetManagedChannelsArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};


export type QuerygetManagedGANsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type QuerygetManagedVolumesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  volumeId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetMembersArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetNodeDocumentationArgs = {
  channelId: Scalars['String']['input'];
  nodeClass: Scalars['String']['input'];
};


export type QuerygetOrganizationSettingsArgs = {
  organizationId: Scalars['String']['input'];
  setting?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetOrganizationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetPreviewArgs = {
  previewId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetPreviewLogArgs = {
  previewId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetSDKCompatibilityArgs = {
  anatools: Scalars['String']['input'];
  os: Scalars['String']['input'];
  python: Scalars['String']['input'];
};


export type QuerygetUMAPLogArgs = {
  umapId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetUMAPPointArgs = {
  datasetId: Scalars['String']['input'];
  image: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QuerygetUMAPsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UMAPFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  umapId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetUMAPsSearchDetailArgs = {
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UMAPFilter>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetVolumeDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  dir?: InputMaybe<Scalars['String']['input']>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  recursive?: InputMaybe<Scalars['Boolean']['input']>;
  volumeId: Scalars['String']['input'];
};


export type QuerygetVolumesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<VolumeFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  volumeId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetVolumesSearchDetailArgs = {
  filters?: InputMaybe<VolumeFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetWorkspaceSettingsArgs = {
  setting?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QuerygetWorkspacesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<WorkspaceFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerygetWorkspacesSearchDetailArgs = {
  filters?: InputMaybe<WorkspaceFilter>;
  organizationId: Scalars['String']['input'];
};


export type QuerylistRemoteDevelopmentArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryvalidateContentCodeArgs = {
  code: Scalars['String']['input'];
};

export type RemoteDevelopment = {
  __typename?: 'RemoteDevelopment';
  channel: Scalars['String']['output'];
  channelId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  editorSessionId: Scalars['String']['output'];
  editorUrl: Scalars['String']['output'];
  instanceType?: Maybe<Scalars['String']['output']>;
  nodePortResponse?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  sshPort?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<RemoteDevelopmentStatus>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RemoteDevelopmentStatus = {
  __typename?: 'RemoteDevelopmentStatus';
  message?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  step?: Maybe<Scalars['Int']['output']>;
};

export enum RoleType {
  admin = 'admin',
  member = 'member'
}

export type RunData = {
  __typename?: 'RunData';
  data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  datasetId?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type SDKCompatibility = {
  __typename?: 'SDKCompatibility';
  message?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type SSHKey = {
  __typename?: 'SSHKey';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type SearchDetail = {
  __typename?: 'SearchDetail';
  display?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SessionCredentials = {
  __typename?: 'SessionCredentials';
  accesskey: Scalars['String']['output'];
  accesskeyid: Scalars['String']['output'];
  sessiontoken: Scalars['String']['output'];
};

export type Sort = {
  column: Scalars['String']['input'];
  direction: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  graphDeleted?: Maybe<Scalars['Boolean']['output']>;
  graphUpdates?: Maybe<GraphUpdateReponse>;
};


export type SubscriptiongraphDeletedArgs = {
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type SubscriptiongraphUpdatesArgs = {
  graphId: Scalars['String']['input'];
  uid?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};

export type UMAP = {
  __typename?: 'UMAP';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasets: Array<Maybe<UMAPDataset>>;
  name: Scalars['String']['output'];
  results?: Maybe<Scalars['String']['output']>;
  samples: Array<Maybe<Scalars['Int']['output']>>;
  seed: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  umapId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type UMAPDataset = {
  __typename?: 'UMAPDataset';
  dataset?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
};

export type UMAPFilter = {
  datasets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  status?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type UMAPImages = {
  __typename?: 'UMAPImages';
  heatmap4?: Maybe<Scalars['String']['output']>;
  heatmap8?: Maybe<Scalars['String']['output']>;
  heatmap16?: Maybe<Scalars['String']['output']>;
  heatmap32?: Maybe<Scalars['String']['output']>;
  heatmap64?: Maybe<Scalars['String']['output']>;
  image: Scalars['String']['output'];
};

export type UMAPLog = {
  __typename?: 'UMAPLog';
  log?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  umapId: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type UMAPPoints = {
  __typename?: 'UMAPPoints';
  image?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
  z?: Maybe<Scalars['Float']['output']>;
};

export type UMAPSearchDetail = {
  __typename?: 'UMAPSearchDetail';
  status?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type UpdatedRemoteDevelopmentResponse = {
  __typename?: 'UpdatedRemoteDevelopmentResponse';
  editorSessionId: Scalars['String']['output'];
  editorUrl: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<RemoteDevelopmentStatus>;
};

export type UploadAnnotationMapResponse = {
  __typename?: 'UploadAnnotationMapResponse';
  key: Scalars['String']['output'];
  mapId: Scalars['String']['output'];
  partSize?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
  urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadDatasetResponse = {
  __typename?: 'UploadDatasetResponse';
  datasetId: Scalars['String']['output'];
  key: Scalars['String']['output'];
  partSize?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
  urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadFields = {
  __typename?: 'UploadFields';
  algorithm?: Maybe<Scalars['String']['output']>;
  bucket?: Maybe<Scalars['String']['output']>;
  credential?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type UploadGANResponse = {
  __typename?: 'UploadGANResponse';
  key: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  partSize?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
  urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadMLModelResponse = {
  __typename?: 'UploadMLModelResponse';
  key: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  partSize?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
  urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadVolumeDataResponse = {
  __typename?: 'UploadVolumeDataResponse';
  key: Scalars['String']['output'];
  partSize?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
  urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  volumeId: Scalars['String']['output'];
};

export type UploadVolumeDataThumbnailResponse = {
  __typename?: 'UploadVolumeDataThumbnailResponse';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type UserCredentials = {
  __typename?: 'UserCredentials';
  expires: Scalars['Int']['output'];
  idtoken: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type Volume = {
  __typename?: 'Volume';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  /** @deprecated Support for organizations has ended, please upgrade your client. */
  organizations?: Maybe<Array<Maybe<VolumeOrganization>>>;
  permission: Scalars['String']['output'];
  size?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  volumeId: Scalars['String']['output'];
};

export type VolumeCredentials = {
  __typename?: 'VolumeCredentials';
  credentials: SessionCredentials;
  keys: Array<Maybe<Scalars['String']['output']>>;
  rw: Array<Maybe<Scalars['String']['output']>>;
};

export type VolumeData = {
  __typename?: 'VolumeData';
  hash?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type VolumeFilter = {
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type VolumeOrganization = {
  __typename?: 'VolumeOrganization';
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type VolumeSearchDetail = {
  __typename?: 'VolumeSearchDetail';
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type Workspace = {
  __typename?: 'Workspace';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organization?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  previewThumbnail?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type WorkspaceCredentials = {
  __typename?: 'WorkspaceCredentials';
  credentials: SessionCredentials;
  keys: Array<Maybe<Scalars['String']['output']>>;
  rw: Array<Maybe<Scalars['String']['output']>>;
};

export type WorkspaceFilter = {
  channels?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type WorkspaceSearchDetail = {
  __typename?: 'WorkspaceSearchDetail';
  channels?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type WorkspaceSetting = {
  __typename?: 'WorkspaceSetting';
  limit: Scalars['String']['output'];
  setting: Scalars['String']['output'];
  units: Scalars['String']['output'];
  usage: Scalars['Float']['output'];
  workspaceId: Scalars['String']['output'];
};

export type getVolumeData = {
  __typename?: 'getVolumeData';
  keys: Array<Maybe<VolumeData>>;
  pageInfo: PageInfo;
};

export type GetWorkspaceSelectionDataQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceSelectionDataQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', name: string, organizationId: string, workspaceId: string } | null> | null };

export type GetAnalyticsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  analyticsId: Scalars['String']['input'];
}>;


export type GetAnalyticsQuery = { __typename?: 'Query', getAnalytics: Array<{ __typename?: 'Analytics', result?: string | null } | null> };

export type GetAnalyticsTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnalyticsTypesQuery = { __typename?: 'Query', getAnalyticsTypes: Array<string | null> };

export type GetAnalyticsLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  analyticsId: Scalars['String']['input'];
}>;


export type GetAnalyticsLogQuery = { __typename?: 'Query', getAnalyticsLog: { __typename?: 'AnalyticsLog', log?: string | null } };

export type GetAnnotationFormatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnnotationFormatsQuery = { __typename?: 'Query', getAnnotationFormats?: Array<string | null> | null };

export type GetAnnotationMapsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  mapId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<AnnotationMapFilter>;
}>;


export type GetAnnotationMapsQuery = { __typename?: 'Query', getAnnotationMaps: Array<{ __typename?: 'AnnotationMap', description?: string | null, mapId: string, name: string, organization: string, createdAt?: string | null, organizationId: string, updatedAt?: string | null, tags?: Array<string | null> | null } | null> };

export type GetAnnotationLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  annotationId: Scalars['String']['input'];
}>;


export type GetAnnotationLogQuery = { __typename?: 'Query', getAnnotationLog: { __typename?: 'AnnotationLog', log?: string | null } };

export type GetChannelDocumentationQueryVariables = Exact<{
  channelId: Scalars['String']['input'];
}>;


export type GetChannelDocumentationQuery = { __typename?: 'Query', getChannelDocumentation: string };

export type GetChannelNodeDocumentationQueryVariables = Exact<{
  channelId: Scalars['String']['input'];
  nodeClass: Scalars['String']['input'];
}>;


export type GetChannelNodeDocumentationQuery = { __typename?: 'Query', getNodeDocumentation: { __typename?: 'NodeDocumentation', documentation: string, preview?: string | null, thumbnail?: string | null } };

export type GetDatasetRunsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetRunsQuery = { __typename?: 'Query', getDatasetRuns?: Array<{ __typename?: 'DatasetRun', runId?: string | null, workspaceId?: string | null, datasetId?: string | null, channelId?: string | null, startTime?: string | null, endTime?: string | null, state?: string | null, run?: number | null } | null> | null, getDatasetJobs?: Array<{ __typename?: 'DatasetJob', datasetId?: string | null, name?: string | null } | null> | null };

export type GetDatasetLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  runId: Scalars['String']['input'];
}>;


export type GetDatasetLogQuery = { __typename?: 'Query', getDatasetLog?: { __typename?: 'DatasetLog', log?: string | null } | null };

export type GetDatasetImageQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
}>;


export type GetDatasetImageQuery = { __typename?: 'Query', getDatasetImage?: { __typename?: 'RunData', data?: Array<string | null> | null } | null };

export type GetDatasetQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetQuery = { __typename?: 'Query', getDatasets?: Array<{ __typename?: 'Dataset', datasetId?: string | null, files?: number | null, name: string, runs?: number | null } | null> | null };

export type GetWorkspaceDatasetsListQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetWorkspaceDatasetsListQuery = { __typename?: 'Query', getDatasets?: Array<{ __typename?: 'Dataset', datasetId?: string | null, name: string } | null> | null };

export type GetGANModelsQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<GANModelFilter>;
}>;


export type GetGANModelsQuery = { __typename?: 'Query', getGANModels: Array<{ __typename?: 'GANModel', organizationId: string, modelId: string, description?: string | null, flags?: string | null, name: string, organization: string, createdAt?: string | null, updatedAt?: string | null, tags?: Array<string | null> | null } | null> };

export type GetGANDatasetLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
}>;


export type GetGANDatasetLogQuery = { __typename?: 'Query', getGANDatasetLog: { __typename?: 'GANDatasetLog', log?: string | null } };

export type GetInpaintFormatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInpaintFormatsQuery = { __typename?: 'Query', getInpaintFormats?: Array<{ __typename?: 'InpaintFormat', name: string, value: string, info?: string | null } | null> | null };

export type GetInpaintsQueryVariables = Exact<{
  volumeId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetInpaintsQuery = { __typename?: 'Query', getInpaints: Array<{ __typename?: 'Inpaint', volumeId: string, inpaintId: string, status: string, location: string, destination?: string | null, inputType?: InpaintInputType | null, outputType?: InpaintOutputType | null, dilation?: number | null, createdBy?: string | null, createdAt?: string | null, updatedBy?: string | null, updatedAt?: string | null } | null> };

export type GetInpaintLogQueryVariables = Exact<{
  volumeId: Scalars['String']['input'];
  inpaintId: Scalars['String']['input'];
}>;


export type GetInpaintLogQuery = { __typename?: 'Query', getInpaintLog: { __typename?: 'InpaintLog', log?: string | null } };

export type GetInvitationsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetInvitationsQuery = { __typename?: 'Query', getInvitations?: Array<{ __typename?: 'Invitation', email?: string | null, organizationId?: string | null, role?: RoleType | null, updatedAt?: string | null } | null> | null };

export type GetMembersQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMembersQuery = { __typename?: 'Query', getMembers?: Array<{ __typename?: 'Member', userId: string, email: string, name: string, role: RoleType } | null> | null };

export type GetMLInferenceLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  inferenceId: Scalars['String']['input'];
}>;


export type GetMLInferenceLogQuery = { __typename?: 'Query', getMLInferenceLog: { __typename?: 'MLInferenceLog', workspaceId: string, inferenceId: string, status: string, log?: string | null } };

export type GetMLInferenceMetricsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  inferenceId: Scalars['String']['input'];
}>;


export type GetMLInferenceMetricsQuery = { __typename?: 'Query', getMLInferenceMetrics: string };

export type GetMLArchitecturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMLArchitecturesQuery = { __typename?: 'Query', getMLArchitectures?: Array<{ __typename?: 'MLArchitecture', architectureId?: string | null, name?: string | null, description?: string | null, annotations?: string | null, hyperparameters?: Array<{ __typename?: 'Hyperparameter', name: string, field: string, type: string, description?: string | null, default?: string | null, min?: number | null, max?: number | null, step?: number | null, options?: Array<string | null> | null } | null> | null } | null> | null };

export type GetMLModelQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
}>;


export type GetMLModelQuery = { __typename?: 'Query', getMLModels: Array<{ __typename?: 'MLModel', architecture: string, architectureId: string, checkpoints?: Array<string | null> | null, dataset: string, datasetId: string, description?: string | null, metrics?: string | null, modelId: string, name: string, parameters?: string | null, status?: string | null, tags?: Array<string | null> | null } | null> };

export type GetMLModelLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
}>;


export type GetMLModelLogQuery = { __typename?: 'Query', getMLModelLog: { __typename?: 'MLModelLog', log?: string | null } };

export type AddMemberMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddMemberMutation = { __typename?: 'Mutation', addMember?: boolean | null };

export type ClearDatasetJobsMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ClearDatasetJobsMutation = { __typename?: 'Mutation', clearDatasetJobs?: boolean | null };

export type CreateAPIKeyMutationVariables = Exact<{
  name: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAPIKeyMutation = { __typename?: 'Mutation', createAPIKey: string };

export type CreateAnalyticsMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  type: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateAnalyticsMutation = { __typename?: 'Mutation', createAnalytics: string };

export type CreateAnnotationMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  format: Scalars['String']['input'];
  mapId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateAnnotationMutation = { __typename?: 'Mutation', createAnnotation: string };

export type CreateChannelMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  instance?: InputMaybe<Scalars['String']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  interfaceVersion?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateChannelMutation = { __typename?: 'Mutation', createChannel: string };

export type CreateDatasetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  runs?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  instanceType?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateDatasetMutation = { __typename?: 'Mutation', createDataset?: string | null };

export type CreateFeedbackMutationVariables = Exact<{
  summary: Scalars['String']['input'];
  description: Scalars['String']['input'];
  files: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type CreateFeedbackMutation = { __typename?: 'Mutation', createFeedback: { __typename?: 'Feedback', feedbackId: string, uploads?: Array<{ __typename?: 'FeedbackUpload', key?: string | null, url?: string | null } | null> | null } };

export type CreateGANDatasetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateGANDatasetMutation = { __typename?: 'Mutation', createGANDataset: string };

export type CreateGraphMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  graph: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateGraphMutation = { __typename?: 'Mutation', createGraph: string };

export type CreateInpaintMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  location: Scalars['String']['input'];
  files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  destination?: InputMaybe<Scalars['String']['input']>;
  dilation?: InputMaybe<Scalars['Int']['input']>;
  inputType?: InputMaybe<InpaintInputType>;
  outputType?: InputMaybe<InpaintOutputType>;
}>;


export type CreateInpaintMutation = { __typename?: 'Mutation', createInpaint: string };

export type CreateMLInferenceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  mapId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateMLInferenceMutation = { __typename?: 'Mutation', createMLInference: string };

export type CreateMLModelMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  architectureId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateMLModelMutation = { __typename?: 'Mutation', createMLModel: string };

export type CreateMixedDatasetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parameters: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateMixedDatasetMutation = { __typename?: 'Mutation', createMixedDataset: string };

export type CreatePreviewMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId: Scalars['String']['input'];
}>;


export type CreatePreviewMutation = { __typename?: 'Mutation', createPreview: string };

export type CreateRemoteDevelopmentMutationVariables = Exact<{
  channelId: Scalars['String']['input'];
  channelVersion?: InputMaybe<Scalars['String']['input']>;
  instanceType?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateRemoteDevelopmentMutation = { __typename?: 'Mutation', createRemoteDevelopment: { __typename?: 'RemoteDevelopment', editorSessionId: string, editorUrl: string } };

export type CreateSSHKeyMutationVariables = Exact<{
  name: Scalars['String']['input'];
  key: Scalars['String']['input'];
}>;


export type CreateSSHKeyMutation = { __typename?: 'Mutation', createSSHKey: boolean };

export type CreateUMAPMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  samples: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  seed?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateUMAPMutation = { __typename?: 'Mutation', createUMAP: string };

export type CreateVolumeMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateVolumeMutation = { __typename?: 'Mutation', createVolume: string };

export type CreateWorkspaceMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  channelIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  volumeIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateWorkspaceMutation = { __typename?: 'Mutation', createWorkspace: string };

export type DeleteAPIKeyMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DeleteAPIKeyMutation = { __typename?: 'Mutation', deleteAPIKey?: boolean | null };

export type DeleteAnalyticsMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  analyticsId: Scalars['String']['input'];
}>;


export type DeleteAnalyticsMutation = { __typename?: 'Mutation', deleteAnalytics: boolean };

export type DeleteAnnotationMutationVariables = Exact<{
  annotationId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}>;


export type DeleteAnnotationMutation = { __typename?: 'Mutation', deleteAnnotation: boolean };

export type DeleteAnnotationMapMutationVariables = Exact<{
  mapId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteAnnotationMapMutation = { __typename?: 'Mutation', deleteAnnotationMap: boolean };

export type DeleteChannelMutationVariables = Exact<{
  channelId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteChannelMutation = { __typename?: 'Mutation', deleteChannel?: boolean | null };

export type DeleteDatasetMutationVariables = Exact<{
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}>;


export type DeleteDatasetMutation = { __typename?: 'Mutation', deleteDataset?: boolean | null };

export type DeleteGANDatasetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
}>;


export type DeleteGANDatasetMutation = { __typename?: 'Mutation', deleteGANDataset?: boolean | null };

export type DeleteGANModelMutationVariables = Exact<{
  modelId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteGANModelMutation = { __typename?: 'Mutation', deleteGANModel?: boolean | null };

export type DeleteGraphMutationVariables = Exact<{
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}>;


export type DeleteGraphMutation = { __typename?: 'Mutation', deleteGraph?: boolean | null };

export type DeleteInpaintMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  inpaintId: Scalars['String']['input'];
}>;


export type DeleteInpaintMutation = { __typename?: 'Mutation', deleteInpaint: boolean };

export type DeleteMLInferenceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  inferenceId: Scalars['String']['input'];
}>;


export type DeleteMLInferenceMutation = { __typename?: 'Mutation', deleteMLInference: boolean };

export type DeleteMLModelMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
}>;


export type DeleteMLModelMutation = { __typename?: 'Mutation', deleteMLModel: boolean };

export type DeleteOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganization?: boolean | null };

export type DeleteRemoteDevelopmentMutationVariables = Exact<{
  editorSessionId: Scalars['String']['input'];
}>;


export type DeleteRemoteDevelopmentMutation = { __typename?: 'Mutation', deleteRemoteDevelopment: { __typename?: 'DeleteRemoteSessionResponse', editorSessionId: string } };

export type DeleteSSHKeyMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DeleteSSHKeyMutation = { __typename?: 'Mutation', deleteSSHKey: boolean };

export type DeleteUMAPMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  umapId: Scalars['String']['input'];
}>;


export type DeleteUMAPMutation = { __typename?: 'Mutation', deleteUMAP: boolean };

export type DeleteUserMutationVariables = Exact<{
  isDeleting?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: Array<{ __typename?: 'OrganizationAdmin', organizationId?: string | null, name?: string | null } | null> | null };

export type DeleteVolumeMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteVolumeMutation = { __typename?: 'Mutation', deleteVolume?: boolean | null };

export type DeleteVolumeDataMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteVolumeDataMutation = { __typename?: 'Mutation', deleteVolumeData: Array<string | null> };

export type DeleteWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type DeleteWorkspaceMutation = { __typename?: 'Mutation', deleteWorkspace: string };

export type DownloadAnnotationMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  annotationId: Scalars['String']['input'];
}>;


export type DownloadAnnotationMutation = { __typename?: 'Mutation', downloadAnnotation: string };

export type DownloadAnnotationMapMutationVariables = Exact<{
  mapId: Scalars['String']['input'];
}>;


export type DownloadAnnotationMapMutation = { __typename?: 'Mutation', downloadAnnotationMap: string };

export type DownloadDatasetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
}>;


export type DownloadDatasetMutation = { __typename?: 'Mutation', downloadDataset?: string | null };

export type DownloadGANModelMutationVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type DownloadGANModelMutation = { __typename?: 'Mutation', downloadGANModel: string };

export type DownloadGraphMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId: Scalars['String']['input'];
}>;


export type DownloadGraphMutation = { __typename?: 'Mutation', downloadGraph?: string | null };

export type DownloadMLInferenceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  inferenceId: Scalars['String']['input'];
}>;


export type DownloadMLInferenceMutation = { __typename?: 'Mutation', downloadMLInference: string };

export type DownloadMLModelMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  checkpoint?: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadMLModelMutation = { __typename?: 'Mutation', downloadMLModel: string };

export type DuplicateGraphMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DuplicateGraphMutation = { __typename?: 'Mutation', duplicateGraph?: string | null };

export type EditAnnotationMapMutationVariables = Exact<{
  mapId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditAnnotationMapMutation = { __typename?: 'Mutation', editAnnotationMap: boolean };

export type EditChannelMutationVariables = Exact<{
  channelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  instance?: InputMaybe<Scalars['String']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  interfaceVersion?: InputMaybe<Scalars['Int']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditChannelMutation = { __typename?: 'Mutation', editChannel?: boolean | null };

export type EditDatasetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  showJob?: InputMaybe<Scalars['Boolean']['input']>;
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditDatasetMutation = { __typename?: 'Mutation', editDataset?: boolean | null };

export type EditGANModelMutationVariables = Exact<{
  modelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditGANModelMutation = { __typename?: 'Mutation', editGANModel?: boolean | null };

export type EditGraphMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  graph?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditGraphMutation = { __typename?: 'Mutation', editGraph?: boolean | null };

export type EditMLModelMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditMLModelMutation = { __typename?: 'Mutation', editMLModel: boolean };

export type EditMemberMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  role: Scalars['String']['input'];
}>;


export type EditMemberMutation = { __typename?: 'Mutation', editMember?: boolean | null };

export type EditOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type EditOrganizationMutation = { __typename?: 'Mutation', editOrganization?: boolean | null };

export type EditUMAPMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  umapId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditUMAPMutation = { __typename?: 'Mutation', editUMAP: boolean };

export type EditUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type EditUserMutation = { __typename?: 'Mutation', editUser?: boolean | null };

export type EditVolumeMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditVolumeMutation = { __typename?: 'Mutation', editVolume?: boolean | null };

export type EditVolumeDataMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  source: Scalars['String']['input'];
  key: Scalars['String']['input'];
}>;


export type EditVolumeDataMutation = { __typename?: 'Mutation', editVolumeData?: boolean | null };

export type EditWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  channelIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  volumeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  ganIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  mapIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditWorkspaceMutation = { __typename?: 'Mutation', editWorkspace: string };

export type EditWorkspaceThumbnailMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  thumbnail: Scalars['String']['input'];
}>;


export type EditWorkspaceThumbnailMutation = { __typename?: 'Mutation', editWorkspaceThumbnail: string };

export type InviteRemoteDevelopmentMutationVariables = Exact<{
  editorSessionId: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type InviteRemoteDevelopmentMutation = { __typename?: 'Mutation', inviteRemoteDevelopment: boolean };

export type PingPreviewMutationVariables = Exact<{
  channelId: Scalars['String']['input'];
}>;


export type PingPreviewMutation = { __typename?: 'Mutation', pingPreview?: boolean | null };

export type RemoveMemberMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveMemberMutation = { __typename?: 'Mutation', removeMember?: boolean | null };

export type StartRemoteDevelopmentMutationVariables = Exact<{
  editorSessionId: Scalars['String']['input'];
}>;


export type StartRemoteDevelopmentMutation = { __typename?: 'Mutation', startRemoteDevelopment: { __typename?: 'UpdatedRemoteDevelopmentResponse', editorSessionId: string, editorUrl: string } };

export type StopRemoteDevelopmentMutationVariables = Exact<{
  editorSessionId: Scalars['String']['input'];
}>;


export type StopRemoteDevelopmentMutation = { __typename?: 'Mutation', stopRemoteDevelopment: { __typename?: 'UpdatedRemoteDevelopmentResponse', editorSessionId: string, editorUrl: string } };

export type UploadAnnotationMapMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UploadAnnotationMapMutation = { __typename?: 'Mutation', uploadAnnotationMap: { __typename?: 'UploadAnnotationMapResponse', mapId: string, key: string, partSize?: number | null, uploadId?: string | null, urls?: Array<string | null> | null } };

export type UploadAnnotationMapFinalizerMutationVariables = Exact<{
  uploadId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>> | InputMaybe<MultipartInput>>;
}>;


export type UploadAnnotationMapFinalizerMutation = { __typename?: 'Mutation', uploadAnnotationMapFinalizer: boolean };

export type UploadDatasetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UploadDatasetMutation = { __typename?: 'Mutation', uploadDataset: { __typename?: 'UploadDatasetResponse', datasetId: string, key: string, partSize?: number | null, uploadId?: string | null, urls?: Array<string | null> | null } };

export type UploadDatasetFinalizerMutationVariables = Exact<{
  key: Scalars['String']['input'];
  uploadId?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>> | InputMaybe<MultipartInput>>;
}>;


export type UploadDatasetFinalizerMutation = { __typename?: 'Mutation', uploadDatasetFinalizer?: boolean | null };

export type UploadGANModelMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UploadGANModelMutation = { __typename?: 'Mutation', uploadGANModel: { __typename?: 'UploadGANResponse', key: string, modelId: string, partSize?: number | null, uploadId?: string | null, urls?: Array<string | null> | null } };

export type UploadGANModelFinalizerMutationVariables = Exact<{
  key: Scalars['String']['input'];
  uploadId?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>> | InputMaybe<MultipartInput>>;
}>;


export type UploadGANModelFinalizerMutation = { __typename?: 'Mutation', uploadGANModelFinalizer?: boolean | null };

export type UploadMLModelMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  architectureId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  parameters?: InputMaybe<Scalars['String']['input']>;
}>;


export type UploadMLModelMutation = { __typename?: 'Mutation', uploadMLModel: { __typename?: 'UploadMLModelResponse', key: string, modelId: string, uploadId?: string | null, partSize?: number | null, urls?: Array<string | null> | null } };

export type UploadMLModelFinalizerMutationVariables = Exact<{
  key: Scalars['String']['input'];
  uploadId?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>> | InputMaybe<MultipartInput>>;
}>;


export type UploadMLModelFinalizerMutation = { __typename?: 'Mutation', uploadMLModelFinalizer?: boolean | null };

export type UploadVolumeDataMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  size: Scalars['Float']['input'];
}>;


export type UploadVolumeDataMutation = { __typename?: 'Mutation', uploadVolumeData: { __typename?: 'UploadVolumeDataResponse', key: string, partSize?: number | null, uploadId?: string | null, urls?: Array<string | null> | null, volumeId: string } };

export type UploadVolumeDataFinalizerMutationVariables = Exact<{
  key: Scalars['String']['input'];
  uploadId?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>> | InputMaybe<MultipartInput>>;
}>;


export type UploadVolumeDataFinalizerMutation = { __typename?: 'Mutation', uploadVolumeDataFinalizer?: boolean | null };

export type UploadVolumeDataThumbnailMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  key: Scalars['String']['input'];
}>;


export type UploadVolumeDataThumbnailMutation = { __typename?: 'Mutation', uploadVolumeDataThumbnail: { __typename?: 'UploadVolumeDataThumbnailResponse', key: string, url: string } };

export type ValidateGraphMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId: Scalars['String']['input'];
}>;


export type ValidateGraphMutation = { __typename?: 'Mutation', validateGraph?: Array<{ __typename?: 'GraphValidationError', node?: string | null, input?: string | null, errorMessage?: string | null, type?: string | null } | null> | null };

export type GetOrganizationsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganizationsQuery = { __typename?: 'Query', getOrganizations: Array<{ __typename?: 'Organization', name: string, role?: string | null, organizationId: string, expirationDate?: string | null, expired?: boolean | null, plan?: string | null } | null> };

export type GetOrganizationSettingsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  setting?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganizationSettingsQuery = { __typename?: 'Query', getOrganizationSettings?: Array<{ __typename?: 'OrganizationSetting', organizationId: string, setting: string, limit: string, usage: number, units: string } | null> | null };

export type GetOrganizationsNamesListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationsNamesListQuery = { __typename?: 'Query', getOrganizations: Array<{ __typename?: 'Organization', name: string, organizationId: string } | null> };

export type GetDatasetThumbnailsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
}>;


export type GetDatasetThumbnailsQuery = { __typename?: 'Query', getDatasetThumbnails: Array<string | null> };

export type ValidateContentCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ValidateContentCodeQuery = { __typename?: 'Query', validateContentCode?: boolean | null };

export type GetRemoteDevelopmentSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRemoteDevelopmentSessionsQuery = { __typename?: 'Query', listRemoteDevelopment: Array<{ __typename?: 'RemoteDevelopment', channel: string, channelId: string, createdAt?: string | null, createdBy?: string | null, editorSessionId: string, editorUrl: string, instanceType?: string | null, organization?: string | null, organizationId?: string | null, sshPort?: number | null, updatedAt?: string | null, status?: { __typename?: 'RemoteDevelopmentStatus', state?: string | null, message?: string | null } | null } | null> };

export type GetRemoteDevelopmentSessionsForChannelsTableQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRemoteDevelopmentSessionsForChannelsTableQuery = { __typename?: 'Query', listRemoteDevelopment: Array<{ __typename?: 'RemoteDevelopment', channel: string, channelId: string, editorSessionId: string, editorUrl: string, sshPort?: number | null, status?: { __typename?: 'RemoteDevelopmentStatus', state?: string | null } | null } | null> };

export type GetUMAPLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  umapId: Scalars['String']['input'];
}>;


export type GetUMAPLogQuery = { __typename?: 'Query', getUMAPLog?: { __typename?: 'UMAPLog', umapId: string, workspaceId: string, state: string, log?: string | null } | null };

export type GetUMAPQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  umapId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUMAPQuery = { __typename?: 'Query', getUMAPs: Array<{ __typename?: 'UMAP', name: string, results?: string | null, samples: Array<number | null>, seed: string, status: string, tags?: Array<string | null> | null, umapId: string, workspaceId: string, datasets: Array<{ __typename?: 'UMAPDataset', datasetId?: string | null, dataset?: string | null } | null> } | null> };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', getCurrentUser?: { __typename?: 'User', userId: string, email: string, name: string } | null };

export type GetVolumesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  volumeId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<VolumeFilter>;
}>;


export type GetVolumesQuery = { __typename?: 'Query', getVolumes?: Array<{ __typename?: 'Volume', name: string, size?: string | null, volumeId: string, updatedAt?: string | null, createdAt?: string | null, permission: string, description: string, organization: string, organizationId: string, tags?: Array<string | null> | null } | null> | null };

export type GetVolumeDataQueryVariables = Exact<{
  volumeId: Scalars['String']['input'];
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  dir?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetVolumeDataQuery = { __typename?: 'Query', getVolumeData: { __typename?: 'getVolumeData', keys: Array<{ __typename?: 'VolumeData', url?: string | null, updatedAt?: string | null, thumbnailUrl?: string | null, previewUrl?: string | null, size?: number | null, key?: string | null, hash?: string | null } | null>, pageInfo: { __typename?: 'PageInfo', totalItems: number, offset?: number | null, limit?: number | null } } };

export type GetVolumesNamesListQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVolumesNamesListQuery = { __typename?: 'Query', getVolumes?: Array<{ __typename?: 'Volume', volumeId: string, name: string } | null> | null };

export type GetWorkspacesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<WorkspaceFilter>;
}>;


export type GetWorkspacesQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', workspaceId: string, organizationId: string, organization?: string | null, name: string, createdAt?: string | null, updatedAt?: string | null, previewThumbnail?: string | null, status?: string | null, description?: string | null, tags?: Array<string | null> | null } | null> | null };

export type GetWorkspacesNameListQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<WorkspaceFilter>;
}>;


export type GetWorkspacesNameListQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', name: string, workspaceId: string } | null> | null };

export type GetWorkspaceSettingsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  setting?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceSettingsQuery = { __typename?: 'Query', getWorkspaceSettings?: Array<{ __typename?: 'WorkspaceSetting', workspaceId: string, setting: string, limit: string, usage: number, units: string } | null> | null };

export type GetWorkspaceNameQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceNameQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', name: string, workspaceId: string } | null> | null };

export type GetWorkspaceContextDataQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceContextDataQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', description?: string | null, name: string, organizationId: string, status?: string | null, tags?: Array<string | null> | null, workspaceId: string } | null> | null };

export type GetOrganizationExpirationDataQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganizationExpirationDataQuery = { __typename?: 'Query', getOrganizations: Array<{ __typename?: 'Organization', role?: string | null, expirationDate?: string | null, expired?: boolean | null, organizationId: string } | null> };

export type GetLandingPageRecentWorkspacesQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLandingPageRecentWorkspacesQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', name: string, organization?: string | null, organizationId: string, previewThumbnail?: string | null, status?: string | null, updatedAt?: string | null, workspaceId: string } | null> | null };

export type ChannelTableRowSessionFragmentFragment = { __typename?: 'RemoteDevelopment', editorSessionId: string, editorUrl: string, channelId: string, sshPort?: number | null, status?: { __typename?: 'RemoteDevelopmentStatus', state?: string | null, message?: string | null } | null };

export type ChannelTableRowChannelFragmentFragment = { __typename?: 'Channel', channelId: string, description: string, documentation?: boolean | null, name: string, organization: string, organizationId: string, updatedAt?: string | null, instanceType?: string | null, state?: string | null, tags?: Array<string | null> | null, version?: string | null };

export type ChannelTableRowDropdownSessionFragmentFragment = { __typename?: 'RemoteDevelopment', channelId: string, editorSessionId: string, editorUrl: string, sshPort?: number | null, status?: { __typename?: 'RemoteDevelopmentStatus', state?: string | null } | null };

export type ChannelTableRowDropdownChannelFragmentFragment = { __typename?: 'Channel', name: string, channelId: string, organizationId: string, description: string, instanceType?: string | null, state?: string | null, tags?: Array<string | null> | null, version?: string | null };

export type GetChannelDataForEditQueryVariables = Exact<{
  channelId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
}>;


export type GetChannelDataForEditQuery = { __typename?: 'Query', getChannels?: Array<{ __typename?: 'Channel', channelId: string, volumes?: Array<string | null> | null, timeout?: number | null } | null> | null };

export type GetOrganizationRemoteDevelopmentSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationRemoteDevelopmentSessionsQuery = { __typename?: 'Query', listRemoteDevelopment: Array<{ __typename?: 'RemoteDevelopment', channelId: string, editorSessionId: string, editorUrl: string, sshPort?: number | null, status?: { __typename?: 'RemoteDevelopmentStatus', state?: string | null, message?: string | null } | null } | null> };

export type GetOrganizationChannelsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ChannelFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganizationChannelsQuery = { __typename?: 'Query', getChannels?: Array<{ __typename?: 'Channel', channelId: string, description: string, documentation?: boolean | null, name: string, organization: string, organizationId: string, updatedAt?: string | null, instanceType?: string | null, state?: string | null, tags?: Array<string | null> | null, version?: string | null } | null> | null };

export type RemoteSessionOptionsFragmentFragment = { __typename?: 'RemoteDevelopment', channelId: string, editorSessionId: string, editorUrl: string, sshPort?: number | null, status?: { __typename?: 'RemoteDevelopmentStatus', state?: string | null } | null };

export type RemoteSessionStatusFragmentFragment = { __typename?: 'RemoteDevelopment', editorSessionId: string, editorUrl: string, status?: { __typename?: 'RemoteDevelopmentStatus', state?: string | null, message?: string | null } | null };

export type GetOrganizationJobsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganizationJobsQuery = { __typename?: 'Query', getDatasetJobs?: Array<{ __typename?: 'DatasetJob', datasetId?: string | null, workspaceId?: string | null, name?: string | null, runs?: number | null, status?: string | null, createdAt?: string | null, estimatedEndAt?: string | null } | null> | null };

export type GetWorkspacesSearchDetailQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  filters?: InputMaybe<WorkspaceFilter>;
}>;


export type GetWorkspacesSearchDetailQuery = { __typename?: 'Query', getWorkspacesSearchDetail?: { __typename?: 'WorkspaceSearchDetail', channels?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type GetChannelsSearchDetailQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ChannelFilter>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetChannelsSearchDetailQuery = { __typename?: 'Query', getChannelsSearchDetail?: { __typename?: 'ChannelSearchDetail', users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type GetVolumesSearchDetailQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<VolumeFilter>;
}>;


export type GetVolumesSearchDetailQuery = { __typename?: 'Query', getVolumesSearchDetail?: { __typename?: 'VolumeSearchDetail', tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type GetAnnotationMapsSearchDetailQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AnnotationMapFilter>;
}>;


export type GetAnnotationMapsSearchDetailQuery = { __typename?: 'Query', getAnnotationMapsSearchDetail: { __typename?: 'AnnotationMapSearchDetail', users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } };

export type GetGANModelsSearchDetailQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<GANModelFilter>;
}>;


export type GetGANModelsSearchDetailQuery = { __typename?: 'Query', getGANModelsSearchDetail: { __typename?: 'GANModelSearchDetail', users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } };

export type GetContentCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContentCodesQuery = { __typename?: 'Query', getContentCodes?: Array<{ __typename?: 'ContentCode', code: string, name: string, description: string, thumbnail?: string | null, link?: string | null, featured: boolean, contactUs: boolean, expiresAt?: string | null } | null> | null };

export type GetWorkspaceTableWorkspaceChannelsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetWorkspaceTableWorkspaceChannelsQuery = { __typename?: 'Query', getChannels?: Array<{ __typename?: 'Channel', channelId: string, name: string } | null> | null };

export type CreateRemoteSessionGetUserOrgsQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateRemoteSessionGetUserOrgsQuery = { __typename?: 'Query', getOrganizations: Array<{ __typename?: 'Organization', expired?: boolean | null, name: string, organizationId: string } | null> };

export type CreateRemoteSessionGetOrgChannelsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateRemoteSessionGetOrgChannelsQuery = { __typename?: 'Query', getChannels?: Array<{ __typename?: 'Channel', channelId: string, instanceType?: string | null, name: string, organizationId: string, state?: string | null, version?: string | null } | null> | null };

export type GetAPIKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAPIKeysQuery = { __typename?: 'Query', getAPIKeys: Array<{ __typename?: 'APIKey', createdAt?: string | null, expiresAt?: string | null, name: string, organizationId?: string | null, scope: string, workspaceId?: string | null } | null> };

export type GetSSHKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSSHKeysQuery = { __typename?: 'Query', getSSHKeys: Array<{ __typename?: 'SSHKey', name?: string | null, key?: string | null, createdAt?: string | null } | null> };

export type GetVolumeDetailsVolumeDataQueryVariables = Exact<{
  volumeId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetVolumeDetailsVolumeDataQuery = { __typename?: 'Query', getVolumes?: Array<{ __typename?: 'Volume', volumeId: string, name: string, permission: string } | null> | null };

export type GetDatasetRunsCountQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
}>;


export type GetDatasetRunsCountQuery = { __typename?: 'Query', getDatasets?: Array<{ __typename?: 'Dataset', datasetId?: string | null, runs?: number | null } | null> | null };

export type GetWorkspaceAnalyticsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<AnalyticsFilter>;
}>;


export type GetWorkspaceAnalyticsQuery = { __typename?: 'Query', getAnalytics: Array<{ __typename?: 'Analytics', analyticsId: string, createdAt?: string | null, createdBy?: string | null, dataset: string, datasetId: string, result?: string | null, status: string, tags?: Array<string | null> | null, type: string, workspaceId: string } | null> };

export type GetAnalyticsSearchDetailQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  filters?: InputMaybe<AnalyticsFilter>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAnalyticsSearchDetailQuery = { __typename?: 'Query', getAnalyticsSearchDetail: { __typename?: 'AnalyticsSearchDetail', status?: Array<{ __typename?: 'SearchDetail', display?: string | null, value?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } };

export type GetWorkspaceUMAPsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<UMAPFilter>;
}>;


export type GetWorkspaceUMAPsQuery = { __typename?: 'Query', getUMAPs: Array<{ __typename?: 'UMAP', createdAt?: string | null, createdBy?: string | null, name: string, results?: string | null, samples: Array<number | null>, seed: string, status: string, tags?: Array<string | null> | null, umapId: string, workspaceId: string, datasets: Array<{ __typename?: 'UMAPDataset', dataset?: string | null, datasetId?: string | null } | null> } | null> };

export type GetUMAPsSearchDetailQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UMAPFilter>;
}>;


export type GetUMAPsSearchDetailQuery = { __typename?: 'Query', getUMAPsSearchDetail: { __typename?: 'UMAPSearchDetail', users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, status?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } };

export type GetWorkspaceMLModelsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<MLModelFilter>;
}>;


export type GetWorkspaceMLModelsQuery = { __typename?: 'Query', getMLModels: Array<{ __typename?: 'MLModel', architecture: string, architectureId: string, checkpoints?: Array<string | null> | null, classes?: Array<string | null> | null, createdBy?: string | null, createdAt?: string | null, dataset: string, datasetId: string, description?: string | null, map?: string | null, mapId?: string | null, metrics?: string | null, modelId: string, name: string, parameters?: string | null, status?: string | null, tags?: Array<string | null> | null } | null> };

export type GetMLModelsSearchDetailQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MLModelFilter>;
}>;


export type GetMLModelsSearchDetailQuery = { __typename?: 'Query', getMLModelsSearchDetail: { __typename?: 'MLModelSearchDetail', users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, status?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, architectures?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } };

export type GetWorkspaceMLInferencesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<MLInferenceFilter>;
}>;


export type GetWorkspaceMLInferencesQuery = { __typename?: 'Query', getMLInferences: Array<{ __typename?: 'MLInference', datasetId: string, dataset: string, map?: string | null, mapId?: string | null, metrics?: string | null, model: string, modelId: string, status?: string | null, inferenceId: string, workspaceId: string, createdBy?: string | null, createdAt?: string | null, tags?: Array<string | null> | null } | null> };

export type GetMLInferencesSearchDetailQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MLInferenceFilter>;
}>;


export type GetMLInferencesSearchDetailQuery = { __typename?: 'Query', getMLInferencesSearchDetail: { __typename?: 'MLInferenceSearchDetail', users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, status?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, architectures?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } };

export type GetMLModelInferencesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  modelId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMLModelInferencesQuery = { __typename?: 'Query', getMLInferences: Array<{ __typename?: 'MLInference', datasetId: string, dataset: string, model: string, modelId: string, status?: string | null, inferenceId: string, tags?: Array<string | null> | null, workspaceId: string } | null> };

export type GetDatasetFilesCountQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
}>;


export type GetDatasetFilesCountQuery = { __typename?: 'Query', getDatasets?: Array<{ __typename?: 'Dataset', datasetId?: string | null, files?: number | null } | null> | null };

export type GetAddGraphAvailableChannelsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetAddGraphAvailableChannelsQuery = { __typename?: 'Query', getChannels?: Array<{ __typename?: 'Channel', channelId: string, name: string } | null> | null };

export type AddGraphAvailableChannelsFragmentFragment = { __typename?: 'Channel', channelId: string, name: string };

export type GraphUpdatedSubscriptionVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId: Scalars['String']['input'];
  uid: Scalars['String']['input'];
}>;


export type GraphUpdatedSubscription = { __typename?: 'Subscription', graphUpdates?: { __typename?: 'GraphUpdateReponse', name?: string | null, description?: string | null, graphId: string, graph?: string | null } | null };

export type GetGraphsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetGraphsQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', channel: string, createdAt?: string | null, createdBy?: string | null, description?: string | null, graphId: string, name: string, tags?: Array<string | null> | null, thumbnail?: string | null, updatedAt?: string | null, workspaceId: string } | null> | null };

export type GetGraphMetadataQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGraphMetadataQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', channel: string, channelId: string, description?: string | null, graphId: string, name: string, previewId?: string | null, readOnly?: boolean | null, showPreview?: boolean | null, tags?: Array<string | null> | null, workspaceId: string, updatedAt?: string | null } | null> | null };

export type GetPreviewQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  previewId: Scalars['String']['input'];
}>;


export type GetPreviewQuery = { __typename?: 'Query', getPreview?: { __typename?: 'Preview', status?: string | null, previewId: string, thumbnail?: string | null, updatedAt?: string | null, workspaceId: string } | null };

export type GetGraphLastUpdatedQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGraphLastUpdatedQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', graphId: string, updatedAt?: string | null } | null> | null };

export type GetChannelSchemaQueryVariables = Exact<{
  channelId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetChannelSchemaQuery = { __typename?: 'Query', getChannelSchema: string };

export type GetPreviewLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  previewId: Scalars['String']['input'];
}>;


export type GetPreviewLogQuery = { __typename?: 'Query', getPreviewLog?: { __typename?: 'PreviewLog', log?: string | null, previewId: string, status?: string | null } | null };

export type GetGraphsWithFiltersQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  filters?: InputMaybe<GraphFilter>;
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetGraphsWithFiltersQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', channel: string, createdAt?: string | null, createdBy?: string | null, description?: string | null, graphId: string, name: string, tags?: Array<string | null> | null, thumbnail?: string | null, updatedAt?: string | null, workspaceId: string } | null> | null };

export type GetGraphsSearchDetailQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<GraphFilter>;
}>;


export type GetGraphsSearchDetailQuery = { __typename?: 'Query', getGraphsSearchDetail?: { __typename?: 'GraphSearchDetail', tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, channels?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type GetJobsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<DatasetJobFilter>;
}>;


export type GetJobsQuery = { __typename?: 'Query', getDatasetJobs?: Array<{ __typename?: 'DatasetJob', name?: string | null, datasetId?: string | null, status?: string | null, priority?: number | null, graphId?: string | null, channelId?: string | null, workspaceId?: string | null, averageRuntime?: string | null, instancesQueued?: number | null, instancesRunning?: number | null, instancesStarting?: number | null, runsSuccess?: number | null, runsTimeout?: number | null, seed?: number | null, runsRunning?: number | null, runsFailed?: number | null, runsCancelled?: number | null, runs?: number | null, runsStarting?: number | null, runsQueued?: number | null, updatedAt?: string | null, estimatedEndAt?: string | null, createdBy?: string | null, createdAt?: string | null, channel?: string | null } | null> | null };

export type GetStagedGraphsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<GraphFilter>;
}>;


export type GetStagedGraphsQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', channel: string, channelId: string, createdAt?: string | null, createdBy?: string | null, description?: string | null, graphId: string, name: string, tags?: Array<string | null> | null, thumbnail?: string | null, workspaceId: string, updatedAt?: string | null } | null> | null };

export type GetDatasetJobsSearchDetailQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<DatasetJobFilter>;
}>;


export type GetDatasetJobsSearchDetailQuery = { __typename?: 'Query', getDatasetJobsSearchDetail?: { __typename?: 'DatasetJobSearchDetail', tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, channels?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, type?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type GetGraphThumbnailsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetGraphThumbnailsQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', graphId: string, thumbnail?: string | null } | null> | null };

export type GetWorkspaceThumbnailQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceThumbnailQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', workspaceId: string, previewThumbnail?: string | null } | null> | null };

export type GetRecentJobsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetRecentJobsQuery = { __typename?: 'Query', getDatasetJobs?: Array<{ __typename?: 'DatasetJob', createdAt?: string | null, datasetId?: string | null, estimatedEndAt?: string | null, name?: string | null, status?: string | null } | null> | null };

export type GetRecentGraphsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  staged?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRecentGraphsQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', channel: string, channelId: string, createdAt?: string | null, createdBy?: string | null, description?: string | null, graphId: string, name: string, tags?: Array<string | null> | null, thumbnail?: string | null, updatedAt?: string | null, workspaceId: string } | null> | null };

export type GetRecentDatasetsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetRecentDatasetsQuery = { __typename?: 'Query', getDatasets?: Array<{ __typename?: 'Dataset', createdAt?: string | null, datasetId?: string | null, name: string, runs?: number | null } | null> | null };

export type GetWorkspaceResourcesAvailableChannelsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceResourcesAvailableChannelsQuery = { __typename?: 'Query', getChannels?: Array<{ __typename?: 'Channel', channelId: string, name: string } | null> | null };

export type GetWorkspaceResourcesWorkspaceChannelsQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceResourcesWorkspaceChannelsQuery = { __typename?: 'Query', getChannels?: Array<{ __typename?: 'Channel', channelId: string, name: string } | null> | null };

export type GetWorkspaceResourcesAvailableVolumesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceResourcesAvailableVolumesQuery = { __typename?: 'Query', getVolumes?: Array<{ __typename?: 'Volume', volumeId: string, name: string } | null> | null };

export type GetWorkspaceResourcesWorkspaceVolumesQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceResourcesWorkspaceVolumesQuery = { __typename?: 'Query', getVolumes?: Array<{ __typename?: 'Volume', volumeId: string, name: string } | null> | null };

export type GetDatasetImageFilenamesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDatasetImageFilenamesQuery = { __typename?: 'Query', getDatasetFiles?: Array<string | null> | null };

export type GetImageInferenceQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  inferenceId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
}>;


export type GetImageInferenceQuery = { __typename?: 'Query', getImageInference: { __typename?: 'ImageInference', image?: string | null, inferences?: Array<{ __typename?: 'Inference', bbox?: Array<number | null> | null, class?: number | null, className?: string | null, confidence?: string | null } | null> | null } };

export type GetImageAnnotationQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
}>;


export type GetImageAnnotationQuery = { __typename?: 'Query', getImageAnnotation?: { __typename?: 'RunData', data?: Array<string | null> | null, datasetId?: string | null, filename?: string | null } | null };

export type GetDatasetsForMixQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDatasetsForMixQuery = { __typename?: 'Query', getDatasets?: Array<{ __typename?: 'Dataset', classes?: Array<string | null> | null, datasetId?: string | null, files?: number | null, name: string } | null> | null };

export type GetDatasetDetailsAnalyticsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetDetailsAnalyticsQuery = { __typename?: 'Query', getAnalytics: Array<{ __typename?: 'Analytics', analyticsId: string, datasetId: string, status: string, tags?: Array<string | null> | null, type: string, workspaceId: string } | null> };

export type GetAnnotationsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAnnotationsQuery = { __typename?: 'Query', getAnnotations: Array<{ __typename?: 'Annotation', annotationId: string, datasetId: string, format: string, map?: string | null, status?: string | null, tags?: Array<string | null> | null, updatedAt?: string | null, workspaceId: string } | null> };

export type GetDatasetDetailsGANDatasetsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetDetailsGANDatasetsQuery = { __typename?: 'Query', getGANDatasets: Array<{ __typename?: 'GANDataset', datasetId: string, description?: string | null, model: string, name?: string | null, status: string, tags?: Array<string | null> | null, updatedAt: string, workspaceId: string } | null> };

export type GetDatasetDetailsUMAPsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetDetailsUMAPsQuery = { __typename?: 'Query', getUMAPs: Array<{ __typename?: 'UMAP', name: string, status: string, tags?: Array<string | null> | null, umapId: string } | null> };

export type GetDatasetInferencesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetInferencesQuery = { __typename?: 'Query', getMLInferences: Array<{ __typename?: 'MLInference', inferenceId: string, dataset: string, datasetId: string, modelId: string, model: string, status?: string | null, tags?: Array<string | null> | null, workspaceId: string } | null> };

export type GetDatasetModelsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetModelsQuery = { __typename?: 'Query', getMLModels: Array<{ __typename?: 'MLModel', modelId: string, name: string, status?: string | null, tags?: Array<string | null> | null, workspaceId: string } | null> };

export type GetDatasetsWithFilterQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<DatasetFilter>;
}>;


export type GetDatasetsWithFilterQuery = { __typename?: 'Query', getDatasets?: Array<{ __typename?: 'Dataset', channel?: string | null, channelId?: string | null, classes?: Array<string | null> | null, createdAt?: string | null, createdBy?: string | null, datasetId?: string | null, description?: string | null, files?: number | null, graphId?: string | null, name: string, runs?: number | null, seed?: string | null, size?: number | null, source?: string | null, status?: string | null, tags?: Array<string | null> | null, type?: string | null } | null> | null };

export type GetDatasetsSearchDetailQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  filters?: InputMaybe<DatasetFilter>;
}>;


export type GetDatasetsSearchDetailQuery = { __typename?: 'Query', getDatasetsSearchDetail?: { __typename?: 'DatasetSearchDetail', channels?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, type?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type GetAvailableChannelsForNewWorkspaceQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetAvailableChannelsForNewWorkspaceQuery = { __typename?: 'Query', getChannels?: Array<{ __typename?: 'Channel', channelId: string, name: string } | null> | null };

export const RemoteSessionOptionsFragmentFragmentDoc = gql`
    fragment RemoteSessionOptionsFragment on RemoteDevelopment {
  channelId
  editorSessionId
  editorUrl
  sshPort
  status {
    state
  }
}
    `;
export const ChannelTableRowDropdownSessionFragmentFragmentDoc = gql`
    fragment ChannelTableRowDropdownSessionFragment on RemoteDevelopment {
  ...RemoteSessionOptionsFragment
}
    ${RemoteSessionOptionsFragmentFragmentDoc}`;
export const RemoteSessionStatusFragmentFragmentDoc = gql`
    fragment RemoteSessionStatusFragment on RemoteDevelopment {
  editorSessionId
  editorUrl
  status {
    state
    message
  }
}
    `;
export const ChannelTableRowSessionFragmentFragmentDoc = gql`
    fragment ChannelTableRowSessionFragment on RemoteDevelopment {
  ...ChannelTableRowDropdownSessionFragment
  ...RemoteSessionStatusFragment
}
    ${ChannelTableRowDropdownSessionFragmentFragmentDoc}
${RemoteSessionStatusFragmentFragmentDoc}`;
export const ChannelTableRowDropdownChannelFragmentFragmentDoc = gql`
    fragment ChannelTableRowDropdownChannelFragment on Channel {
  name
  channelId
  organizationId
  description
  instanceType
  state
  tags
  version
}
    `;
export const ChannelTableRowChannelFragmentFragmentDoc = gql`
    fragment ChannelTableRowChannelFragment on Channel {
  channelId
  description
  documentation
  name
  organization
  organizationId
  updatedAt
  ...ChannelTableRowDropdownChannelFragment
}
    ${ChannelTableRowDropdownChannelFragmentFragmentDoc}`;
export const AddGraphAvailableChannelsFragmentFragmentDoc = gql`
    fragment AddGraphAvailableChannelsFragment on Channel {
  channelId
  name
}
    `;
export const GetWorkspaceSelectionDataDocument = gql`
    query GetWorkspaceSelectionData($workspaceId: String) {
  getWorkspaces(workspaceId: $workspaceId) {
    name
    organizationId
    workspaceId
  }
}
    `;

/**
 * __useGetWorkspaceSelectionDataQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSelectionDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSelectionDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSelectionDataQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceSelectionDataQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceSelectionDataQuery, GetWorkspaceSelectionDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceSelectionDataQuery, GetWorkspaceSelectionDataQueryVariables>(GetWorkspaceSelectionDataDocument, options);
      }
export function useGetWorkspaceSelectionDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceSelectionDataQuery, GetWorkspaceSelectionDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceSelectionDataQuery, GetWorkspaceSelectionDataQueryVariables>(GetWorkspaceSelectionDataDocument, options);
        }
export type GetWorkspaceSelectionDataQueryHookResult = ReturnType<typeof useGetWorkspaceSelectionDataQuery>;
export type GetWorkspaceSelectionDataLazyQueryHookResult = ReturnType<typeof useGetWorkspaceSelectionDataLazyQuery>;
export type GetWorkspaceSelectionDataQueryResult = Apollo.QueryResult<GetWorkspaceSelectionDataQuery, GetWorkspaceSelectionDataQueryVariables>;
export const GetAnalyticsDocument = gql`
    query GetAnalytics($workspaceId: String!, $analyticsId: String!) {
  getAnalytics(workspaceId: $workspaceId, analyticsId: $analyticsId) {
    result
  }
}
    `;

/**
 * __useGetAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      analyticsId: // value for 'analyticsId'
 *   },
 * });
 */
export function useGetAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsQuery, GetAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsQuery, GetAnalyticsQueryVariables>(GetAnalyticsDocument, options);
      }
export function useGetAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsQuery, GetAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsQuery, GetAnalyticsQueryVariables>(GetAnalyticsDocument, options);
        }
export type GetAnalyticsQueryHookResult = ReturnType<typeof useGetAnalyticsQuery>;
export type GetAnalyticsLazyQueryHookResult = ReturnType<typeof useGetAnalyticsLazyQuery>;
export type GetAnalyticsQueryResult = Apollo.QueryResult<GetAnalyticsQuery, GetAnalyticsQueryVariables>;
export const GetAnalyticsTypesDocument = gql`
    query GetAnalyticsTypes {
  getAnalyticsTypes
}
    `;

/**
 * __useGetAnalyticsTypesQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnalyticsTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>(GetAnalyticsTypesDocument, options);
      }
export function useGetAnalyticsTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>(GetAnalyticsTypesDocument, options);
        }
export type GetAnalyticsTypesQueryHookResult = ReturnType<typeof useGetAnalyticsTypesQuery>;
export type GetAnalyticsTypesLazyQueryHookResult = ReturnType<typeof useGetAnalyticsTypesLazyQuery>;
export type GetAnalyticsTypesQueryResult = Apollo.QueryResult<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>;
export const GetAnalyticsLogDocument = gql`
    query GetAnalyticsLog($workspaceId: String!, $analyticsId: String!) {
  getAnalyticsLog(workspaceId: $workspaceId, analyticsId: $analyticsId) {
    log
  }
}
    `;

/**
 * __useGetAnalyticsLogQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      analyticsId: // value for 'analyticsId'
 *   },
 * });
 */
export function useGetAnalyticsLogQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables>(GetAnalyticsLogDocument, options);
      }
export function useGetAnalyticsLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables>(GetAnalyticsLogDocument, options);
        }
export type GetAnalyticsLogQueryHookResult = ReturnType<typeof useGetAnalyticsLogQuery>;
export type GetAnalyticsLogLazyQueryHookResult = ReturnType<typeof useGetAnalyticsLogLazyQuery>;
export type GetAnalyticsLogQueryResult = Apollo.QueryResult<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables>;
export const GetAnnotationFormatsDocument = gql`
    query GetAnnotationFormats {
  getAnnotationFormats
}
    `;

/**
 * __useGetAnnotationFormatsQuery__
 *
 * To run a query within a React component, call `useGetAnnotationFormatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationFormatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationFormatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnnotationFormatsQuery(baseOptions?: Apollo.QueryHookOptions<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>(GetAnnotationFormatsDocument, options);
      }
export function useGetAnnotationFormatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>(GetAnnotationFormatsDocument, options);
        }
export type GetAnnotationFormatsQueryHookResult = ReturnType<typeof useGetAnnotationFormatsQuery>;
export type GetAnnotationFormatsLazyQueryHookResult = ReturnType<typeof useGetAnnotationFormatsLazyQuery>;
export type GetAnnotationFormatsQueryResult = Apollo.QueryResult<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>;
export const GetAnnotationMapsDocument = gql`
    query GetAnnotationMaps($organizationId: String, $workspaceId: String, $mapId: String, $cursor: String, $limit: Int, $filters: AnnotationMapFilter) {
  getAnnotationMaps(
    organizationId: $organizationId
    workspaceId: $workspaceId
    mapId: $mapId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    description
    mapId
    name
    organization
    createdAt
    organizationId
    updatedAt
    tags
  }
}
    `;

/**
 * __useGetAnnotationMapsQuery__
 *
 * To run a query within a React component, call `useGetAnnotationMapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationMapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationMapsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      mapId: // value for 'mapId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAnnotationMapsQuery(baseOptions?: Apollo.QueryHookOptions<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>(GetAnnotationMapsDocument, options);
      }
export function useGetAnnotationMapsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>(GetAnnotationMapsDocument, options);
        }
export type GetAnnotationMapsQueryHookResult = ReturnType<typeof useGetAnnotationMapsQuery>;
export type GetAnnotationMapsLazyQueryHookResult = ReturnType<typeof useGetAnnotationMapsLazyQuery>;
export type GetAnnotationMapsQueryResult = Apollo.QueryResult<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>;
export const GetAnnotationLogDocument = gql`
    query GetAnnotationLog($workspaceId: String!, $annotationId: String!) {
  getAnnotationLog(workspaceId: $workspaceId, annotationId: $annotationId) {
    log
  }
}
    `;

/**
 * __useGetAnnotationLogQuery__
 *
 * To run a query within a React component, call `useGetAnnotationLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      annotationId: // value for 'annotationId'
 *   },
 * });
 */
export function useGetAnnotationLogQuery(baseOptions: Apollo.QueryHookOptions<GetAnnotationLogQuery, GetAnnotationLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnotationLogQuery, GetAnnotationLogQueryVariables>(GetAnnotationLogDocument, options);
      }
export function useGetAnnotationLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnotationLogQuery, GetAnnotationLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnotationLogQuery, GetAnnotationLogQueryVariables>(GetAnnotationLogDocument, options);
        }
export type GetAnnotationLogQueryHookResult = ReturnType<typeof useGetAnnotationLogQuery>;
export type GetAnnotationLogLazyQueryHookResult = ReturnType<typeof useGetAnnotationLogLazyQuery>;
export type GetAnnotationLogQueryResult = Apollo.QueryResult<GetAnnotationLogQuery, GetAnnotationLogQueryVariables>;
export const GetChannelDocumentationDocument = gql`
    query GetChannelDocumentation($channelId: String!) {
  getChannelDocumentation(channelId: $channelId)
}
    `;

/**
 * __useGetChannelDocumentationQuery__
 *
 * To run a query within a React component, call `useGetChannelDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelDocumentationQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetChannelDocumentationQuery(baseOptions: Apollo.QueryHookOptions<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables>(GetChannelDocumentationDocument, options);
      }
export function useGetChannelDocumentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables>(GetChannelDocumentationDocument, options);
        }
export type GetChannelDocumentationQueryHookResult = ReturnType<typeof useGetChannelDocumentationQuery>;
export type GetChannelDocumentationLazyQueryHookResult = ReturnType<typeof useGetChannelDocumentationLazyQuery>;
export type GetChannelDocumentationQueryResult = Apollo.QueryResult<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables>;
export const GetChannelNodeDocumentationDocument = gql`
    query GetChannelNodeDocumentation($channelId: String!, $nodeClass: String!) {
  getNodeDocumentation(channelId: $channelId, nodeClass: $nodeClass) {
    documentation
    preview
    thumbnail
  }
}
    `;

/**
 * __useGetChannelNodeDocumentationQuery__
 *
 * To run a query within a React component, call `useGetChannelNodeDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelNodeDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelNodeDocumentationQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      nodeClass: // value for 'nodeClass'
 *   },
 * });
 */
export function useGetChannelNodeDocumentationQuery(baseOptions: Apollo.QueryHookOptions<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables>(GetChannelNodeDocumentationDocument, options);
      }
export function useGetChannelNodeDocumentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables>(GetChannelNodeDocumentationDocument, options);
        }
export type GetChannelNodeDocumentationQueryHookResult = ReturnType<typeof useGetChannelNodeDocumentationQuery>;
export type GetChannelNodeDocumentationLazyQueryHookResult = ReturnType<typeof useGetChannelNodeDocumentationLazyQuery>;
export type GetChannelNodeDocumentationQueryResult = Apollo.QueryResult<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables>;
export const GetDatasetRunsDocument = gql`
    query GetDatasetRuns($workspaceId: String!, $datasetId: String!, $state: String) {
  getDatasetRuns(workspaceId: $workspaceId, datasetId: $datasetId, state: $state) {
    runId
    workspaceId
    datasetId
    channelId
    startTime
    endTime
    state
    run
  }
  getDatasetJobs(workspaceId: $workspaceId, datasetId: $datasetId) {
    datasetId
    name
  }
}
    `;

/**
 * __useGetDatasetRunsQuery__
 *
 * To run a query within a React component, call `useGetDatasetRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetRunsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetDatasetRunsQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetRunsQuery, GetDatasetRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetRunsQuery, GetDatasetRunsQueryVariables>(GetDatasetRunsDocument, options);
      }
export function useGetDatasetRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetRunsQuery, GetDatasetRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetRunsQuery, GetDatasetRunsQueryVariables>(GetDatasetRunsDocument, options);
        }
export type GetDatasetRunsQueryHookResult = ReturnType<typeof useGetDatasetRunsQuery>;
export type GetDatasetRunsLazyQueryHookResult = ReturnType<typeof useGetDatasetRunsLazyQuery>;
export type GetDatasetRunsQueryResult = Apollo.QueryResult<GetDatasetRunsQuery, GetDatasetRunsQueryVariables>;
export const GetDatasetLogDocument = gql`
    query GetDatasetLog($workspaceId: String!, $datasetId: String!, $runId: String!) {
  getDatasetLog(workspaceId: $workspaceId, datasetId: $datasetId, runId: $runId) {
    log
  }
}
    `;

/**
 * __useGetDatasetLogQuery__
 *
 * To run a query within a React component, call `useGetDatasetLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useGetDatasetLogQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetLogQuery, GetDatasetLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetLogQuery, GetDatasetLogQueryVariables>(GetDatasetLogDocument, options);
      }
export function useGetDatasetLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetLogQuery, GetDatasetLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetLogQuery, GetDatasetLogQueryVariables>(GetDatasetLogDocument, options);
        }
export type GetDatasetLogQueryHookResult = ReturnType<typeof useGetDatasetLogQuery>;
export type GetDatasetLogLazyQueryHookResult = ReturnType<typeof useGetDatasetLogLazyQuery>;
export type GetDatasetLogQueryResult = Apollo.QueryResult<GetDatasetLogQuery, GetDatasetLogQueryVariables>;
export const GetDatasetImageDocument = gql`
    query GetDatasetImage($workspaceId: String!, $datasetId: String!, $filename: String!) {
  getDatasetImage(
    workspaceId: $workspaceId
    datasetId: $datasetId
    filename: $filename
  ) {
    data
  }
}
    `;

/**
 * __useGetDatasetImageQuery__
 *
 * To run a query within a React component, call `useGetDatasetImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetImageQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGetDatasetImageQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetImageQuery, GetDatasetImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetImageQuery, GetDatasetImageQueryVariables>(GetDatasetImageDocument, options);
      }
export function useGetDatasetImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetImageQuery, GetDatasetImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetImageQuery, GetDatasetImageQueryVariables>(GetDatasetImageDocument, options);
        }
export type GetDatasetImageQueryHookResult = ReturnType<typeof useGetDatasetImageQuery>;
export type GetDatasetImageLazyQueryHookResult = ReturnType<typeof useGetDatasetImageLazyQuery>;
export type GetDatasetImageQueryResult = Apollo.QueryResult<GetDatasetImageQuery, GetDatasetImageQueryVariables>;
export const GetDatasetDocument = gql`
    query GetDataset($workspaceId: String!, $datasetId: String) {
  getDatasets(workspaceId: $workspaceId, datasetId: $datasetId) {
    datasetId
    files
    name
    runs
  }
}
    `;

/**
 * __useGetDatasetQuery__
 *
 * To run a query within a React component, call `useGetDatasetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetQuery, GetDatasetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetQuery, GetDatasetQueryVariables>(GetDatasetDocument, options);
      }
export function useGetDatasetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetQuery, GetDatasetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetQuery, GetDatasetQueryVariables>(GetDatasetDocument, options);
        }
export type GetDatasetQueryHookResult = ReturnType<typeof useGetDatasetQuery>;
export type GetDatasetLazyQueryHookResult = ReturnType<typeof useGetDatasetLazyQuery>;
export type GetDatasetQueryResult = Apollo.QueryResult<GetDatasetQuery, GetDatasetQueryVariables>;
export const GetWorkspaceDatasetsListDocument = gql`
    query GetWorkspaceDatasetsList($workspaceId: String!, $cursor: String, $limit: Int) {
  getDatasets(workspaceId: $workspaceId, cursor: $cursor, limit: $limit) {
    datasetId
    name
  }
}
    `;

/**
 * __useGetWorkspaceDatasetsListQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceDatasetsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceDatasetsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceDatasetsListQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetWorkspaceDatasetsListQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceDatasetsListQuery, GetWorkspaceDatasetsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceDatasetsListQuery, GetWorkspaceDatasetsListQueryVariables>(GetWorkspaceDatasetsListDocument, options);
      }
export function useGetWorkspaceDatasetsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceDatasetsListQuery, GetWorkspaceDatasetsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceDatasetsListQuery, GetWorkspaceDatasetsListQueryVariables>(GetWorkspaceDatasetsListDocument, options);
        }
export type GetWorkspaceDatasetsListQueryHookResult = ReturnType<typeof useGetWorkspaceDatasetsListQuery>;
export type GetWorkspaceDatasetsListLazyQueryHookResult = ReturnType<typeof useGetWorkspaceDatasetsListLazyQuery>;
export type GetWorkspaceDatasetsListQueryResult = Apollo.QueryResult<GetWorkspaceDatasetsListQuery, GetWorkspaceDatasetsListQueryVariables>;
export const GetGANModelsDocument = gql`
    query GetGANModels($workspaceId: String, $modelId: String, $organizationId: String, $cursor: String, $limit: Int, $filters: GANModelFilter) {
  getGANModels(
    workspaceId: $workspaceId
    modelId: $modelId
    organizationId: $organizationId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    organizationId
    modelId
    description
    flags
    name
    organization
    createdAt
    updatedAt
    tags
  }
}
    `;

/**
 * __useGetGANModelsQuery__
 *
 * To run a query within a React component, call `useGetGANModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGANModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGANModelsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *      organizationId: // value for 'organizationId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetGANModelsQuery(baseOptions?: Apollo.QueryHookOptions<GetGANModelsQuery, GetGANModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGANModelsQuery, GetGANModelsQueryVariables>(GetGANModelsDocument, options);
      }
export function useGetGANModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGANModelsQuery, GetGANModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGANModelsQuery, GetGANModelsQueryVariables>(GetGANModelsDocument, options);
        }
export type GetGANModelsQueryHookResult = ReturnType<typeof useGetGANModelsQuery>;
export type GetGANModelsLazyQueryHookResult = ReturnType<typeof useGetGANModelsLazyQuery>;
export type GetGANModelsQueryResult = Apollo.QueryResult<GetGANModelsQuery, GetGANModelsQueryVariables>;
export const GetGANDatasetLogDocument = gql`
    query GetGANDatasetLog($workspaceId: String!, $datasetId: String!) {
  getGANDatasetLog(workspaceId: $workspaceId, datasetId: $datasetId) {
    log
  }
}
    `;

/**
 * __useGetGANDatasetLogQuery__
 *
 * To run a query within a React component, call `useGetGANDatasetLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGANDatasetLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGANDatasetLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetGANDatasetLogQuery(baseOptions: Apollo.QueryHookOptions<GetGANDatasetLogQuery, GetGANDatasetLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGANDatasetLogQuery, GetGANDatasetLogQueryVariables>(GetGANDatasetLogDocument, options);
      }
export function useGetGANDatasetLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGANDatasetLogQuery, GetGANDatasetLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGANDatasetLogQuery, GetGANDatasetLogQueryVariables>(GetGANDatasetLogDocument, options);
        }
export type GetGANDatasetLogQueryHookResult = ReturnType<typeof useGetGANDatasetLogQuery>;
export type GetGANDatasetLogLazyQueryHookResult = ReturnType<typeof useGetGANDatasetLogLazyQuery>;
export type GetGANDatasetLogQueryResult = Apollo.QueryResult<GetGANDatasetLogQuery, GetGANDatasetLogQueryVariables>;
export const GetInpaintFormatsDocument = gql`
    query GetInpaintFormats {
  getInpaintFormats {
    name
    value
    info
  }
}
    `;

/**
 * __useGetInpaintFormatsQuery__
 *
 * To run a query within a React component, call `useGetInpaintFormatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInpaintFormatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInpaintFormatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInpaintFormatsQuery(baseOptions?: Apollo.QueryHookOptions<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>(GetInpaintFormatsDocument, options);
      }
export function useGetInpaintFormatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>(GetInpaintFormatsDocument, options);
        }
export type GetInpaintFormatsQueryHookResult = ReturnType<typeof useGetInpaintFormatsQuery>;
export type GetInpaintFormatsLazyQueryHookResult = ReturnType<typeof useGetInpaintFormatsLazyQuery>;
export type GetInpaintFormatsQueryResult = Apollo.QueryResult<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>;
export const GetInpaintsDocument = gql`
    query GetInpaints($volumeId: String!, $cursor: String, $limit: Int) {
  getInpaints(volumeId: $volumeId, cursor: $cursor, limit: $limit) {
    volumeId
    inpaintId
    status
    location
    destination
    inputType
    outputType
    dilation
    createdBy
    createdAt
    updatedBy
    updatedAt
  }
}
    `;

/**
 * __useGetInpaintsQuery__
 *
 * To run a query within a React component, call `useGetInpaintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInpaintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInpaintsQuery({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetInpaintsQuery(baseOptions: Apollo.QueryHookOptions<GetInpaintsQuery, GetInpaintsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInpaintsQuery, GetInpaintsQueryVariables>(GetInpaintsDocument, options);
      }
export function useGetInpaintsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInpaintsQuery, GetInpaintsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInpaintsQuery, GetInpaintsQueryVariables>(GetInpaintsDocument, options);
        }
export type GetInpaintsQueryHookResult = ReturnType<typeof useGetInpaintsQuery>;
export type GetInpaintsLazyQueryHookResult = ReturnType<typeof useGetInpaintsLazyQuery>;
export type GetInpaintsQueryResult = Apollo.QueryResult<GetInpaintsQuery, GetInpaintsQueryVariables>;
export const GetInpaintLogDocument = gql`
    query GetInpaintLog($volumeId: String!, $inpaintId: String!) {
  getInpaintLog(volumeId: $volumeId, inpaintId: $inpaintId) {
    log
  }
}
    `;

/**
 * __useGetInpaintLogQuery__
 *
 * To run a query within a React component, call `useGetInpaintLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInpaintLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInpaintLogQuery({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      inpaintId: // value for 'inpaintId'
 *   },
 * });
 */
export function useGetInpaintLogQuery(baseOptions: Apollo.QueryHookOptions<GetInpaintLogQuery, GetInpaintLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInpaintLogQuery, GetInpaintLogQueryVariables>(GetInpaintLogDocument, options);
      }
export function useGetInpaintLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInpaintLogQuery, GetInpaintLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInpaintLogQuery, GetInpaintLogQueryVariables>(GetInpaintLogDocument, options);
        }
export type GetInpaintLogQueryHookResult = ReturnType<typeof useGetInpaintLogQuery>;
export type GetInpaintLogLazyQueryHookResult = ReturnType<typeof useGetInpaintLogLazyQuery>;
export type GetInpaintLogQueryResult = Apollo.QueryResult<GetInpaintLogQuery, GetInpaintLogQueryVariables>;
export const GetInvitationsDocument = gql`
    query GetInvitations($organizationId: String!) {
  getInvitations(organizationId: $organizationId) {
    email
    organizationId
    role
    updatedAt
  }
}
    `;

/**
 * __useGetInvitationsQuery__
 *
 * To run a query within a React component, call `useGetInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetInvitationsQuery(baseOptions: Apollo.QueryHookOptions<GetInvitationsQuery, GetInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvitationsQuery, GetInvitationsQueryVariables>(GetInvitationsDocument, options);
      }
export function useGetInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvitationsQuery, GetInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvitationsQuery, GetInvitationsQueryVariables>(GetInvitationsDocument, options);
        }
export type GetInvitationsQueryHookResult = ReturnType<typeof useGetInvitationsQuery>;
export type GetInvitationsLazyQueryHookResult = ReturnType<typeof useGetInvitationsLazyQuery>;
export type GetInvitationsQueryResult = Apollo.QueryResult<GetInvitationsQuery, GetInvitationsQueryVariables>;
export const GetMembersDocument = gql`
    query GetMembers($organizationId: String!, $limit: Int, $cursor: String) {
  getMembers(organizationId: $organizationId, limit: $limit, cursor: $cursor) {
    userId
    email
    name
    role
  }
}
    `;

/**
 * __useGetMembersQuery__
 *
 * To run a query within a React component, call `useGetMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetMembersQuery(baseOptions: Apollo.QueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
      }
export function useGetMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
        }
export type GetMembersQueryHookResult = ReturnType<typeof useGetMembersQuery>;
export type GetMembersLazyQueryHookResult = ReturnType<typeof useGetMembersLazyQuery>;
export type GetMembersQueryResult = Apollo.QueryResult<GetMembersQuery, GetMembersQueryVariables>;
export const GetMLInferenceLogDocument = gql`
    query GetMLInferenceLog($workspaceId: String!, $inferenceId: String!) {
  getMLInferenceLog(workspaceId: $workspaceId, inferenceId: $inferenceId) {
    workspaceId
    inferenceId
    status
    log
  }
}
    `;

/**
 * __useGetMLInferenceLogQuery__
 *
 * To run a query within a React component, call `useGetMLInferenceLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMLInferenceLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMLInferenceLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      inferenceId: // value for 'inferenceId'
 *   },
 * });
 */
export function useGetMLInferenceLogQuery(baseOptions: Apollo.QueryHookOptions<GetMLInferenceLogQuery, GetMLInferenceLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMLInferenceLogQuery, GetMLInferenceLogQueryVariables>(GetMLInferenceLogDocument, options);
      }
export function useGetMLInferenceLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMLInferenceLogQuery, GetMLInferenceLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMLInferenceLogQuery, GetMLInferenceLogQueryVariables>(GetMLInferenceLogDocument, options);
        }
export type GetMLInferenceLogQueryHookResult = ReturnType<typeof useGetMLInferenceLogQuery>;
export type GetMLInferenceLogLazyQueryHookResult = ReturnType<typeof useGetMLInferenceLogLazyQuery>;
export type GetMLInferenceLogQueryResult = Apollo.QueryResult<GetMLInferenceLogQuery, GetMLInferenceLogQueryVariables>;
export const GetMLInferenceMetricsDocument = gql`
    query GetMLInferenceMetrics($workspaceId: String!, $inferenceId: String!) {
  getMLInferenceMetrics(workspaceId: $workspaceId, inferenceId: $inferenceId)
}
    `;

/**
 * __useGetMLInferenceMetricsQuery__
 *
 * To run a query within a React component, call `useGetMLInferenceMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMLInferenceMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMLInferenceMetricsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      inferenceId: // value for 'inferenceId'
 *   },
 * });
 */
export function useGetMLInferenceMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetMLInferenceMetricsQuery, GetMLInferenceMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMLInferenceMetricsQuery, GetMLInferenceMetricsQueryVariables>(GetMLInferenceMetricsDocument, options);
      }
export function useGetMLInferenceMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMLInferenceMetricsQuery, GetMLInferenceMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMLInferenceMetricsQuery, GetMLInferenceMetricsQueryVariables>(GetMLInferenceMetricsDocument, options);
        }
export type GetMLInferenceMetricsQueryHookResult = ReturnType<typeof useGetMLInferenceMetricsQuery>;
export type GetMLInferenceMetricsLazyQueryHookResult = ReturnType<typeof useGetMLInferenceMetricsLazyQuery>;
export type GetMLInferenceMetricsQueryResult = Apollo.QueryResult<GetMLInferenceMetricsQuery, GetMLInferenceMetricsQueryVariables>;
export const GetMLArchitecturesDocument = gql`
    query GetMLArchitectures {
  getMLArchitectures {
    architectureId
    name
    description
    annotations
    hyperparameters {
      name
      field
      type
      description
      default
      min
      max
      step
      options
    }
  }
}
    `;

/**
 * __useGetMLArchitecturesQuery__
 *
 * To run a query within a React component, call `useGetMLArchitecturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMLArchitecturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMLArchitecturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMLArchitecturesQuery(baseOptions?: Apollo.QueryHookOptions<GetMLArchitecturesQuery, GetMLArchitecturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMLArchitecturesQuery, GetMLArchitecturesQueryVariables>(GetMLArchitecturesDocument, options);
      }
export function useGetMLArchitecturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMLArchitecturesQuery, GetMLArchitecturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMLArchitecturesQuery, GetMLArchitecturesQueryVariables>(GetMLArchitecturesDocument, options);
        }
export type GetMLArchitecturesQueryHookResult = ReturnType<typeof useGetMLArchitecturesQuery>;
export type GetMLArchitecturesLazyQueryHookResult = ReturnType<typeof useGetMLArchitecturesLazyQuery>;
export type GetMLArchitecturesQueryResult = Apollo.QueryResult<GetMLArchitecturesQuery, GetMLArchitecturesQueryVariables>;
export const GetMLModelDocument = gql`
    query GetMLModel($workspaceId: String!, $modelId: String!) {
  getMLModels(workspaceId: $workspaceId, modelId: $modelId) {
    architecture
    architectureId
    checkpoints
    dataset
    datasetId
    description
    metrics
    modelId
    name
    parameters
    status
    tags
  }
}
    `;

/**
 * __useGetMLModelQuery__
 *
 * To run a query within a React component, call `useGetMLModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMLModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMLModelQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useGetMLModelQuery(baseOptions: Apollo.QueryHookOptions<GetMLModelQuery, GetMLModelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMLModelQuery, GetMLModelQueryVariables>(GetMLModelDocument, options);
      }
export function useGetMLModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMLModelQuery, GetMLModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMLModelQuery, GetMLModelQueryVariables>(GetMLModelDocument, options);
        }
export type GetMLModelQueryHookResult = ReturnType<typeof useGetMLModelQuery>;
export type GetMLModelLazyQueryHookResult = ReturnType<typeof useGetMLModelLazyQuery>;
export type GetMLModelQueryResult = Apollo.QueryResult<GetMLModelQuery, GetMLModelQueryVariables>;
export const GetMLModelLogDocument = gql`
    query GetMLModelLog($workspaceId: String!, $modelId: String!) {
  getMLModelLog(workspaceId: $workspaceId, modelId: $modelId) {
    log
  }
}
    `;

/**
 * __useGetMLModelLogQuery__
 *
 * To run a query within a React component, call `useGetMLModelLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMLModelLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMLModelLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useGetMLModelLogQuery(baseOptions: Apollo.QueryHookOptions<GetMLModelLogQuery, GetMLModelLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMLModelLogQuery, GetMLModelLogQueryVariables>(GetMLModelLogDocument, options);
      }
export function useGetMLModelLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMLModelLogQuery, GetMLModelLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMLModelLogQuery, GetMLModelLogQueryVariables>(GetMLModelLogDocument, options);
        }
export type GetMLModelLogQueryHookResult = ReturnType<typeof useGetMLModelLogQuery>;
export type GetMLModelLogLazyQueryHookResult = ReturnType<typeof useGetMLModelLogLazyQuery>;
export type GetMLModelLogQueryResult = Apollo.QueryResult<GetMLModelLogQuery, GetMLModelLogQueryVariables>;
export const AddMemberDocument = gql`
    mutation AddMember($organizationId: String, $email: String!, $role: String) {
  addMember(organizationId: $organizationId, email: $email, role: $role)
}
    `;
export type AddMemberMutationFn = Apollo.MutationFunction<AddMemberMutation, AddMemberMutationVariables>;

/**
 * __useAddMemberMutation__
 *
 * To run a mutation, you first call `useAddMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMemberMutation, { data, loading, error }] = useAddMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAddMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddMemberMutation, AddMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMemberMutation, AddMemberMutationVariables>(AddMemberDocument, options);
      }
export type AddMemberMutationHookResult = ReturnType<typeof useAddMemberMutation>;
export type AddMemberMutationResult = Apollo.MutationResult<AddMemberMutation>;
export type AddMemberMutationOptions = Apollo.BaseMutationOptions<AddMemberMutation, AddMemberMutationVariables>;
export const ClearDatasetJobsDocument = gql`
    mutation ClearDatasetJobs($organizationId: String, $workspaceId: String, $datasetId: String) {
  clearDatasetJobs(
    organizationId: $organizationId
    workspaceId: $workspaceId
    datasetId: $datasetId
  )
}
    `;
export type ClearDatasetJobsMutationFn = Apollo.MutationFunction<ClearDatasetJobsMutation, ClearDatasetJobsMutationVariables>;

/**
 * __useClearDatasetJobsMutation__
 *
 * To run a mutation, you first call `useClearDatasetJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearDatasetJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearDatasetJobsMutation, { data, loading, error }] = useClearDatasetJobsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useClearDatasetJobsMutation(baseOptions?: Apollo.MutationHookOptions<ClearDatasetJobsMutation, ClearDatasetJobsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearDatasetJobsMutation, ClearDatasetJobsMutationVariables>(ClearDatasetJobsDocument, options);
      }
export type ClearDatasetJobsMutationHookResult = ReturnType<typeof useClearDatasetJobsMutation>;
export type ClearDatasetJobsMutationResult = Apollo.MutationResult<ClearDatasetJobsMutation>;
export type ClearDatasetJobsMutationOptions = Apollo.BaseMutationOptions<ClearDatasetJobsMutation, ClearDatasetJobsMutationVariables>;
export const CreateAPIKeyDocument = gql`
    mutation CreateAPIKey($name: String!, $scope: String, $organizationId: String, $workspaceId: String, $expiresAt: String) {
  createAPIKey(
    name: $name
    scope: $scope
    organizationId: $organizationId
    workspaceId: $workspaceId
    expiresAt: $expiresAt
  )
}
    `;
export type CreateAPIKeyMutationFn = Apollo.MutationFunction<CreateAPIKeyMutation, CreateAPIKeyMutationVariables>;

/**
 * __useCreateAPIKeyMutation__
 *
 * To run a mutation, you first call `useCreateAPIKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAPIKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateAPIKeyMutation({
 *   variables: {
 *      name: // value for 'name'
 *      scope: // value for 'scope'
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useCreateAPIKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateAPIKeyMutation, CreateAPIKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAPIKeyMutation, CreateAPIKeyMutationVariables>(CreateAPIKeyDocument, options);
      }
export type CreateAPIKeyMutationHookResult = ReturnType<typeof useCreateAPIKeyMutation>;
export type CreateAPIKeyMutationResult = Apollo.MutationResult<CreateAPIKeyMutation>;
export type CreateAPIKeyMutationOptions = Apollo.BaseMutationOptions<CreateAPIKeyMutation, CreateAPIKeyMutationVariables>;
export const CreateAnalyticsDocument = gql`
    mutation CreateAnalytics($workspaceId: String!, $datasetId: String!, $type: String!, $tags: [String]) {
  createAnalytics(
    workspaceId: $workspaceId
    datasetId: $datasetId
    type: $type
    tags: $tags
  )
}
    `;
export type CreateAnalyticsMutationFn = Apollo.MutationFunction<CreateAnalyticsMutation, CreateAnalyticsMutationVariables>;

/**
 * __useCreateAnalyticsMutation__
 *
 * To run a mutation, you first call `useCreateAnalyticsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnalyticsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnalyticsMutation, { data, loading, error }] = useCreateAnalyticsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      type: // value for 'type'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateAnalyticsMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnalyticsMutation, CreateAnalyticsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnalyticsMutation, CreateAnalyticsMutationVariables>(CreateAnalyticsDocument, options);
      }
export type CreateAnalyticsMutationHookResult = ReturnType<typeof useCreateAnalyticsMutation>;
export type CreateAnalyticsMutationResult = Apollo.MutationResult<CreateAnalyticsMutation>;
export type CreateAnalyticsMutationOptions = Apollo.BaseMutationOptions<CreateAnalyticsMutation, CreateAnalyticsMutationVariables>;
export const CreateAnnotationDocument = gql`
    mutation CreateAnnotation($workspaceId: String!, $datasetId: String!, $format: String!, $mapId: String, $tags: [String]) {
  createAnnotation(
    workspaceId: $workspaceId
    datasetId: $datasetId
    format: $format
    mapId: $mapId
    tags: $tags
  )
}
    `;
export type CreateAnnotationMutationFn = Apollo.MutationFunction<CreateAnnotationMutation, CreateAnnotationMutationVariables>;

/**
 * __useCreateAnnotationMutation__
 *
 * To run a mutation, you first call `useCreateAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnotationMutation, { data, loading, error }] = useCreateAnnotationMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      format: // value for 'format'
 *      mapId: // value for 'mapId'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateAnnotationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnnotationMutation, CreateAnnotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnnotationMutation, CreateAnnotationMutationVariables>(CreateAnnotationDocument, options);
      }
export type CreateAnnotationMutationHookResult = ReturnType<typeof useCreateAnnotationMutation>;
export type CreateAnnotationMutationResult = Apollo.MutationResult<CreateAnnotationMutation>;
export type CreateAnnotationMutationOptions = Apollo.BaseMutationOptions<CreateAnnotationMutation, CreateAnnotationMutationVariables>;
export const CreateChannelDocument = gql`
    mutation CreateChannel($organizationId: String!, $name: String!, $description: String, $volumes: [String], $instance: String, $timeout: Int, $interfaceVersion: Int, $tags: [String]) {
  createChannel(
    organizationId: $organizationId
    name: $name
    description: $description
    volumes: $volumes
    instance: $instance
    timeout: $timeout
    interfaceVersion: $interfaceVersion
    tags: $tags
  )
}
    `;
export type CreateChannelMutationFn = Apollo.MutationFunction<CreateChannelMutation, CreateChannelMutationVariables>;

/**
 * __useCreateChannelMutation__
 *
 * To run a mutation, you first call `useCreateChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChannelMutation, { data, loading, error }] = useCreateChannelMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      volumes: // value for 'volumes'
 *      instance: // value for 'instance'
 *      timeout: // value for 'timeout'
 *      interfaceVersion: // value for 'interfaceVersion'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateChannelMutation(baseOptions?: Apollo.MutationHookOptions<CreateChannelMutation, CreateChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChannelMutation, CreateChannelMutationVariables>(CreateChannelDocument, options);
      }
export type CreateChannelMutationHookResult = ReturnType<typeof useCreateChannelMutation>;
export type CreateChannelMutationResult = Apollo.MutationResult<CreateChannelMutation>;
export type CreateChannelMutationOptions = Apollo.BaseMutationOptions<CreateChannelMutation, CreateChannelMutationVariables>;
export const CreateDatasetDocument = gql`
    mutation CreateDataset($workspaceId: String!, $graphId: String!, $name: String!, $description: String, $runs: Int, $priority: Int, $seed: Int, $tags: [String], $instanceType: String) {
  createDataset(
    workspaceId: $workspaceId
    graphId: $graphId
    name: $name
    description: $description
    runs: $runs
    priority: $priority
    seed: $seed
    tags: $tags
    instanceType: $instanceType
  )
}
    `;
export type CreateDatasetMutationFn = Apollo.MutationFunction<CreateDatasetMutation, CreateDatasetMutationVariables>;

/**
 * __useCreateDatasetMutation__
 *
 * To run a mutation, you first call `useCreateDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDatasetMutation, { data, loading, error }] = useCreateDatasetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      runs: // value for 'runs'
 *      priority: // value for 'priority'
 *      seed: // value for 'seed'
 *      tags: // value for 'tags'
 *      instanceType: // value for 'instanceType'
 *   },
 * });
 */
export function useCreateDatasetMutation(baseOptions?: Apollo.MutationHookOptions<CreateDatasetMutation, CreateDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDatasetMutation, CreateDatasetMutationVariables>(CreateDatasetDocument, options);
      }
export type CreateDatasetMutationHookResult = ReturnType<typeof useCreateDatasetMutation>;
export type CreateDatasetMutationResult = Apollo.MutationResult<CreateDatasetMutation>;
export type CreateDatasetMutationOptions = Apollo.BaseMutationOptions<CreateDatasetMutation, CreateDatasetMutationVariables>;
export const CreateFeedbackDocument = gql`
    mutation CreateFeedback($summary: String!, $description: String!, $files: [String]!) {
  createFeedback(summary: $summary, description: $description, files: $files) {
    feedbackId
    uploads {
      key
      url
    }
  }
}
    `;
export type CreateFeedbackMutationFn = Apollo.MutationFunction<CreateFeedbackMutation, CreateFeedbackMutationVariables>;

/**
 * __useCreateFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackMutation, { data, loading, error }] = useCreateFeedbackMutation({
 *   variables: {
 *      summary: // value for 'summary'
 *      description: // value for 'description'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useCreateFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedbackMutation, CreateFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedbackMutation, CreateFeedbackMutationVariables>(CreateFeedbackDocument, options);
      }
export type CreateFeedbackMutationHookResult = ReturnType<typeof useCreateFeedbackMutation>;
export type CreateFeedbackMutationResult = Apollo.MutationResult<CreateFeedbackMutation>;
export type CreateFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateFeedbackMutation, CreateFeedbackMutationVariables>;
export const CreateGANDatasetDocument = gql`
    mutation CreateGANDataset($workspaceId: String!, $datasetId: String!, $modelId: String!, $name: String!, $description: String, $tags: [String]) {
  createGANDataset(
    workspaceId: $workspaceId
    datasetId: $datasetId
    modelId: $modelId
    name: $name
    description: $description
    tags: $tags
  )
}
    `;
export type CreateGANDatasetMutationFn = Apollo.MutationFunction<CreateGANDatasetMutation, CreateGANDatasetMutationVariables>;

/**
 * __useCreateGANDatasetMutation__
 *
 * To run a mutation, you first call `useCreateGANDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGANDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGanDatasetMutation, { data, loading, error }] = useCreateGANDatasetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      modelId: // value for 'modelId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateGANDatasetMutation(baseOptions?: Apollo.MutationHookOptions<CreateGANDatasetMutation, CreateGANDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGANDatasetMutation, CreateGANDatasetMutationVariables>(CreateGANDatasetDocument, options);
      }
export type CreateGANDatasetMutationHookResult = ReturnType<typeof useCreateGANDatasetMutation>;
export type CreateGANDatasetMutationResult = Apollo.MutationResult<CreateGANDatasetMutation>;
export type CreateGANDatasetMutationOptions = Apollo.BaseMutationOptions<CreateGANDatasetMutation, CreateGANDatasetMutationVariables>;
export const CreateGraphDocument = gql`
    mutation CreateGraph($workspaceId: String!, $channelId: String!, $graph: String!, $name: String!, $description: String, $staged: Boolean, $tags: [String]) {
  createGraph(
    workspaceId: $workspaceId
    channelId: $channelId
    graph: $graph
    name: $name
    description: $description
    staged: $staged
    tags: $tags
  )
}
    `;
export type CreateGraphMutationFn = Apollo.MutationFunction<CreateGraphMutation, CreateGraphMutationVariables>;

/**
 * __useCreateGraphMutation__
 *
 * To run a mutation, you first call `useCreateGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGraphMutation, { data, loading, error }] = useCreateGraphMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      channelId: // value for 'channelId'
 *      graph: // value for 'graph'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      staged: // value for 'staged'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateGraphMutation(baseOptions?: Apollo.MutationHookOptions<CreateGraphMutation, CreateGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGraphMutation, CreateGraphMutationVariables>(CreateGraphDocument, options);
      }
export type CreateGraphMutationHookResult = ReturnType<typeof useCreateGraphMutation>;
export type CreateGraphMutationResult = Apollo.MutationResult<CreateGraphMutation>;
export type CreateGraphMutationOptions = Apollo.BaseMutationOptions<CreateGraphMutation, CreateGraphMutationVariables>;
export const CreateInpaintDocument = gql`
    mutation CreateInpaint($volumeId: String!, $location: String!, $files: [String], $destination: String, $dilation: Int, $inputType: InpaintInputType, $outputType: InpaintOutputType) {
  createInpaint(
    volumeId: $volumeId
    location: $location
    files: $files
    destination: $destination
    dilation: $dilation
    inputType: $inputType
    outputType: $outputType
  )
}
    `;
export type CreateInpaintMutationFn = Apollo.MutationFunction<CreateInpaintMutation, CreateInpaintMutationVariables>;

/**
 * __useCreateInpaintMutation__
 *
 * To run a mutation, you first call `useCreateInpaintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInpaintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInpaintMutation, { data, loading, error }] = useCreateInpaintMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      location: // value for 'location'
 *      files: // value for 'files'
 *      destination: // value for 'destination'
 *      dilation: // value for 'dilation'
 *      inputType: // value for 'inputType'
 *      outputType: // value for 'outputType'
 *   },
 * });
 */
export function useCreateInpaintMutation(baseOptions?: Apollo.MutationHookOptions<CreateInpaintMutation, CreateInpaintMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInpaintMutation, CreateInpaintMutationVariables>(CreateInpaintDocument, options);
      }
export type CreateInpaintMutationHookResult = ReturnType<typeof useCreateInpaintMutation>;
export type CreateInpaintMutationResult = Apollo.MutationResult<CreateInpaintMutation>;
export type CreateInpaintMutationOptions = Apollo.BaseMutationOptions<CreateInpaintMutation, CreateInpaintMutationVariables>;
export const CreateMLInferenceDocument = gql`
    mutation CreateMLInference($workspaceId: String!, $datasetId: String!, $modelId: String!, $mapId: String, $tags: [String]) {
  createMLInference(
    workspaceId: $workspaceId
    datasetId: $datasetId
    modelId: $modelId
    mapId: $mapId
    tags: $tags
  )
}
    `;
export type CreateMLInferenceMutationFn = Apollo.MutationFunction<CreateMLInferenceMutation, CreateMLInferenceMutationVariables>;

/**
 * __useCreateMLInferenceMutation__
 *
 * To run a mutation, you first call `useCreateMLInferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMLInferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMlInferenceMutation, { data, loading, error }] = useCreateMLInferenceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      modelId: // value for 'modelId'
 *      mapId: // value for 'mapId'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateMLInferenceMutation(baseOptions?: Apollo.MutationHookOptions<CreateMLInferenceMutation, CreateMLInferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMLInferenceMutation, CreateMLInferenceMutationVariables>(CreateMLInferenceDocument, options);
      }
export type CreateMLInferenceMutationHookResult = ReturnType<typeof useCreateMLInferenceMutation>;
export type CreateMLInferenceMutationResult = Apollo.MutationResult<CreateMLInferenceMutation>;
export type CreateMLInferenceMutationOptions = Apollo.BaseMutationOptions<CreateMLInferenceMutation, CreateMLInferenceMutationVariables>;
export const CreateMLModelDocument = gql`
    mutation CreateMLModel($workspaceId: String!, $datasetId: String!, $architectureId: String!, $name: String, $description: String, $parameters: String, $tags: [String]) {
  createMLModel(
    workspaceId: $workspaceId
    datasetId: $datasetId
    architectureId: $architectureId
    name: $name
    description: $description
    parameters: $parameters
    tags: $tags
  )
}
    `;
export type CreateMLModelMutationFn = Apollo.MutationFunction<CreateMLModelMutation, CreateMLModelMutationVariables>;

/**
 * __useCreateMLModelMutation__
 *
 * To run a mutation, you first call `useCreateMLModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMLModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMlModelMutation, { data, loading, error }] = useCreateMLModelMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      architectureId: // value for 'architectureId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      parameters: // value for 'parameters'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateMLModelMutation(baseOptions?: Apollo.MutationHookOptions<CreateMLModelMutation, CreateMLModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMLModelMutation, CreateMLModelMutationVariables>(CreateMLModelDocument, options);
      }
export type CreateMLModelMutationHookResult = ReturnType<typeof useCreateMLModelMutation>;
export type CreateMLModelMutationResult = Apollo.MutationResult<CreateMLModelMutation>;
export type CreateMLModelMutationOptions = Apollo.BaseMutationOptions<CreateMLModelMutation, CreateMLModelMutationVariables>;
export const CreateMixedDatasetDocument = gql`
    mutation CreateMixedDataset($workspaceId: String!, $name: String!, $parameters: String!, $description: String, $seed: Int, $tags: [String]) {
  createMixedDataset(
    workspaceId: $workspaceId
    name: $name
    parameters: $parameters
    description: $description
    seed: $seed
    tags: $tags
  )
}
    `;
export type CreateMixedDatasetMutationFn = Apollo.MutationFunction<CreateMixedDatasetMutation, CreateMixedDatasetMutationVariables>;

/**
 * __useCreateMixedDatasetMutation__
 *
 * To run a mutation, you first call `useCreateMixedDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMixedDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMixedDatasetMutation, { data, loading, error }] = useCreateMixedDatasetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      name: // value for 'name'
 *      parameters: // value for 'parameters'
 *      description: // value for 'description'
 *      seed: // value for 'seed'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateMixedDatasetMutation(baseOptions?: Apollo.MutationHookOptions<CreateMixedDatasetMutation, CreateMixedDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMixedDatasetMutation, CreateMixedDatasetMutationVariables>(CreateMixedDatasetDocument, options);
      }
export type CreateMixedDatasetMutationHookResult = ReturnType<typeof useCreateMixedDatasetMutation>;
export type CreateMixedDatasetMutationResult = Apollo.MutationResult<CreateMixedDatasetMutation>;
export type CreateMixedDatasetMutationOptions = Apollo.BaseMutationOptions<CreateMixedDatasetMutation, CreateMixedDatasetMutationVariables>;
export const CreatePreviewDocument = gql`
    mutation CreatePreview($workspaceId: String!, $graphId: String!) {
  createPreview(workspaceId: $workspaceId, graphId: $graphId)
}
    `;
export type CreatePreviewMutationFn = Apollo.MutationFunction<CreatePreviewMutation, CreatePreviewMutationVariables>;

/**
 * __useCreatePreviewMutation__
 *
 * To run a mutation, you first call `useCreatePreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPreviewMutation, { data, loading, error }] = useCreatePreviewMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *   },
 * });
 */
export function useCreatePreviewMutation(baseOptions?: Apollo.MutationHookOptions<CreatePreviewMutation, CreatePreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePreviewMutation, CreatePreviewMutationVariables>(CreatePreviewDocument, options);
      }
export type CreatePreviewMutationHookResult = ReturnType<typeof useCreatePreviewMutation>;
export type CreatePreviewMutationResult = Apollo.MutationResult<CreatePreviewMutation>;
export type CreatePreviewMutationOptions = Apollo.BaseMutationOptions<CreatePreviewMutation, CreatePreviewMutationVariables>;
export const CreateRemoteDevelopmentDocument = gql`
    mutation CreateRemoteDevelopment($channelId: String!, $channelVersion: String, $instanceType: String) {
  createRemoteDevelopment(
    channelId: $channelId
    channelVersion: $channelVersion
    instanceType: $instanceType
  ) {
    editorSessionId
    editorUrl
  }
}
    `;
export type CreateRemoteDevelopmentMutationFn = Apollo.MutationFunction<CreateRemoteDevelopmentMutation, CreateRemoteDevelopmentMutationVariables>;

/**
 * __useCreateRemoteDevelopmentMutation__
 *
 * To run a mutation, you first call `useCreateRemoteDevelopmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRemoteDevelopmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRemoteDevelopmentMutation, { data, loading, error }] = useCreateRemoteDevelopmentMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      channelVersion: // value for 'channelVersion'
 *      instanceType: // value for 'instanceType'
 *   },
 * });
 */
export function useCreateRemoteDevelopmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateRemoteDevelopmentMutation, CreateRemoteDevelopmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRemoteDevelopmentMutation, CreateRemoteDevelopmentMutationVariables>(CreateRemoteDevelopmentDocument, options);
      }
export type CreateRemoteDevelopmentMutationHookResult = ReturnType<typeof useCreateRemoteDevelopmentMutation>;
export type CreateRemoteDevelopmentMutationResult = Apollo.MutationResult<CreateRemoteDevelopmentMutation>;
export type CreateRemoteDevelopmentMutationOptions = Apollo.BaseMutationOptions<CreateRemoteDevelopmentMutation, CreateRemoteDevelopmentMutationVariables>;
export const CreateSSHKeyDocument = gql`
    mutation CreateSSHKey($name: String!, $key: String!) {
  createSSHKey(name: $name, key: $key)
}
    `;
export type CreateSSHKeyMutationFn = Apollo.MutationFunction<CreateSSHKeyMutation, CreateSSHKeyMutationVariables>;

/**
 * __useCreateSSHKeyMutation__
 *
 * To run a mutation, you first call `useCreateSSHKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSSHKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSshKeyMutation, { data, loading, error }] = useCreateSSHKeyMutation({
 *   variables: {
 *      name: // value for 'name'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useCreateSSHKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateSSHKeyMutation, CreateSSHKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSSHKeyMutation, CreateSSHKeyMutationVariables>(CreateSSHKeyDocument, options);
      }
export type CreateSSHKeyMutationHookResult = ReturnType<typeof useCreateSSHKeyMutation>;
export type CreateSSHKeyMutationResult = Apollo.MutationResult<CreateSSHKeyMutation>;
export type CreateSSHKeyMutationOptions = Apollo.BaseMutationOptions<CreateSSHKeyMutation, CreateSSHKeyMutationVariables>;
export const CreateUMAPDocument = gql`
    mutation CreateUMAP($workspaceId: String!, $datasetIds: [String]!, $samples: [Int]!, $seed: String, $name: String, $description: String, $tags: [String]) {
  createUMAP(
    workspaceId: $workspaceId
    datasetIds: $datasetIds
    samples: $samples
    seed: $seed
    name: $name
    description: $description
    tags: $tags
  )
}
    `;
export type CreateUMAPMutationFn = Apollo.MutationFunction<CreateUMAPMutation, CreateUMAPMutationVariables>;

/**
 * __useCreateUMAPMutation__
 *
 * To run a mutation, you first call `useCreateUMAPMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUMAPMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUmapMutation, { data, loading, error }] = useCreateUMAPMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetIds: // value for 'datasetIds'
 *      samples: // value for 'samples'
 *      seed: // value for 'seed'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateUMAPMutation(baseOptions?: Apollo.MutationHookOptions<CreateUMAPMutation, CreateUMAPMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUMAPMutation, CreateUMAPMutationVariables>(CreateUMAPDocument, options);
      }
export type CreateUMAPMutationHookResult = ReturnType<typeof useCreateUMAPMutation>;
export type CreateUMAPMutationResult = Apollo.MutationResult<CreateUMAPMutation>;
export type CreateUMAPMutationOptions = Apollo.BaseMutationOptions<CreateUMAPMutation, CreateUMAPMutationVariables>;
export const CreateVolumeDocument = gql`
    mutation CreateVolume($organizationId: String!, $name: String!, $description: String, $permission: String, $tags: [String]) {
  createVolume(
    organizationId: $organizationId
    name: $name
    description: $description
    permission: $permission
    tags: $tags
  )
}
    `;
export type CreateVolumeMutationFn = Apollo.MutationFunction<CreateVolumeMutation, CreateVolumeMutationVariables>;

/**
 * __useCreateVolumeMutation__
 *
 * To run a mutation, you first call `useCreateVolumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVolumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVolumeMutation, { data, loading, error }] = useCreateVolumeMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      permission: // value for 'permission'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateVolumeMutation(baseOptions?: Apollo.MutationHookOptions<CreateVolumeMutation, CreateVolumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVolumeMutation, CreateVolumeMutationVariables>(CreateVolumeDocument, options);
      }
export type CreateVolumeMutationHookResult = ReturnType<typeof useCreateVolumeMutation>;
export type CreateVolumeMutationResult = Apollo.MutationResult<CreateVolumeMutation>;
export type CreateVolumeMutationOptions = Apollo.BaseMutationOptions<CreateVolumeMutation, CreateVolumeMutationVariables>;
export const CreateWorkspaceDocument = gql`
    mutation CreateWorkspace($organizationId: String!, $name: String!, $description: String, $channelIds: [String]!, $volumeIds: [String]!, $code: String, $tags: [String]) {
  createWorkspace(
    organizationId: $organizationId
    name: $name
    description: $description
    channelIds: $channelIds
    volumeIds: $volumeIds
    code: $code
    tags: $tags
  )
}
    `;
export type CreateWorkspaceMutationFn = Apollo.MutationFunction<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;

/**
 * __useCreateWorkspaceMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceMutation, { data, loading, error }] = useCreateWorkspaceMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      channelIds: // value for 'channelIds'
 *      volumeIds: // value for 'volumeIds'
 *      code: // value for 'code'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>(CreateWorkspaceDocument, options);
      }
export type CreateWorkspaceMutationHookResult = ReturnType<typeof useCreateWorkspaceMutation>;
export type CreateWorkspaceMutationResult = Apollo.MutationResult<CreateWorkspaceMutation>;
export type CreateWorkspaceMutationOptions = Apollo.BaseMutationOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;
export const DeleteAPIKeyDocument = gql`
    mutation DeleteAPIKey($name: String!) {
  deleteAPIKey(name: $name)
}
    `;
export type DeleteAPIKeyMutationFn = Apollo.MutationFunction<DeleteAPIKeyMutation, DeleteAPIKeyMutationVariables>;

/**
 * __useDeleteAPIKeyMutation__
 *
 * To run a mutation, you first call `useDeleteAPIKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAPIKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiKeyMutation, { data, loading, error }] = useDeleteAPIKeyMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteAPIKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAPIKeyMutation, DeleteAPIKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAPIKeyMutation, DeleteAPIKeyMutationVariables>(DeleteAPIKeyDocument, options);
      }
export type DeleteAPIKeyMutationHookResult = ReturnType<typeof useDeleteAPIKeyMutation>;
export type DeleteAPIKeyMutationResult = Apollo.MutationResult<DeleteAPIKeyMutation>;
export type DeleteAPIKeyMutationOptions = Apollo.BaseMutationOptions<DeleteAPIKeyMutation, DeleteAPIKeyMutationVariables>;
export const DeleteAnalyticsDocument = gql`
    mutation DeleteAnalytics($workspaceId: String!, $analyticsId: String!) {
  deleteAnalytics(workspaceId: $workspaceId, analyticsId: $analyticsId)
}
    `;
export type DeleteAnalyticsMutationFn = Apollo.MutationFunction<DeleteAnalyticsMutation, DeleteAnalyticsMutationVariables>;

/**
 * __useDeleteAnalyticsMutation__
 *
 * To run a mutation, you first call `useDeleteAnalyticsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnalyticsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnalyticsMutation, { data, loading, error }] = useDeleteAnalyticsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      analyticsId: // value for 'analyticsId'
 *   },
 * });
 */
export function useDeleteAnalyticsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnalyticsMutation, DeleteAnalyticsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnalyticsMutation, DeleteAnalyticsMutationVariables>(DeleteAnalyticsDocument, options);
      }
export type DeleteAnalyticsMutationHookResult = ReturnType<typeof useDeleteAnalyticsMutation>;
export type DeleteAnalyticsMutationResult = Apollo.MutationResult<DeleteAnalyticsMutation>;
export type DeleteAnalyticsMutationOptions = Apollo.BaseMutationOptions<DeleteAnalyticsMutation, DeleteAnalyticsMutationVariables>;
export const DeleteAnnotationDocument = gql`
    mutation DeleteAnnotation($annotationId: String!, $workspaceId: String!) {
  deleteAnnotation(annotationId: $annotationId, workspaceId: $workspaceId)
}
    `;
export type DeleteAnnotationMutationFn = Apollo.MutationFunction<DeleteAnnotationMutation, DeleteAnnotationMutationVariables>;

/**
 * __useDeleteAnnotationMutation__
 *
 * To run a mutation, you first call `useDeleteAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnnotationMutation, { data, loading, error }] = useDeleteAnnotationMutation({
 *   variables: {
 *      annotationId: // value for 'annotationId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteAnnotationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnnotationMutation, DeleteAnnotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnnotationMutation, DeleteAnnotationMutationVariables>(DeleteAnnotationDocument, options);
      }
export type DeleteAnnotationMutationHookResult = ReturnType<typeof useDeleteAnnotationMutation>;
export type DeleteAnnotationMutationResult = Apollo.MutationResult<DeleteAnnotationMutation>;
export type DeleteAnnotationMutationOptions = Apollo.BaseMutationOptions<DeleteAnnotationMutation, DeleteAnnotationMutationVariables>;
export const DeleteAnnotationMapDocument = gql`
    mutation DeleteAnnotationMap($mapId: String!, $organizationId: String) {
  deleteAnnotationMap(mapId: $mapId, organizationId: $organizationId)
}
    `;
export type DeleteAnnotationMapMutationFn = Apollo.MutationFunction<DeleteAnnotationMapMutation, DeleteAnnotationMapMutationVariables>;

/**
 * __useDeleteAnnotationMapMutation__
 *
 * To run a mutation, you first call `useDeleteAnnotationMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnnotationMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnnotationMapMutation, { data, loading, error }] = useDeleteAnnotationMapMutation({
 *   variables: {
 *      mapId: // value for 'mapId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteAnnotationMapMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnnotationMapMutation, DeleteAnnotationMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnnotationMapMutation, DeleteAnnotationMapMutationVariables>(DeleteAnnotationMapDocument, options);
      }
export type DeleteAnnotationMapMutationHookResult = ReturnType<typeof useDeleteAnnotationMapMutation>;
export type DeleteAnnotationMapMutationResult = Apollo.MutationResult<DeleteAnnotationMapMutation>;
export type DeleteAnnotationMapMutationOptions = Apollo.BaseMutationOptions<DeleteAnnotationMapMutation, DeleteAnnotationMapMutationVariables>;
export const DeleteChannelDocument = gql`
    mutation DeleteChannel($channelId: String!, $organizationId: String) {
  deleteChannel(channelId: $channelId, organizationId: $organizationId)
}
    `;
export type DeleteChannelMutationFn = Apollo.MutationFunction<DeleteChannelMutation, DeleteChannelMutationVariables>;

/**
 * __useDeleteChannelMutation__
 *
 * To run a mutation, you first call `useDeleteChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChannelMutation, { data, loading, error }] = useDeleteChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteChannelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChannelMutation, DeleteChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChannelMutation, DeleteChannelMutationVariables>(DeleteChannelDocument, options);
      }
export type DeleteChannelMutationHookResult = ReturnType<typeof useDeleteChannelMutation>;
export type DeleteChannelMutationResult = Apollo.MutationResult<DeleteChannelMutation>;
export type DeleteChannelMutationOptions = Apollo.BaseMutationOptions<DeleteChannelMutation, DeleteChannelMutationVariables>;
export const DeleteDatasetDocument = gql`
    mutation DeleteDataset($datasetId: String!, $workspaceId: String!) {
  deleteDataset(datasetId: $datasetId, workspaceId: $workspaceId)
}
    `;
export type DeleteDatasetMutationFn = Apollo.MutationFunction<DeleteDatasetMutation, DeleteDatasetMutationVariables>;

/**
 * __useDeleteDatasetMutation__
 *
 * To run a mutation, you first call `useDeleteDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDatasetMutation, { data, loading, error }] = useDeleteDatasetMutation({
 *   variables: {
 *      datasetId: // value for 'datasetId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteDatasetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDatasetMutation, DeleteDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDatasetMutation, DeleteDatasetMutationVariables>(DeleteDatasetDocument, options);
      }
export type DeleteDatasetMutationHookResult = ReturnType<typeof useDeleteDatasetMutation>;
export type DeleteDatasetMutationResult = Apollo.MutationResult<DeleteDatasetMutation>;
export type DeleteDatasetMutationOptions = Apollo.BaseMutationOptions<DeleteDatasetMutation, DeleteDatasetMutationVariables>;
export const DeleteGANDatasetDocument = gql`
    mutation DeleteGANDataset($workspaceId: String!, $datasetId: String!) {
  deleteGANDataset(workspaceId: $workspaceId, datasetId: $datasetId)
}
    `;
export type DeleteGANDatasetMutationFn = Apollo.MutationFunction<DeleteGANDatasetMutation, DeleteGANDatasetMutationVariables>;

/**
 * __useDeleteGANDatasetMutation__
 *
 * To run a mutation, you first call `useDeleteGANDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGANDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGanDatasetMutation, { data, loading, error }] = useDeleteGANDatasetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useDeleteGANDatasetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGANDatasetMutation, DeleteGANDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGANDatasetMutation, DeleteGANDatasetMutationVariables>(DeleteGANDatasetDocument, options);
      }
export type DeleteGANDatasetMutationHookResult = ReturnType<typeof useDeleteGANDatasetMutation>;
export type DeleteGANDatasetMutationResult = Apollo.MutationResult<DeleteGANDatasetMutation>;
export type DeleteGANDatasetMutationOptions = Apollo.BaseMutationOptions<DeleteGANDatasetMutation, DeleteGANDatasetMutationVariables>;
export const DeleteGANModelDocument = gql`
    mutation DeleteGANModel($modelId: String!, $organizationId: String) {
  deleteGANModel(modelId: $modelId, organizationId: $organizationId)
}
    `;
export type DeleteGANModelMutationFn = Apollo.MutationFunction<DeleteGANModelMutation, DeleteGANModelMutationVariables>;

/**
 * __useDeleteGANModelMutation__
 *
 * To run a mutation, you first call `useDeleteGANModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGANModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGanModelMutation, { data, loading, error }] = useDeleteGANModelMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteGANModelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGANModelMutation, DeleteGANModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGANModelMutation, DeleteGANModelMutationVariables>(DeleteGANModelDocument, options);
      }
export type DeleteGANModelMutationHookResult = ReturnType<typeof useDeleteGANModelMutation>;
export type DeleteGANModelMutationResult = Apollo.MutationResult<DeleteGANModelMutation>;
export type DeleteGANModelMutationOptions = Apollo.BaseMutationOptions<DeleteGANModelMutation, DeleteGANModelMutationVariables>;
export const DeleteGraphDocument = gql`
    mutation DeleteGraph($graphId: String!, $workspaceId: String!) {
  deleteGraph(graphId: $graphId, workspaceId: $workspaceId)
}
    `;
export type DeleteGraphMutationFn = Apollo.MutationFunction<DeleteGraphMutation, DeleteGraphMutationVariables>;

/**
 * __useDeleteGraphMutation__
 *
 * To run a mutation, you first call `useDeleteGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGraphMutation, { data, loading, error }] = useDeleteGraphMutation({
 *   variables: {
 *      graphId: // value for 'graphId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteGraphMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGraphMutation, DeleteGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGraphMutation, DeleteGraphMutationVariables>(DeleteGraphDocument, options);
      }
export type DeleteGraphMutationHookResult = ReturnType<typeof useDeleteGraphMutation>;
export type DeleteGraphMutationResult = Apollo.MutationResult<DeleteGraphMutation>;
export type DeleteGraphMutationOptions = Apollo.BaseMutationOptions<DeleteGraphMutation, DeleteGraphMutationVariables>;
export const DeleteInpaintDocument = gql`
    mutation DeleteInpaint($volumeId: String!, $inpaintId: String!) {
  deleteInpaint(volumeId: $volumeId, inpaintId: $inpaintId)
}
    `;
export type DeleteInpaintMutationFn = Apollo.MutationFunction<DeleteInpaintMutation, DeleteInpaintMutationVariables>;

/**
 * __useDeleteInpaintMutation__
 *
 * To run a mutation, you first call `useDeleteInpaintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInpaintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInpaintMutation, { data, loading, error }] = useDeleteInpaintMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      inpaintId: // value for 'inpaintId'
 *   },
 * });
 */
export function useDeleteInpaintMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInpaintMutation, DeleteInpaintMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInpaintMutation, DeleteInpaintMutationVariables>(DeleteInpaintDocument, options);
      }
export type DeleteInpaintMutationHookResult = ReturnType<typeof useDeleteInpaintMutation>;
export type DeleteInpaintMutationResult = Apollo.MutationResult<DeleteInpaintMutation>;
export type DeleteInpaintMutationOptions = Apollo.BaseMutationOptions<DeleteInpaintMutation, DeleteInpaintMutationVariables>;
export const DeleteMLInferenceDocument = gql`
    mutation DeleteMLInference($workspaceId: String!, $inferenceId: String!) {
  deleteMLInference(workspaceId: $workspaceId, inferenceId: $inferenceId)
}
    `;
export type DeleteMLInferenceMutationFn = Apollo.MutationFunction<DeleteMLInferenceMutation, DeleteMLInferenceMutationVariables>;

/**
 * __useDeleteMLInferenceMutation__
 *
 * To run a mutation, you first call `useDeleteMLInferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMLInferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMlInferenceMutation, { data, loading, error }] = useDeleteMLInferenceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      inferenceId: // value for 'inferenceId'
 *   },
 * });
 */
export function useDeleteMLInferenceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMLInferenceMutation, DeleteMLInferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMLInferenceMutation, DeleteMLInferenceMutationVariables>(DeleteMLInferenceDocument, options);
      }
export type DeleteMLInferenceMutationHookResult = ReturnType<typeof useDeleteMLInferenceMutation>;
export type DeleteMLInferenceMutationResult = Apollo.MutationResult<DeleteMLInferenceMutation>;
export type DeleteMLInferenceMutationOptions = Apollo.BaseMutationOptions<DeleteMLInferenceMutation, DeleteMLInferenceMutationVariables>;
export const DeleteMLModelDocument = gql`
    mutation DeleteMLModel($workspaceId: String!, $modelId: String!) {
  deleteMLModel(workspaceId: $workspaceId, modelId: $modelId)
}
    `;
export type DeleteMLModelMutationFn = Apollo.MutationFunction<DeleteMLModelMutation, DeleteMLModelMutationVariables>;

/**
 * __useDeleteMLModelMutation__
 *
 * To run a mutation, you first call `useDeleteMLModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMLModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMlModelMutation, { data, loading, error }] = useDeleteMLModelMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useDeleteMLModelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMLModelMutation, DeleteMLModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMLModelMutation, DeleteMLModelMutationVariables>(DeleteMLModelDocument, options);
      }
export type DeleteMLModelMutationHookResult = ReturnType<typeof useDeleteMLModelMutation>;
export type DeleteMLModelMutationResult = Apollo.MutationResult<DeleteMLModelMutation>;
export type DeleteMLModelMutationOptions = Apollo.BaseMutationOptions<DeleteMLModelMutation, DeleteMLModelMutationVariables>;
export const DeleteOrganizationDocument = gql`
    mutation DeleteOrganization($organizationId: String!) {
  deleteOrganization(organizationId: $organizationId)
}
    `;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, options);
      }
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const DeleteRemoteDevelopmentDocument = gql`
    mutation DeleteRemoteDevelopment($editorSessionId: String!) {
  deleteRemoteDevelopment(editorSessionId: $editorSessionId) {
    editorSessionId
  }
}
    `;
export type DeleteRemoteDevelopmentMutationFn = Apollo.MutationFunction<DeleteRemoteDevelopmentMutation, DeleteRemoteDevelopmentMutationVariables>;

/**
 * __useDeleteRemoteDevelopmentMutation__
 *
 * To run a mutation, you first call `useDeleteRemoteDevelopmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRemoteDevelopmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRemoteDevelopmentMutation, { data, loading, error }] = useDeleteRemoteDevelopmentMutation({
 *   variables: {
 *      editorSessionId: // value for 'editorSessionId'
 *   },
 * });
 */
export function useDeleteRemoteDevelopmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRemoteDevelopmentMutation, DeleteRemoteDevelopmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRemoteDevelopmentMutation, DeleteRemoteDevelopmentMutationVariables>(DeleteRemoteDevelopmentDocument, options);
      }
export type DeleteRemoteDevelopmentMutationHookResult = ReturnType<typeof useDeleteRemoteDevelopmentMutation>;
export type DeleteRemoteDevelopmentMutationResult = Apollo.MutationResult<DeleteRemoteDevelopmentMutation>;
export type DeleteRemoteDevelopmentMutationOptions = Apollo.BaseMutationOptions<DeleteRemoteDevelopmentMutation, DeleteRemoteDevelopmentMutationVariables>;
export const DeleteSSHKeyDocument = gql`
    mutation DeleteSSHKey($name: String!) {
  deleteSSHKey(name: $name)
}
    `;
export type DeleteSSHKeyMutationFn = Apollo.MutationFunction<DeleteSSHKeyMutation, DeleteSSHKeyMutationVariables>;

/**
 * __useDeleteSSHKeyMutation__
 *
 * To run a mutation, you first call `useDeleteSSHKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSSHKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSshKeyMutation, { data, loading, error }] = useDeleteSSHKeyMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteSSHKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSSHKeyMutation, DeleteSSHKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSSHKeyMutation, DeleteSSHKeyMutationVariables>(DeleteSSHKeyDocument, options);
      }
export type DeleteSSHKeyMutationHookResult = ReturnType<typeof useDeleteSSHKeyMutation>;
export type DeleteSSHKeyMutationResult = Apollo.MutationResult<DeleteSSHKeyMutation>;
export type DeleteSSHKeyMutationOptions = Apollo.BaseMutationOptions<DeleteSSHKeyMutation, DeleteSSHKeyMutationVariables>;
export const DeleteUMAPDocument = gql`
    mutation DeleteUMAP($workspaceId: String!, $umapId: String!) {
  deleteUMAP(workspaceId: $workspaceId, umapId: $umapId)
}
    `;
export type DeleteUMAPMutationFn = Apollo.MutationFunction<DeleteUMAPMutation, DeleteUMAPMutationVariables>;

/**
 * __useDeleteUMAPMutation__
 *
 * To run a mutation, you first call `useDeleteUMAPMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUMAPMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUmapMutation, { data, loading, error }] = useDeleteUMAPMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      umapId: // value for 'umapId'
 *   },
 * });
 */
export function useDeleteUMAPMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUMAPMutation, DeleteUMAPMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUMAPMutation, DeleteUMAPMutationVariables>(DeleteUMAPDocument, options);
      }
export type DeleteUMAPMutationHookResult = ReturnType<typeof useDeleteUMAPMutation>;
export type DeleteUMAPMutationResult = Apollo.MutationResult<DeleteUMAPMutation>;
export type DeleteUMAPMutationOptions = Apollo.BaseMutationOptions<DeleteUMAPMutation, DeleteUMAPMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($isDeleting: Boolean) {
  deleteUser(isDeleting: $isDeleting) {
    organizationId
    name
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      isDeleting: // value for 'isDeleting'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const DeleteVolumeDocument = gql`
    mutation DeleteVolume($volumeId: String!, $organizationId: String) {
  deleteVolume(volumeId: $volumeId, organizationId: $organizationId)
}
    `;
export type DeleteVolumeMutationFn = Apollo.MutationFunction<DeleteVolumeMutation, DeleteVolumeMutationVariables>;

/**
 * __useDeleteVolumeMutation__
 *
 * To run a mutation, you first call `useDeleteVolumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVolumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVolumeMutation, { data, loading, error }] = useDeleteVolumeMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteVolumeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVolumeMutation, DeleteVolumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVolumeMutation, DeleteVolumeMutationVariables>(DeleteVolumeDocument, options);
      }
export type DeleteVolumeMutationHookResult = ReturnType<typeof useDeleteVolumeMutation>;
export type DeleteVolumeMutationResult = Apollo.MutationResult<DeleteVolumeMutation>;
export type DeleteVolumeMutationOptions = Apollo.BaseMutationOptions<DeleteVolumeMutation, DeleteVolumeMutationVariables>;
export const DeleteVolumeDataDocument = gql`
    mutation DeleteVolumeData($volumeId: String!, $keys: [String]) {
  deleteVolumeData(volumeId: $volumeId, keys: $keys)
}
    `;
export type DeleteVolumeDataMutationFn = Apollo.MutationFunction<DeleteVolumeDataMutation, DeleteVolumeDataMutationVariables>;

/**
 * __useDeleteVolumeDataMutation__
 *
 * To run a mutation, you first call `useDeleteVolumeDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVolumeDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVolumeDataMutation, { data, loading, error }] = useDeleteVolumeDataMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useDeleteVolumeDataMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVolumeDataMutation, DeleteVolumeDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVolumeDataMutation, DeleteVolumeDataMutationVariables>(DeleteVolumeDataDocument, options);
      }
export type DeleteVolumeDataMutationHookResult = ReturnType<typeof useDeleteVolumeDataMutation>;
export type DeleteVolumeDataMutationResult = Apollo.MutationResult<DeleteVolumeDataMutation>;
export type DeleteVolumeDataMutationOptions = Apollo.BaseMutationOptions<DeleteVolumeDataMutation, DeleteVolumeDataMutationVariables>;
export const DeleteWorkspaceDocument = gql`
    mutation DeleteWorkspace($workspaceId: String!) {
  deleteWorkspace(workspaceId: $workspaceId)
}
    `;
export type DeleteWorkspaceMutationFn = Apollo.MutationFunction<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>;

/**
 * __useDeleteWorkspaceMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceMutation, { data, loading, error }] = useDeleteWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>(DeleteWorkspaceDocument, options);
      }
export type DeleteWorkspaceMutationHookResult = ReturnType<typeof useDeleteWorkspaceMutation>;
export type DeleteWorkspaceMutationResult = Apollo.MutationResult<DeleteWorkspaceMutation>;
export type DeleteWorkspaceMutationOptions = Apollo.BaseMutationOptions<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>;
export const DownloadAnnotationDocument = gql`
    mutation DownloadAnnotation($workspaceId: String!, $annotationId: String!) {
  downloadAnnotation(workspaceId: $workspaceId, annotationId: $annotationId)
}
    `;
export type DownloadAnnotationMutationFn = Apollo.MutationFunction<DownloadAnnotationMutation, DownloadAnnotationMutationVariables>;

/**
 * __useDownloadAnnotationMutation__
 *
 * To run a mutation, you first call `useDownloadAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAnnotationMutation, { data, loading, error }] = useDownloadAnnotationMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      annotationId: // value for 'annotationId'
 *   },
 * });
 */
export function useDownloadAnnotationMutation(baseOptions?: Apollo.MutationHookOptions<DownloadAnnotationMutation, DownloadAnnotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadAnnotationMutation, DownloadAnnotationMutationVariables>(DownloadAnnotationDocument, options);
      }
export type DownloadAnnotationMutationHookResult = ReturnType<typeof useDownloadAnnotationMutation>;
export type DownloadAnnotationMutationResult = Apollo.MutationResult<DownloadAnnotationMutation>;
export type DownloadAnnotationMutationOptions = Apollo.BaseMutationOptions<DownloadAnnotationMutation, DownloadAnnotationMutationVariables>;
export const DownloadAnnotationMapDocument = gql`
    mutation DownloadAnnotationMap($mapId: String!) {
  downloadAnnotationMap(mapId: $mapId)
}
    `;
export type DownloadAnnotationMapMutationFn = Apollo.MutationFunction<DownloadAnnotationMapMutation, DownloadAnnotationMapMutationVariables>;

/**
 * __useDownloadAnnotationMapMutation__
 *
 * To run a mutation, you first call `useDownloadAnnotationMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAnnotationMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAnnotationMapMutation, { data, loading, error }] = useDownloadAnnotationMapMutation({
 *   variables: {
 *      mapId: // value for 'mapId'
 *   },
 * });
 */
export function useDownloadAnnotationMapMutation(baseOptions?: Apollo.MutationHookOptions<DownloadAnnotationMapMutation, DownloadAnnotationMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadAnnotationMapMutation, DownloadAnnotationMapMutationVariables>(DownloadAnnotationMapDocument, options);
      }
export type DownloadAnnotationMapMutationHookResult = ReturnType<typeof useDownloadAnnotationMapMutation>;
export type DownloadAnnotationMapMutationResult = Apollo.MutationResult<DownloadAnnotationMapMutation>;
export type DownloadAnnotationMapMutationOptions = Apollo.BaseMutationOptions<DownloadAnnotationMapMutation, DownloadAnnotationMapMutationVariables>;
export const DownloadDatasetDocument = gql`
    mutation DownloadDataset($workspaceId: String!, $datasetId: String!) {
  downloadDataset(workspaceId: $workspaceId, datasetId: $datasetId)
}
    `;
export type DownloadDatasetMutationFn = Apollo.MutationFunction<DownloadDatasetMutation, DownloadDatasetMutationVariables>;

/**
 * __useDownloadDatasetMutation__
 *
 * To run a mutation, you first call `useDownloadDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadDatasetMutation, { data, loading, error }] = useDownloadDatasetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useDownloadDatasetMutation(baseOptions?: Apollo.MutationHookOptions<DownloadDatasetMutation, DownloadDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadDatasetMutation, DownloadDatasetMutationVariables>(DownloadDatasetDocument, options);
      }
export type DownloadDatasetMutationHookResult = ReturnType<typeof useDownloadDatasetMutation>;
export type DownloadDatasetMutationResult = Apollo.MutationResult<DownloadDatasetMutation>;
export type DownloadDatasetMutationOptions = Apollo.BaseMutationOptions<DownloadDatasetMutation, DownloadDatasetMutationVariables>;
export const DownloadGANModelDocument = gql`
    mutation DownloadGANModel($modelId: String!) {
  downloadGANModel(modelId: $modelId)
}
    `;
export type DownloadGANModelMutationFn = Apollo.MutationFunction<DownloadGANModelMutation, DownloadGANModelMutationVariables>;

/**
 * __useDownloadGANModelMutation__
 *
 * To run a mutation, you first call `useDownloadGANModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadGANModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadGanModelMutation, { data, loading, error }] = useDownloadGANModelMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useDownloadGANModelMutation(baseOptions?: Apollo.MutationHookOptions<DownloadGANModelMutation, DownloadGANModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadGANModelMutation, DownloadGANModelMutationVariables>(DownloadGANModelDocument, options);
      }
export type DownloadGANModelMutationHookResult = ReturnType<typeof useDownloadGANModelMutation>;
export type DownloadGANModelMutationResult = Apollo.MutationResult<DownloadGANModelMutation>;
export type DownloadGANModelMutationOptions = Apollo.BaseMutationOptions<DownloadGANModelMutation, DownloadGANModelMutationVariables>;
export const DownloadGraphDocument = gql`
    mutation DownloadGraph($workspaceId: String!, $graphId: String!) {
  downloadGraph(workspaceId: $workspaceId, graphId: $graphId)
}
    `;
export type DownloadGraphMutationFn = Apollo.MutationFunction<DownloadGraphMutation, DownloadGraphMutationVariables>;

/**
 * __useDownloadGraphMutation__
 *
 * To run a mutation, you first call `useDownloadGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadGraphMutation, { data, loading, error }] = useDownloadGraphMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *   },
 * });
 */
export function useDownloadGraphMutation(baseOptions?: Apollo.MutationHookOptions<DownloadGraphMutation, DownloadGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadGraphMutation, DownloadGraphMutationVariables>(DownloadGraphDocument, options);
      }
export type DownloadGraphMutationHookResult = ReturnType<typeof useDownloadGraphMutation>;
export type DownloadGraphMutationResult = Apollo.MutationResult<DownloadGraphMutation>;
export type DownloadGraphMutationOptions = Apollo.BaseMutationOptions<DownloadGraphMutation, DownloadGraphMutationVariables>;
export const DownloadMLInferenceDocument = gql`
    mutation DownloadMLInference($workspaceId: String!, $inferenceId: String!) {
  downloadMLInference(workspaceId: $workspaceId, inferenceId: $inferenceId)
}
    `;
export type DownloadMLInferenceMutationFn = Apollo.MutationFunction<DownloadMLInferenceMutation, DownloadMLInferenceMutationVariables>;

/**
 * __useDownloadMLInferenceMutation__
 *
 * To run a mutation, you first call `useDownloadMLInferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadMLInferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadMlInferenceMutation, { data, loading, error }] = useDownloadMLInferenceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      inferenceId: // value for 'inferenceId'
 *   },
 * });
 */
export function useDownloadMLInferenceMutation(baseOptions?: Apollo.MutationHookOptions<DownloadMLInferenceMutation, DownloadMLInferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadMLInferenceMutation, DownloadMLInferenceMutationVariables>(DownloadMLInferenceDocument, options);
      }
export type DownloadMLInferenceMutationHookResult = ReturnType<typeof useDownloadMLInferenceMutation>;
export type DownloadMLInferenceMutationResult = Apollo.MutationResult<DownloadMLInferenceMutation>;
export type DownloadMLInferenceMutationOptions = Apollo.BaseMutationOptions<DownloadMLInferenceMutation, DownloadMLInferenceMutationVariables>;
export const DownloadMLModelDocument = gql`
    mutation DownloadMLModel($workspaceId: String!, $modelId: String!, $checkpoint: String) {
  downloadMLModel(
    workspaceId: $workspaceId
    modelId: $modelId
    checkpoint: $checkpoint
  )
}
    `;
export type DownloadMLModelMutationFn = Apollo.MutationFunction<DownloadMLModelMutation, DownloadMLModelMutationVariables>;

/**
 * __useDownloadMLModelMutation__
 *
 * To run a mutation, you first call `useDownloadMLModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadMLModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadMlModelMutation, { data, loading, error }] = useDownloadMLModelMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *      checkpoint: // value for 'checkpoint'
 *   },
 * });
 */
export function useDownloadMLModelMutation(baseOptions?: Apollo.MutationHookOptions<DownloadMLModelMutation, DownloadMLModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadMLModelMutation, DownloadMLModelMutationVariables>(DownloadMLModelDocument, options);
      }
export type DownloadMLModelMutationHookResult = ReturnType<typeof useDownloadMLModelMutation>;
export type DownloadMLModelMutationResult = Apollo.MutationResult<DownloadMLModelMutation>;
export type DownloadMLModelMutationOptions = Apollo.BaseMutationOptions<DownloadMLModelMutation, DownloadMLModelMutationVariables>;
export const DuplicateGraphDocument = gql`
    mutation DuplicateGraph($workspaceId: String!, $graphId: String!, $name: String, $description: String, $tags: [String]) {
  duplicateGraph(
    workspaceId: $workspaceId
    graphId: $graphId
    name: $name
    description: $description
    tags: $tags
  )
}
    `;
export type DuplicateGraphMutationFn = Apollo.MutationFunction<DuplicateGraphMutation, DuplicateGraphMutationVariables>;

/**
 * __useDuplicateGraphMutation__
 *
 * To run a mutation, you first call `useDuplicateGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateGraphMutation, { data, loading, error }] = useDuplicateGraphMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useDuplicateGraphMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateGraphMutation, DuplicateGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateGraphMutation, DuplicateGraphMutationVariables>(DuplicateGraphDocument, options);
      }
export type DuplicateGraphMutationHookResult = ReturnType<typeof useDuplicateGraphMutation>;
export type DuplicateGraphMutationResult = Apollo.MutationResult<DuplicateGraphMutation>;
export type DuplicateGraphMutationOptions = Apollo.BaseMutationOptions<DuplicateGraphMutation, DuplicateGraphMutationVariables>;
export const EditAnnotationMapDocument = gql`
    mutation EditAnnotationMap($mapId: String!, $name: String, $description: String, $tags: [String]) {
  editAnnotationMap(
    mapId: $mapId
    name: $name
    description: $description
    tags: $tags
  )
}
    `;
export type EditAnnotationMapMutationFn = Apollo.MutationFunction<EditAnnotationMapMutation, EditAnnotationMapMutationVariables>;

/**
 * __useEditAnnotationMapMutation__
 *
 * To run a mutation, you first call `useEditAnnotationMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAnnotationMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAnnotationMapMutation, { data, loading, error }] = useEditAnnotationMapMutation({
 *   variables: {
 *      mapId: // value for 'mapId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditAnnotationMapMutation(baseOptions?: Apollo.MutationHookOptions<EditAnnotationMapMutation, EditAnnotationMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAnnotationMapMutation, EditAnnotationMapMutationVariables>(EditAnnotationMapDocument, options);
      }
export type EditAnnotationMapMutationHookResult = ReturnType<typeof useEditAnnotationMapMutation>;
export type EditAnnotationMapMutationResult = Apollo.MutationResult<EditAnnotationMapMutation>;
export type EditAnnotationMapMutationOptions = Apollo.BaseMutationOptions<EditAnnotationMapMutation, EditAnnotationMapMutationVariables>;
export const EditChannelDocument = gql`
    mutation EditChannel($channelId: String!, $name: String, $description: String, $volumes: [String], $instance: String, $timeout: Int, $status: String, $interfaceVersion: Int, $preview: Boolean, $tags: [String]) {
  editChannel(
    channelId: $channelId
    name: $name
    description: $description
    volumes: $volumes
    instance: $instance
    timeout: $timeout
    status: $status
    interfaceVersion: $interfaceVersion
    preview: $preview
    tags: $tags
  )
}
    `;
export type EditChannelMutationFn = Apollo.MutationFunction<EditChannelMutation, EditChannelMutationVariables>;

/**
 * __useEditChannelMutation__
 *
 * To run a mutation, you first call `useEditChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editChannelMutation, { data, loading, error }] = useEditChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      volumes: // value for 'volumes'
 *      instance: // value for 'instance'
 *      timeout: // value for 'timeout'
 *      status: // value for 'status'
 *      interfaceVersion: // value for 'interfaceVersion'
 *      preview: // value for 'preview'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditChannelMutation(baseOptions?: Apollo.MutationHookOptions<EditChannelMutation, EditChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditChannelMutation, EditChannelMutationVariables>(EditChannelDocument, options);
      }
export type EditChannelMutationHookResult = ReturnType<typeof useEditChannelMutation>;
export type EditChannelMutationResult = Apollo.MutationResult<EditChannelMutation>;
export type EditChannelMutationOptions = Apollo.BaseMutationOptions<EditChannelMutation, EditChannelMutationVariables>;
export const EditDatasetDocument = gql`
    mutation EditDataset($workspaceId: String!, $datasetId: String!, $name: String, $description: String, $showJob: Boolean, $pause: Boolean, $priority: Int, $tags: [String]) {
  editDataset(
    workspaceId: $workspaceId
    datasetId: $datasetId
    name: $name
    description: $description
    showJob: $showJob
    pause: $pause
    priority: $priority
    tags: $tags
  )
}
    `;
export type EditDatasetMutationFn = Apollo.MutationFunction<EditDatasetMutation, EditDatasetMutationVariables>;

/**
 * __useEditDatasetMutation__
 *
 * To run a mutation, you first call `useEditDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDatasetMutation, { data, loading, error }] = useEditDatasetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      showJob: // value for 'showJob'
 *      pause: // value for 'pause'
 *      priority: // value for 'priority'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditDatasetMutation(baseOptions?: Apollo.MutationHookOptions<EditDatasetMutation, EditDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDatasetMutation, EditDatasetMutationVariables>(EditDatasetDocument, options);
      }
export type EditDatasetMutationHookResult = ReturnType<typeof useEditDatasetMutation>;
export type EditDatasetMutationResult = Apollo.MutationResult<EditDatasetMutation>;
export type EditDatasetMutationOptions = Apollo.BaseMutationOptions<EditDatasetMutation, EditDatasetMutationVariables>;
export const EditGANModelDocument = gql`
    mutation EditGANModel($modelId: String!, $name: String, $description: String, $flags: String, $tags: [String]) {
  editGANModel(
    modelId: $modelId
    name: $name
    description: $description
    flags: $flags
    tags: $tags
  )
}
    `;
export type EditGANModelMutationFn = Apollo.MutationFunction<EditGANModelMutation, EditGANModelMutationVariables>;

/**
 * __useEditGANModelMutation__
 *
 * To run a mutation, you first call `useEditGANModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditGANModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editGanModelMutation, { data, loading, error }] = useEditGANModelMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      flags: // value for 'flags'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditGANModelMutation(baseOptions?: Apollo.MutationHookOptions<EditGANModelMutation, EditGANModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditGANModelMutation, EditGANModelMutationVariables>(EditGANModelDocument, options);
      }
export type EditGANModelMutationHookResult = ReturnType<typeof useEditGANModelMutation>;
export type EditGANModelMutationResult = Apollo.MutationResult<EditGANModelMutation>;
export type EditGANModelMutationOptions = Apollo.BaseMutationOptions<EditGANModelMutation, EditGANModelMutationVariables>;
export const EditGraphDocument = gql`
    mutation EditGraph($workspaceId: String!, $graphId: String!, $name: String, $description: String, $graph: String, $tags: [String]) {
  editGraph(
    workspaceId: $workspaceId
    graphId: $graphId
    name: $name
    description: $description
    graph: $graph
    tags: $tags
  )
}
    `;
export type EditGraphMutationFn = Apollo.MutationFunction<EditGraphMutation, EditGraphMutationVariables>;

/**
 * __useEditGraphMutation__
 *
 * To run a mutation, you first call `useEditGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editGraphMutation, { data, loading, error }] = useEditGraphMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      graph: // value for 'graph'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditGraphMutation(baseOptions?: Apollo.MutationHookOptions<EditGraphMutation, EditGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditGraphMutation, EditGraphMutationVariables>(EditGraphDocument, options);
      }
export type EditGraphMutationHookResult = ReturnType<typeof useEditGraphMutation>;
export type EditGraphMutationResult = Apollo.MutationResult<EditGraphMutation>;
export type EditGraphMutationOptions = Apollo.BaseMutationOptions<EditGraphMutation, EditGraphMutationVariables>;
export const EditMLModelDocument = gql`
    mutation EditMLModel($workspaceId: String!, $modelId: String!, $name: String, $description: String, $tags: [String]) {
  editMLModel(
    workspaceId: $workspaceId
    modelId: $modelId
    name: $name
    description: $description
    tags: $tags
  )
}
    `;
export type EditMLModelMutationFn = Apollo.MutationFunction<EditMLModelMutation, EditMLModelMutationVariables>;

/**
 * __useEditMLModelMutation__
 *
 * To run a mutation, you first call `useEditMLModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMLModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMlModelMutation, { data, loading, error }] = useEditMLModelMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditMLModelMutation(baseOptions?: Apollo.MutationHookOptions<EditMLModelMutation, EditMLModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMLModelMutation, EditMLModelMutationVariables>(EditMLModelDocument, options);
      }
export type EditMLModelMutationHookResult = ReturnType<typeof useEditMLModelMutation>;
export type EditMLModelMutationResult = Apollo.MutationResult<EditMLModelMutation>;
export type EditMLModelMutationOptions = Apollo.BaseMutationOptions<EditMLModelMutation, EditMLModelMutationVariables>;
export const EditMemberDocument = gql`
    mutation EditMember($organizationId: String, $email: String!, $role: String!) {
  editMember(organizationId: $organizationId, email: $email, role: $role)
}
    `;
export type EditMemberMutationFn = Apollo.MutationFunction<EditMemberMutation, EditMemberMutationVariables>;

/**
 * __useEditMemberMutation__
 *
 * To run a mutation, you first call `useEditMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMemberMutation, { data, loading, error }] = useEditMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useEditMemberMutation(baseOptions?: Apollo.MutationHookOptions<EditMemberMutation, EditMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMemberMutation, EditMemberMutationVariables>(EditMemberDocument, options);
      }
export type EditMemberMutationHookResult = ReturnType<typeof useEditMemberMutation>;
export type EditMemberMutationResult = Apollo.MutationResult<EditMemberMutation>;
export type EditMemberMutationOptions = Apollo.BaseMutationOptions<EditMemberMutation, EditMemberMutationVariables>;
export const EditOrganizationDocument = gql`
    mutation EditOrganization($organizationId: String!, $name: String!) {
  editOrganization(organizationId: $organizationId, name: $name)
}
    `;
export type EditOrganizationMutationFn = Apollo.MutationFunction<EditOrganizationMutation, EditOrganizationMutationVariables>;

/**
 * __useEditOrganizationMutation__
 *
 * To run a mutation, you first call `useEditOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrganizationMutation, { data, loading, error }] = useEditOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEditOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<EditOrganizationMutation, EditOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditOrganizationMutation, EditOrganizationMutationVariables>(EditOrganizationDocument, options);
      }
export type EditOrganizationMutationHookResult = ReturnType<typeof useEditOrganizationMutation>;
export type EditOrganizationMutationResult = Apollo.MutationResult<EditOrganizationMutation>;
export type EditOrganizationMutationOptions = Apollo.BaseMutationOptions<EditOrganizationMutation, EditOrganizationMutationVariables>;
export const EditUMAPDocument = gql`
    mutation EditUMAP($workspaceId: String!, $umapId: String!, $name: String!, $description: String, $tags: [String]) {
  editUMAP(
    workspaceId: $workspaceId
    umapId: $umapId
    name: $name
    description: $description
    tags: $tags
  )
}
    `;
export type EditUMAPMutationFn = Apollo.MutationFunction<EditUMAPMutation, EditUMAPMutationVariables>;

/**
 * __useEditUMAPMutation__
 *
 * To run a mutation, you first call `useEditUMAPMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUMAPMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUmapMutation, { data, loading, error }] = useEditUMAPMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      umapId: // value for 'umapId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditUMAPMutation(baseOptions?: Apollo.MutationHookOptions<EditUMAPMutation, EditUMAPMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUMAPMutation, EditUMAPMutationVariables>(EditUMAPDocument, options);
      }
export type EditUMAPMutationHookResult = ReturnType<typeof useEditUMAPMutation>;
export type EditUMAPMutationResult = Apollo.MutationResult<EditUMAPMutation>;
export type EditUMAPMutationOptions = Apollo.BaseMutationOptions<EditUMAPMutation, EditUMAPMutationVariables>;
export const EditUserDocument = gql`
    mutation EditUser($email: String!, $name: String!) {
  editUser(email: $email, name: $name)
}
    `;
export type EditUserMutationFn = Apollo.MutationFunction<EditUserMutation, EditUserMutationVariables>;

/**
 * __useEditUserMutation__
 *
 * To run a mutation, you first call `useEditUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUserMutation, { data, loading, error }] = useEditUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEditUserMutation(baseOptions?: Apollo.MutationHookOptions<EditUserMutation, EditUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUserMutation, EditUserMutationVariables>(EditUserDocument, options);
      }
export type EditUserMutationHookResult = ReturnType<typeof useEditUserMutation>;
export type EditUserMutationResult = Apollo.MutationResult<EditUserMutation>;
export type EditUserMutationOptions = Apollo.BaseMutationOptions<EditUserMutation, EditUserMutationVariables>;
export const EditVolumeDocument = gql`
    mutation EditVolume($volumeId: String!, $name: String, $description: String, $permission: String, $tags: [String]) {
  editVolume(
    volumeId: $volumeId
    name: $name
    description: $description
    permission: $permission
    tags: $tags
  )
}
    `;
export type EditVolumeMutationFn = Apollo.MutationFunction<EditVolumeMutation, EditVolumeMutationVariables>;

/**
 * __useEditVolumeMutation__
 *
 * To run a mutation, you first call `useEditVolumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVolumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVolumeMutation, { data, loading, error }] = useEditVolumeMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      permission: // value for 'permission'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditVolumeMutation(baseOptions?: Apollo.MutationHookOptions<EditVolumeMutation, EditVolumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditVolumeMutation, EditVolumeMutationVariables>(EditVolumeDocument, options);
      }
export type EditVolumeMutationHookResult = ReturnType<typeof useEditVolumeMutation>;
export type EditVolumeMutationResult = Apollo.MutationResult<EditVolumeMutation>;
export type EditVolumeMutationOptions = Apollo.BaseMutationOptions<EditVolumeMutation, EditVolumeMutationVariables>;
export const EditVolumeDataDocument = gql`
    mutation EditVolumeData($volumeId: String!, $source: String!, $key: String!) {
  editVolumeData(volumeId: $volumeId, source: $source, key: $key)
}
    `;
export type EditVolumeDataMutationFn = Apollo.MutationFunction<EditVolumeDataMutation, EditVolumeDataMutationVariables>;

/**
 * __useEditVolumeDataMutation__
 *
 * To run a mutation, you first call `useEditVolumeDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVolumeDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVolumeDataMutation, { data, loading, error }] = useEditVolumeDataMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      source: // value for 'source'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useEditVolumeDataMutation(baseOptions?: Apollo.MutationHookOptions<EditVolumeDataMutation, EditVolumeDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditVolumeDataMutation, EditVolumeDataMutationVariables>(EditVolumeDataDocument, options);
      }
export type EditVolumeDataMutationHookResult = ReturnType<typeof useEditVolumeDataMutation>;
export type EditVolumeDataMutationResult = Apollo.MutationResult<EditVolumeDataMutation>;
export type EditVolumeDataMutationOptions = Apollo.BaseMutationOptions<EditVolumeDataMutation, EditVolumeDataMutationVariables>;
export const EditWorkspaceDocument = gql`
    mutation EditWorkspace($workspaceId: String!, $name: String, $description: String, $channelIds: [String], $volumeIds: [String], $ganIds: [String], $mapIds: [String], $tags: [String]) {
  editWorkspace(
    workspaceId: $workspaceId
    name: $name
    description: $description
    channelIds: $channelIds
    volumeIds: $volumeIds
    ganIds: $ganIds
    mapIds: $mapIds
    tags: $tags
  )
}
    `;
export type EditWorkspaceMutationFn = Apollo.MutationFunction<EditWorkspaceMutation, EditWorkspaceMutationVariables>;

/**
 * __useEditWorkspaceMutation__
 *
 * To run a mutation, you first call `useEditWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editWorkspaceMutation, { data, loading, error }] = useEditWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      channelIds: // value for 'channelIds'
 *      volumeIds: // value for 'volumeIds'
 *      ganIds: // value for 'ganIds'
 *      mapIds: // value for 'mapIds'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<EditWorkspaceMutation, EditWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditWorkspaceMutation, EditWorkspaceMutationVariables>(EditWorkspaceDocument, options);
      }
export type EditWorkspaceMutationHookResult = ReturnType<typeof useEditWorkspaceMutation>;
export type EditWorkspaceMutationResult = Apollo.MutationResult<EditWorkspaceMutation>;
export type EditWorkspaceMutationOptions = Apollo.BaseMutationOptions<EditWorkspaceMutation, EditWorkspaceMutationVariables>;
export const EditWorkspaceThumbnailDocument = gql`
    mutation EditWorkspaceThumbnail($workspaceId: String!, $thumbnail: String!) {
  editWorkspaceThumbnail(workspaceId: $workspaceId, thumbnail: $thumbnail)
}
    `;
export type EditWorkspaceThumbnailMutationFn = Apollo.MutationFunction<EditWorkspaceThumbnailMutation, EditWorkspaceThumbnailMutationVariables>;

/**
 * __useEditWorkspaceThumbnailMutation__
 *
 * To run a mutation, you first call `useEditWorkspaceThumbnailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditWorkspaceThumbnailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editWorkspaceThumbnailMutation, { data, loading, error }] = useEditWorkspaceThumbnailMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      thumbnail: // value for 'thumbnail'
 *   },
 * });
 */
export function useEditWorkspaceThumbnailMutation(baseOptions?: Apollo.MutationHookOptions<EditWorkspaceThumbnailMutation, EditWorkspaceThumbnailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditWorkspaceThumbnailMutation, EditWorkspaceThumbnailMutationVariables>(EditWorkspaceThumbnailDocument, options);
      }
export type EditWorkspaceThumbnailMutationHookResult = ReturnType<typeof useEditWorkspaceThumbnailMutation>;
export type EditWorkspaceThumbnailMutationResult = Apollo.MutationResult<EditWorkspaceThumbnailMutation>;
export type EditWorkspaceThumbnailMutationOptions = Apollo.BaseMutationOptions<EditWorkspaceThumbnailMutation, EditWorkspaceThumbnailMutationVariables>;
export const InviteRemoteDevelopmentDocument = gql`
    mutation InviteRemoteDevelopment($editorSessionId: String!, $email: String!) {
  inviteRemoteDevelopment(editorSessionId: $editorSessionId, email: $email)
}
    `;
export type InviteRemoteDevelopmentMutationFn = Apollo.MutationFunction<InviteRemoteDevelopmentMutation, InviteRemoteDevelopmentMutationVariables>;

/**
 * __useInviteRemoteDevelopmentMutation__
 *
 * To run a mutation, you first call `useInviteRemoteDevelopmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteRemoteDevelopmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteRemoteDevelopmentMutation, { data, loading, error }] = useInviteRemoteDevelopmentMutation({
 *   variables: {
 *      editorSessionId: // value for 'editorSessionId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useInviteRemoteDevelopmentMutation(baseOptions?: Apollo.MutationHookOptions<InviteRemoteDevelopmentMutation, InviteRemoteDevelopmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteRemoteDevelopmentMutation, InviteRemoteDevelopmentMutationVariables>(InviteRemoteDevelopmentDocument, options);
      }
export type InviteRemoteDevelopmentMutationHookResult = ReturnType<typeof useInviteRemoteDevelopmentMutation>;
export type InviteRemoteDevelopmentMutationResult = Apollo.MutationResult<InviteRemoteDevelopmentMutation>;
export type InviteRemoteDevelopmentMutationOptions = Apollo.BaseMutationOptions<InviteRemoteDevelopmentMutation, InviteRemoteDevelopmentMutationVariables>;
export const PingPreviewDocument = gql`
    mutation PingPreview($channelId: String!) {
  pingPreview(channelId: $channelId)
}
    `;
export type PingPreviewMutationFn = Apollo.MutationFunction<PingPreviewMutation, PingPreviewMutationVariables>;

/**
 * __usePingPreviewMutation__
 *
 * To run a mutation, you first call `usePingPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePingPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pingPreviewMutation, { data, loading, error }] = usePingPreviewMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function usePingPreviewMutation(baseOptions?: Apollo.MutationHookOptions<PingPreviewMutation, PingPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PingPreviewMutation, PingPreviewMutationVariables>(PingPreviewDocument, options);
      }
export type PingPreviewMutationHookResult = ReturnType<typeof usePingPreviewMutation>;
export type PingPreviewMutationResult = Apollo.MutationResult<PingPreviewMutation>;
export type PingPreviewMutationOptions = Apollo.BaseMutationOptions<PingPreviewMutation, PingPreviewMutationVariables>;
export const RemoveMemberDocument = gql`
    mutation RemoveMember($organizationId: String, $email: String) {
  removeMember(organizationId: $organizationId, email: $email)
}
    `;
export type RemoveMemberMutationFn = Apollo.MutationFunction<RemoveMemberMutation, RemoveMemberMutationVariables>;

/**
 * __useRemoveMemberMutation__
 *
 * To run a mutation, you first call `useRemoveMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberMutation, { data, loading, error }] = useRemoveMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRemoveMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberMutation, RemoveMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMemberMutation, RemoveMemberMutationVariables>(RemoveMemberDocument, options);
      }
export type RemoveMemberMutationHookResult = ReturnType<typeof useRemoveMemberMutation>;
export type RemoveMemberMutationResult = Apollo.MutationResult<RemoveMemberMutation>;
export type RemoveMemberMutationOptions = Apollo.BaseMutationOptions<RemoveMemberMutation, RemoveMemberMutationVariables>;
export const StartRemoteDevelopmentDocument = gql`
    mutation StartRemoteDevelopment($editorSessionId: String!) {
  startRemoteDevelopment(editorSessionId: $editorSessionId) {
    editorSessionId
    editorUrl
  }
}
    `;
export type StartRemoteDevelopmentMutationFn = Apollo.MutationFunction<StartRemoteDevelopmentMutation, StartRemoteDevelopmentMutationVariables>;

/**
 * __useStartRemoteDevelopmentMutation__
 *
 * To run a mutation, you first call `useStartRemoteDevelopmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartRemoteDevelopmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startRemoteDevelopmentMutation, { data, loading, error }] = useStartRemoteDevelopmentMutation({
 *   variables: {
 *      editorSessionId: // value for 'editorSessionId'
 *   },
 * });
 */
export function useStartRemoteDevelopmentMutation(baseOptions?: Apollo.MutationHookOptions<StartRemoteDevelopmentMutation, StartRemoteDevelopmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartRemoteDevelopmentMutation, StartRemoteDevelopmentMutationVariables>(StartRemoteDevelopmentDocument, options);
      }
export type StartRemoteDevelopmentMutationHookResult = ReturnType<typeof useStartRemoteDevelopmentMutation>;
export type StartRemoteDevelopmentMutationResult = Apollo.MutationResult<StartRemoteDevelopmentMutation>;
export type StartRemoteDevelopmentMutationOptions = Apollo.BaseMutationOptions<StartRemoteDevelopmentMutation, StartRemoteDevelopmentMutationVariables>;
export const StopRemoteDevelopmentDocument = gql`
    mutation StopRemoteDevelopment($editorSessionId: String!) {
  stopRemoteDevelopment(editorSessionId: $editorSessionId) {
    editorSessionId
    editorUrl
  }
}
    `;
export type StopRemoteDevelopmentMutationFn = Apollo.MutationFunction<StopRemoteDevelopmentMutation, StopRemoteDevelopmentMutationVariables>;

/**
 * __useStopRemoteDevelopmentMutation__
 *
 * To run a mutation, you first call `useStopRemoteDevelopmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopRemoteDevelopmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopRemoteDevelopmentMutation, { data, loading, error }] = useStopRemoteDevelopmentMutation({
 *   variables: {
 *      editorSessionId: // value for 'editorSessionId'
 *   },
 * });
 */
export function useStopRemoteDevelopmentMutation(baseOptions?: Apollo.MutationHookOptions<StopRemoteDevelopmentMutation, StopRemoteDevelopmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopRemoteDevelopmentMutation, StopRemoteDevelopmentMutationVariables>(StopRemoteDevelopmentDocument, options);
      }
export type StopRemoteDevelopmentMutationHookResult = ReturnType<typeof useStopRemoteDevelopmentMutation>;
export type StopRemoteDevelopmentMutationResult = Apollo.MutationResult<StopRemoteDevelopmentMutation>;
export type StopRemoteDevelopmentMutationOptions = Apollo.BaseMutationOptions<StopRemoteDevelopmentMutation, StopRemoteDevelopmentMutationVariables>;
export const UploadAnnotationMapDocument = gql`
    mutation UploadAnnotationMap($organizationId: String!, $name: String!, $size: Int!, $description: String, $tags: [String]) {
  uploadAnnotationMap(
    organizationId: $organizationId
    name: $name
    size: $size
    description: $description
    tags: $tags
  ) {
    mapId
    key
    partSize
    uploadId
    urls
  }
}
    `;
export type UploadAnnotationMapMutationFn = Apollo.MutationFunction<UploadAnnotationMapMutation, UploadAnnotationMapMutationVariables>;

/**
 * __useUploadAnnotationMapMutation__
 *
 * To run a mutation, you first call `useUploadAnnotationMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAnnotationMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAnnotationMapMutation, { data, loading, error }] = useUploadAnnotationMapMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      size: // value for 'size'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUploadAnnotationMapMutation(baseOptions?: Apollo.MutationHookOptions<UploadAnnotationMapMutation, UploadAnnotationMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAnnotationMapMutation, UploadAnnotationMapMutationVariables>(UploadAnnotationMapDocument, options);
      }
export type UploadAnnotationMapMutationHookResult = ReturnType<typeof useUploadAnnotationMapMutation>;
export type UploadAnnotationMapMutationResult = Apollo.MutationResult<UploadAnnotationMapMutation>;
export type UploadAnnotationMapMutationOptions = Apollo.BaseMutationOptions<UploadAnnotationMapMutation, UploadAnnotationMapMutationVariables>;
export const UploadAnnotationMapFinalizerDocument = gql`
    mutation UploadAnnotationMapFinalizer($uploadId: String!, $key: String!, $parts: [MultipartInput]) {
  uploadAnnotationMapFinalizer(uploadId: $uploadId, key: $key, parts: $parts)
}
    `;
export type UploadAnnotationMapFinalizerMutationFn = Apollo.MutationFunction<UploadAnnotationMapFinalizerMutation, UploadAnnotationMapFinalizerMutationVariables>;

/**
 * __useUploadAnnotationMapFinalizerMutation__
 *
 * To run a mutation, you first call `useUploadAnnotationMapFinalizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAnnotationMapFinalizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAnnotationMapFinalizerMutation, { data, loading, error }] = useUploadAnnotationMapFinalizerMutation({
 *   variables: {
 *      uploadId: // value for 'uploadId'
 *      key: // value for 'key'
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useUploadAnnotationMapFinalizerMutation(baseOptions?: Apollo.MutationHookOptions<UploadAnnotationMapFinalizerMutation, UploadAnnotationMapFinalizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAnnotationMapFinalizerMutation, UploadAnnotationMapFinalizerMutationVariables>(UploadAnnotationMapFinalizerDocument, options);
      }
export type UploadAnnotationMapFinalizerMutationHookResult = ReturnType<typeof useUploadAnnotationMapFinalizerMutation>;
export type UploadAnnotationMapFinalizerMutationResult = Apollo.MutationResult<UploadAnnotationMapFinalizerMutation>;
export type UploadAnnotationMapFinalizerMutationOptions = Apollo.BaseMutationOptions<UploadAnnotationMapFinalizerMutation, UploadAnnotationMapFinalizerMutationVariables>;
export const UploadDatasetDocument = gql`
    mutation UploadDataset($workspaceId: String!, $name: String!, $size: Float!, $description: String, $tags: [String]) {
  uploadDataset(
    workspaceId: $workspaceId
    name: $name
    size: $size
    description: $description
    tags: $tags
  ) {
    datasetId
    key
    partSize
    uploadId
    urls
  }
}
    `;
export type UploadDatasetMutationFn = Apollo.MutationFunction<UploadDatasetMutation, UploadDatasetMutationVariables>;

/**
 * __useUploadDatasetMutation__
 *
 * To run a mutation, you first call `useUploadDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDatasetMutation, { data, loading, error }] = useUploadDatasetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      name: // value for 'name'
 *      size: // value for 'size'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUploadDatasetMutation(baseOptions?: Apollo.MutationHookOptions<UploadDatasetMutation, UploadDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDatasetMutation, UploadDatasetMutationVariables>(UploadDatasetDocument, options);
      }
export type UploadDatasetMutationHookResult = ReturnType<typeof useUploadDatasetMutation>;
export type UploadDatasetMutationResult = Apollo.MutationResult<UploadDatasetMutation>;
export type UploadDatasetMutationOptions = Apollo.BaseMutationOptions<UploadDatasetMutation, UploadDatasetMutationVariables>;
export const UploadDatasetFinalizerDocument = gql`
    mutation UploadDatasetFinalizer($key: String!, $uploadId: String, $parts: [MultipartInput]) {
  uploadDatasetFinalizer(uploadId: $uploadId, key: $key, parts: $parts)
}
    `;
export type UploadDatasetFinalizerMutationFn = Apollo.MutationFunction<UploadDatasetFinalizerMutation, UploadDatasetFinalizerMutationVariables>;

/**
 * __useUploadDatasetFinalizerMutation__
 *
 * To run a mutation, you first call `useUploadDatasetFinalizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDatasetFinalizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDatasetFinalizerMutation, { data, loading, error }] = useUploadDatasetFinalizerMutation({
 *   variables: {
 *      key: // value for 'key'
 *      uploadId: // value for 'uploadId'
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useUploadDatasetFinalizerMutation(baseOptions?: Apollo.MutationHookOptions<UploadDatasetFinalizerMutation, UploadDatasetFinalizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDatasetFinalizerMutation, UploadDatasetFinalizerMutationVariables>(UploadDatasetFinalizerDocument, options);
      }
export type UploadDatasetFinalizerMutationHookResult = ReturnType<typeof useUploadDatasetFinalizerMutation>;
export type UploadDatasetFinalizerMutationResult = Apollo.MutationResult<UploadDatasetFinalizerMutation>;
export type UploadDatasetFinalizerMutationOptions = Apollo.BaseMutationOptions<UploadDatasetFinalizerMutation, UploadDatasetFinalizerMutationVariables>;
export const UploadGANModelDocument = gql`
    mutation UploadGANModel($organizationId: String!, $name: String!, $size: Float!, $description: String, $flags: String, $tags: [String]) {
  uploadGANModel(
    organizationId: $organizationId
    name: $name
    size: $size
    description: $description
    flags: $flags
    tags: $tags
  ) {
    key
    modelId
    partSize
    uploadId
    urls
  }
}
    `;
export type UploadGANModelMutationFn = Apollo.MutationFunction<UploadGANModelMutation, UploadGANModelMutationVariables>;

/**
 * __useUploadGANModelMutation__
 *
 * To run a mutation, you first call `useUploadGANModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadGANModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadGanModelMutation, { data, loading, error }] = useUploadGANModelMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      size: // value for 'size'
 *      description: // value for 'description'
 *      flags: // value for 'flags'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUploadGANModelMutation(baseOptions?: Apollo.MutationHookOptions<UploadGANModelMutation, UploadGANModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadGANModelMutation, UploadGANModelMutationVariables>(UploadGANModelDocument, options);
      }
export type UploadGANModelMutationHookResult = ReturnType<typeof useUploadGANModelMutation>;
export type UploadGANModelMutationResult = Apollo.MutationResult<UploadGANModelMutation>;
export type UploadGANModelMutationOptions = Apollo.BaseMutationOptions<UploadGANModelMutation, UploadGANModelMutationVariables>;
export const UploadGANModelFinalizerDocument = gql`
    mutation UploadGANModelFinalizer($key: String!, $uploadId: String, $parts: [MultipartInput]) {
  uploadGANModelFinalizer(key: $key, uploadId: $uploadId, parts: $parts)
}
    `;
export type UploadGANModelFinalizerMutationFn = Apollo.MutationFunction<UploadGANModelFinalizerMutation, UploadGANModelFinalizerMutationVariables>;

/**
 * __useUploadGANModelFinalizerMutation__
 *
 * To run a mutation, you first call `useUploadGANModelFinalizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadGANModelFinalizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadGanModelFinalizerMutation, { data, loading, error }] = useUploadGANModelFinalizerMutation({
 *   variables: {
 *      key: // value for 'key'
 *      uploadId: // value for 'uploadId'
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useUploadGANModelFinalizerMutation(baseOptions?: Apollo.MutationHookOptions<UploadGANModelFinalizerMutation, UploadGANModelFinalizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadGANModelFinalizerMutation, UploadGANModelFinalizerMutationVariables>(UploadGANModelFinalizerDocument, options);
      }
export type UploadGANModelFinalizerMutationHookResult = ReturnType<typeof useUploadGANModelFinalizerMutation>;
export type UploadGANModelFinalizerMutationResult = Apollo.MutationResult<UploadGANModelFinalizerMutation>;
export type UploadGANModelFinalizerMutationOptions = Apollo.BaseMutationOptions<UploadGANModelFinalizerMutation, UploadGANModelFinalizerMutationVariables>;
export const UploadMLModelDocument = gql`
    mutation UploadMLModel($workspaceId: String!, $architectureId: String!, $name: String!, $size: Float!, $description: String, $tags: [String], $parameters: String) {
  uploadMLModel(
    workspaceId: $workspaceId
    architectureId: $architectureId
    name: $name
    size: $size
    description: $description
    tags: $tags
    parameters: $parameters
  ) {
    key
    modelId
    uploadId
    partSize
    urls
  }
}
    `;
export type UploadMLModelMutationFn = Apollo.MutationFunction<UploadMLModelMutation, UploadMLModelMutationVariables>;

/**
 * __useUploadMLModelMutation__
 *
 * To run a mutation, you first call `useUploadMLModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMLModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMlModelMutation, { data, loading, error }] = useUploadMLModelMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      architectureId: // value for 'architectureId'
 *      name: // value for 'name'
 *      size: // value for 'size'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *      parameters: // value for 'parameters'
 *   },
 * });
 */
export function useUploadMLModelMutation(baseOptions?: Apollo.MutationHookOptions<UploadMLModelMutation, UploadMLModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMLModelMutation, UploadMLModelMutationVariables>(UploadMLModelDocument, options);
      }
export type UploadMLModelMutationHookResult = ReturnType<typeof useUploadMLModelMutation>;
export type UploadMLModelMutationResult = Apollo.MutationResult<UploadMLModelMutation>;
export type UploadMLModelMutationOptions = Apollo.BaseMutationOptions<UploadMLModelMutation, UploadMLModelMutationVariables>;
export const UploadMLModelFinalizerDocument = gql`
    mutation UploadMLModelFinalizer($key: String!, $uploadId: String, $parts: [MultipartInput]) {
  uploadMLModelFinalizer(key: $key, uploadId: $uploadId, parts: $parts)
}
    `;
export type UploadMLModelFinalizerMutationFn = Apollo.MutationFunction<UploadMLModelFinalizerMutation, UploadMLModelFinalizerMutationVariables>;

/**
 * __useUploadMLModelFinalizerMutation__
 *
 * To run a mutation, you first call `useUploadMLModelFinalizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMLModelFinalizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMlModelFinalizerMutation, { data, loading, error }] = useUploadMLModelFinalizerMutation({
 *   variables: {
 *      key: // value for 'key'
 *      uploadId: // value for 'uploadId'
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useUploadMLModelFinalizerMutation(baseOptions?: Apollo.MutationHookOptions<UploadMLModelFinalizerMutation, UploadMLModelFinalizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMLModelFinalizerMutation, UploadMLModelFinalizerMutationVariables>(UploadMLModelFinalizerDocument, options);
      }
export type UploadMLModelFinalizerMutationHookResult = ReturnType<typeof useUploadMLModelFinalizerMutation>;
export type UploadMLModelFinalizerMutationResult = Apollo.MutationResult<UploadMLModelFinalizerMutation>;
export type UploadMLModelFinalizerMutationOptions = Apollo.BaseMutationOptions<UploadMLModelFinalizerMutation, UploadMLModelFinalizerMutationVariables>;
export const UploadVolumeDataDocument = gql`
    mutation UploadVolumeData($volumeId: String!, $key: String!, $size: Float!) {
  uploadVolumeData(volumeId: $volumeId, key: $key, size: $size) {
    key
    partSize
    uploadId
    urls
    volumeId
  }
}
    `;
export type UploadVolumeDataMutationFn = Apollo.MutationFunction<UploadVolumeDataMutation, UploadVolumeDataMutationVariables>;

/**
 * __useUploadVolumeDataMutation__
 *
 * To run a mutation, you first call `useUploadVolumeDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadVolumeDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadVolumeDataMutation, { data, loading, error }] = useUploadVolumeDataMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      key: // value for 'key'
 *      size: // value for 'size'
 *   },
 * });
 */
export function useUploadVolumeDataMutation(baseOptions?: Apollo.MutationHookOptions<UploadVolumeDataMutation, UploadVolumeDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadVolumeDataMutation, UploadVolumeDataMutationVariables>(UploadVolumeDataDocument, options);
      }
export type UploadVolumeDataMutationHookResult = ReturnType<typeof useUploadVolumeDataMutation>;
export type UploadVolumeDataMutationResult = Apollo.MutationResult<UploadVolumeDataMutation>;
export type UploadVolumeDataMutationOptions = Apollo.BaseMutationOptions<UploadVolumeDataMutation, UploadVolumeDataMutationVariables>;
export const UploadVolumeDataFinalizerDocument = gql`
    mutation UploadVolumeDataFinalizer($key: String!, $uploadId: String, $parts: [MultipartInput]) {
  uploadVolumeDataFinalizer(key: $key, uploadId: $uploadId, parts: $parts)
}
    `;
export type UploadVolumeDataFinalizerMutationFn = Apollo.MutationFunction<UploadVolumeDataFinalizerMutation, UploadVolumeDataFinalizerMutationVariables>;

/**
 * __useUploadVolumeDataFinalizerMutation__
 *
 * To run a mutation, you first call `useUploadVolumeDataFinalizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadVolumeDataFinalizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadVolumeDataFinalizerMutation, { data, loading, error }] = useUploadVolumeDataFinalizerMutation({
 *   variables: {
 *      key: // value for 'key'
 *      uploadId: // value for 'uploadId'
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useUploadVolumeDataFinalizerMutation(baseOptions?: Apollo.MutationHookOptions<UploadVolumeDataFinalizerMutation, UploadVolumeDataFinalizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadVolumeDataFinalizerMutation, UploadVolumeDataFinalizerMutationVariables>(UploadVolumeDataFinalizerDocument, options);
      }
export type UploadVolumeDataFinalizerMutationHookResult = ReturnType<typeof useUploadVolumeDataFinalizerMutation>;
export type UploadVolumeDataFinalizerMutationResult = Apollo.MutationResult<UploadVolumeDataFinalizerMutation>;
export type UploadVolumeDataFinalizerMutationOptions = Apollo.BaseMutationOptions<UploadVolumeDataFinalizerMutation, UploadVolumeDataFinalizerMutationVariables>;
export const UploadVolumeDataThumbnailDocument = gql`
    mutation UploadVolumeDataThumbnail($volumeId: String!, $key: String!) {
  uploadVolumeDataThumbnail(volumeId: $volumeId, key: $key) {
    key
    url
  }
}
    `;
export type UploadVolumeDataThumbnailMutationFn = Apollo.MutationFunction<UploadVolumeDataThumbnailMutation, UploadVolumeDataThumbnailMutationVariables>;

/**
 * __useUploadVolumeDataThumbnailMutation__
 *
 * To run a mutation, you first call `useUploadVolumeDataThumbnailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadVolumeDataThumbnailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadVolumeDataThumbnailMutation, { data, loading, error }] = useUploadVolumeDataThumbnailMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useUploadVolumeDataThumbnailMutation(baseOptions?: Apollo.MutationHookOptions<UploadVolumeDataThumbnailMutation, UploadVolumeDataThumbnailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadVolumeDataThumbnailMutation, UploadVolumeDataThumbnailMutationVariables>(UploadVolumeDataThumbnailDocument, options);
      }
export type UploadVolumeDataThumbnailMutationHookResult = ReturnType<typeof useUploadVolumeDataThumbnailMutation>;
export type UploadVolumeDataThumbnailMutationResult = Apollo.MutationResult<UploadVolumeDataThumbnailMutation>;
export type UploadVolumeDataThumbnailMutationOptions = Apollo.BaseMutationOptions<UploadVolumeDataThumbnailMutation, UploadVolumeDataThumbnailMutationVariables>;
export const ValidateGraphDocument = gql`
    mutation ValidateGraph($workspaceId: String!, $graphId: String!) {
  validateGraph(workspaceId: $workspaceId, graphId: $graphId) {
    node
    input
    errorMessage
    type
  }
}
    `;
export type ValidateGraphMutationFn = Apollo.MutationFunction<ValidateGraphMutation, ValidateGraphMutationVariables>;

/**
 * __useValidateGraphMutation__
 *
 * To run a mutation, you first call `useValidateGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateGraphMutation, { data, loading, error }] = useValidateGraphMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *   },
 * });
 */
export function useValidateGraphMutation(baseOptions?: Apollo.MutationHookOptions<ValidateGraphMutation, ValidateGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateGraphMutation, ValidateGraphMutationVariables>(ValidateGraphDocument, options);
      }
export type ValidateGraphMutationHookResult = ReturnType<typeof useValidateGraphMutation>;
export type ValidateGraphMutationResult = Apollo.MutationResult<ValidateGraphMutation>;
export type ValidateGraphMutationOptions = Apollo.BaseMutationOptions<ValidateGraphMutation, ValidateGraphMutationVariables>;
export const GetOrganizationsDocument = gql`
    query GetOrganizations($organizationId: String) {
  getOrganizations(organizationId: $organizationId) {
    name
    role
    organizationId
    expirationDate
    expired
    plan
  }
}
    `;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetOrganizationSettingsDocument = gql`
    query GetOrganizationSettings($organizationId: String!, $setting: String) {
  getOrganizationSettings(organizationId: $organizationId, setting: $setting) {
    organizationId
    setting
    limit
    usage
    units
  }
}
    `;

/**
 * __useGetOrganizationSettingsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationSettingsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      setting: // value for 'setting'
 *   },
 * });
 */
export function useGetOrganizationSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>(GetOrganizationSettingsDocument, options);
      }
export function useGetOrganizationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>(GetOrganizationSettingsDocument, options);
        }
export type GetOrganizationSettingsQueryHookResult = ReturnType<typeof useGetOrganizationSettingsQuery>;
export type GetOrganizationSettingsLazyQueryHookResult = ReturnType<typeof useGetOrganizationSettingsLazyQuery>;
export type GetOrganizationSettingsQueryResult = Apollo.QueryResult<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>;
export const GetOrganizationsNamesListDocument = gql`
    query GetOrganizationsNamesList {
  getOrganizations {
    name
    organizationId
  }
}
    `;

/**
 * __useGetOrganizationsNamesListQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsNamesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsNamesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsNamesListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationsNamesListQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsNamesListQuery, GetOrganizationsNamesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsNamesListQuery, GetOrganizationsNamesListQueryVariables>(GetOrganizationsNamesListDocument, options);
      }
export function useGetOrganizationsNamesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsNamesListQuery, GetOrganizationsNamesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsNamesListQuery, GetOrganizationsNamesListQueryVariables>(GetOrganizationsNamesListDocument, options);
        }
export type GetOrganizationsNamesListQueryHookResult = ReturnType<typeof useGetOrganizationsNamesListQuery>;
export type GetOrganizationsNamesListLazyQueryHookResult = ReturnType<typeof useGetOrganizationsNamesListLazyQuery>;
export type GetOrganizationsNamesListQueryResult = Apollo.QueryResult<GetOrganizationsNamesListQuery, GetOrganizationsNamesListQueryVariables>;
export const GetDatasetThumbnailsDocument = gql`
    query GetDatasetThumbnails($workspaceId: String!, $datasetId: String!) {
  getDatasetThumbnails(workspaceId: $workspaceId, datasetId: $datasetId)
}
    `;

/**
 * __useGetDatasetThumbnailsQuery__
 *
 * To run a query within a React component, call `useGetDatasetThumbnailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetThumbnailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetThumbnailsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetThumbnailsQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables>(GetDatasetThumbnailsDocument, options);
      }
export function useGetDatasetThumbnailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables>(GetDatasetThumbnailsDocument, options);
        }
export type GetDatasetThumbnailsQueryHookResult = ReturnType<typeof useGetDatasetThumbnailsQuery>;
export type GetDatasetThumbnailsLazyQueryHookResult = ReturnType<typeof useGetDatasetThumbnailsLazyQuery>;
export type GetDatasetThumbnailsQueryResult = Apollo.QueryResult<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables>;
export const ValidateContentCodeDocument = gql`
    query ValidateContentCode($code: String!) {
  validateContentCode(code: $code)
}
    `;

/**
 * __useValidateContentCodeQuery__
 *
 * To run a query within a React component, call `useValidateContentCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateContentCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateContentCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useValidateContentCodeQuery(baseOptions: Apollo.QueryHookOptions<ValidateContentCodeQuery, ValidateContentCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateContentCodeQuery, ValidateContentCodeQueryVariables>(ValidateContentCodeDocument, options);
      }
export function useValidateContentCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateContentCodeQuery, ValidateContentCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateContentCodeQuery, ValidateContentCodeQueryVariables>(ValidateContentCodeDocument, options);
        }
export type ValidateContentCodeQueryHookResult = ReturnType<typeof useValidateContentCodeQuery>;
export type ValidateContentCodeLazyQueryHookResult = ReturnType<typeof useValidateContentCodeLazyQuery>;
export type ValidateContentCodeQueryResult = Apollo.QueryResult<ValidateContentCodeQuery, ValidateContentCodeQueryVariables>;
export const GetRemoteDevelopmentSessionsDocument = gql`
    query GetRemoteDevelopmentSessions {
  listRemoteDevelopment {
    channel
    channelId
    createdAt
    createdBy
    editorSessionId
    editorUrl
    instanceType
    organization
    organizationId
    sshPort
    status {
      state
      message
    }
    updatedAt
  }
}
    `;

/**
 * __useGetRemoteDevelopmentSessionsQuery__
 *
 * To run a query within a React component, call `useGetRemoteDevelopmentSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemoteDevelopmentSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemoteDevelopmentSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRemoteDevelopmentSessionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>(GetRemoteDevelopmentSessionsDocument, options);
      }
export function useGetRemoteDevelopmentSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>(GetRemoteDevelopmentSessionsDocument, options);
        }
export type GetRemoteDevelopmentSessionsQueryHookResult = ReturnType<typeof useGetRemoteDevelopmentSessionsQuery>;
export type GetRemoteDevelopmentSessionsLazyQueryHookResult = ReturnType<typeof useGetRemoteDevelopmentSessionsLazyQuery>;
export type GetRemoteDevelopmentSessionsQueryResult = Apollo.QueryResult<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>;
export const GetRemoteDevelopmentSessionsForChannelsTableDocument = gql`
    query GetRemoteDevelopmentSessionsForChannelsTable($organizationId: String) {
  listRemoteDevelopment(organizationId: $organizationId) {
    channel
    channelId
    editorSessionId
    editorUrl
    sshPort
    status {
      state
    }
  }
}
    `;

/**
 * __useGetRemoteDevelopmentSessionsForChannelsTableQuery__
 *
 * To run a query within a React component, call `useGetRemoteDevelopmentSessionsForChannelsTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemoteDevelopmentSessionsForChannelsTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemoteDevelopmentSessionsForChannelsTableQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetRemoteDevelopmentSessionsForChannelsTableQuery(baseOptions?: Apollo.QueryHookOptions<GetRemoteDevelopmentSessionsForChannelsTableQuery, GetRemoteDevelopmentSessionsForChannelsTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRemoteDevelopmentSessionsForChannelsTableQuery, GetRemoteDevelopmentSessionsForChannelsTableQueryVariables>(GetRemoteDevelopmentSessionsForChannelsTableDocument, options);
      }
export function useGetRemoteDevelopmentSessionsForChannelsTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRemoteDevelopmentSessionsForChannelsTableQuery, GetRemoteDevelopmentSessionsForChannelsTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRemoteDevelopmentSessionsForChannelsTableQuery, GetRemoteDevelopmentSessionsForChannelsTableQueryVariables>(GetRemoteDevelopmentSessionsForChannelsTableDocument, options);
        }
export type GetRemoteDevelopmentSessionsForChannelsTableQueryHookResult = ReturnType<typeof useGetRemoteDevelopmentSessionsForChannelsTableQuery>;
export type GetRemoteDevelopmentSessionsForChannelsTableLazyQueryHookResult = ReturnType<typeof useGetRemoteDevelopmentSessionsForChannelsTableLazyQuery>;
export type GetRemoteDevelopmentSessionsForChannelsTableQueryResult = Apollo.QueryResult<GetRemoteDevelopmentSessionsForChannelsTableQuery, GetRemoteDevelopmentSessionsForChannelsTableQueryVariables>;
export const GetUMAPLogDocument = gql`
    query GetUMAPLog($workspaceId: String!, $umapId: String!) {
  getUMAPLog(workspaceId: $workspaceId, umapId: $umapId) {
    umapId
    workspaceId
    state
    log
  }
}
    `;

/**
 * __useGetUMAPLogQuery__
 *
 * To run a query within a React component, call `useGetUMAPLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUMAPLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUMAPLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      umapId: // value for 'umapId'
 *   },
 * });
 */
export function useGetUMAPLogQuery(baseOptions: Apollo.QueryHookOptions<GetUMAPLogQuery, GetUMAPLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUMAPLogQuery, GetUMAPLogQueryVariables>(GetUMAPLogDocument, options);
      }
export function useGetUMAPLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUMAPLogQuery, GetUMAPLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUMAPLogQuery, GetUMAPLogQueryVariables>(GetUMAPLogDocument, options);
        }
export type GetUMAPLogQueryHookResult = ReturnType<typeof useGetUMAPLogQuery>;
export type GetUMAPLogLazyQueryHookResult = ReturnType<typeof useGetUMAPLogLazyQuery>;
export type GetUMAPLogQueryResult = Apollo.QueryResult<GetUMAPLogQuery, GetUMAPLogQueryVariables>;
export const GetUMAPDocument = gql`
    query GetUMAP($workspaceId: String!, $umapId: String) {
  getUMAPs(workspaceId: $workspaceId, umapId: $umapId) {
    datasets {
      datasetId
      dataset
    }
    name
    results
    samples
    seed
    status
    tags
    umapId
    workspaceId
  }
}
    `;

/**
 * __useGetUMAPQuery__
 *
 * To run a query within a React component, call `useGetUMAPQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUMAPQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUMAPQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      umapId: // value for 'umapId'
 *   },
 * });
 */
export function useGetUMAPQuery(baseOptions: Apollo.QueryHookOptions<GetUMAPQuery, GetUMAPQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUMAPQuery, GetUMAPQueryVariables>(GetUMAPDocument, options);
      }
export function useGetUMAPLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUMAPQuery, GetUMAPQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUMAPQuery, GetUMAPQueryVariables>(GetUMAPDocument, options);
        }
export type GetUMAPQueryHookResult = ReturnType<typeof useGetUMAPQuery>;
export type GetUMAPLazyQueryHookResult = ReturnType<typeof useGetUMAPLazyQuery>;
export type GetUMAPQueryResult = Apollo.QueryResult<GetUMAPQuery, GetUMAPQueryVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  getCurrentUser {
    userId
    email
    name
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetVolumesDocument = gql`
    query GetVolumes($organizationId: String, $volumeId: String, $workspaceId: String, $cursor: String, $limit: Int, $filters: VolumeFilter) {
  getVolumes(
    organizationId: $organizationId
    volumeId: $volumeId
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    name
    size
    volumeId
    updatedAt
    createdAt
    permission
    description
    organization
    organizationId
    tags
  }
}
    `;

/**
 * __useGetVolumesQuery__
 *
 * To run a query within a React component, call `useGetVolumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolumesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      volumeId: // value for 'volumeId'
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetVolumesQuery(baseOptions?: Apollo.QueryHookOptions<GetVolumesQuery, GetVolumesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVolumesQuery, GetVolumesQueryVariables>(GetVolumesDocument, options);
      }
export function useGetVolumesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVolumesQuery, GetVolumesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVolumesQuery, GetVolumesQueryVariables>(GetVolumesDocument, options);
        }
export type GetVolumesQueryHookResult = ReturnType<typeof useGetVolumesQuery>;
export type GetVolumesLazyQueryHookResult = ReturnType<typeof useGetVolumesLazyQuery>;
export type GetVolumesQueryResult = Apollo.QueryResult<GetVolumesQuery, GetVolumesQueryVariables>;
export const GetVolumeDataDocument = gql`
    query GetVolumeData($volumeId: String!, $keys: [String], $dir: String, $cursor: String, $limit: Int) {
  getVolumeData(
    volumeId: $volumeId
    keys: $keys
    dir: $dir
    cursor: $cursor
    limit: $limit
  ) {
    keys {
      url
      updatedAt
      thumbnailUrl
      previewUrl
      size
      key
      hash
    }
    pageInfo {
      totalItems
      offset
      limit
    }
  }
}
    `;

/**
 * __useGetVolumeDataQuery__
 *
 * To run a query within a React component, call `useGetVolumeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolumeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolumeDataQuery({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      keys: // value for 'keys'
 *      dir: // value for 'dir'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetVolumeDataQuery(baseOptions: Apollo.QueryHookOptions<GetVolumeDataQuery, GetVolumeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVolumeDataQuery, GetVolumeDataQueryVariables>(GetVolumeDataDocument, options);
      }
export function useGetVolumeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVolumeDataQuery, GetVolumeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVolumeDataQuery, GetVolumeDataQueryVariables>(GetVolumeDataDocument, options);
        }
export type GetVolumeDataQueryHookResult = ReturnType<typeof useGetVolumeDataQuery>;
export type GetVolumeDataLazyQueryHookResult = ReturnType<typeof useGetVolumeDataLazyQuery>;
export type GetVolumeDataQueryResult = Apollo.QueryResult<GetVolumeDataQuery, GetVolumeDataQueryVariables>;
export const GetVolumesNamesListDocument = gql`
    query GetVolumesNamesList($organizationId: String, $workspaceId: String, $limit: Int, $cursor: String) {
  getVolumes(
    organizationId: $organizationId
    workspaceId: $workspaceId
    limit: $limit
    cursor: $cursor
  ) {
    volumeId
    name
  }
}
    `;

/**
 * __useGetVolumesNamesListQuery__
 *
 * To run a query within a React component, call `useGetVolumesNamesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolumesNamesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolumesNamesListQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetVolumesNamesListQuery(baseOptions?: Apollo.QueryHookOptions<GetVolumesNamesListQuery, GetVolumesNamesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVolumesNamesListQuery, GetVolumesNamesListQueryVariables>(GetVolumesNamesListDocument, options);
      }
export function useGetVolumesNamesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVolumesNamesListQuery, GetVolumesNamesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVolumesNamesListQuery, GetVolumesNamesListQueryVariables>(GetVolumesNamesListDocument, options);
        }
export type GetVolumesNamesListQueryHookResult = ReturnType<typeof useGetVolumesNamesListQuery>;
export type GetVolumesNamesListLazyQueryHookResult = ReturnType<typeof useGetVolumesNamesListLazyQuery>;
export type GetVolumesNamesListQueryResult = Apollo.QueryResult<GetVolumesNamesListQuery, GetVolumesNamesListQueryVariables>;
export const GetWorkspacesDocument = gql`
    query GetWorkspaces($organizationId: String, $workspaceId: String, $limit: Int, $cursor: String, $filters: WorkspaceFilter) {
  getWorkspaces(
    organizationId: $organizationId
    workspaceId: $workspaceId
    limit: $limit
    cursor: $cursor
    filters: $filters
  ) {
    workspaceId
    organizationId
    organization
    name
    createdAt
    updatedAt
    previewThumbnail
    status
    description
    tags
  }
}
    `;

/**
 * __useGetWorkspacesQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspacesQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspacesQuery, GetWorkspacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspacesQuery, GetWorkspacesQueryVariables>(GetWorkspacesDocument, options);
      }
export function useGetWorkspacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspacesQuery, GetWorkspacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspacesQuery, GetWorkspacesQueryVariables>(GetWorkspacesDocument, options);
        }
export type GetWorkspacesQueryHookResult = ReturnType<typeof useGetWorkspacesQuery>;
export type GetWorkspacesLazyQueryHookResult = ReturnType<typeof useGetWorkspacesLazyQuery>;
export type GetWorkspacesQueryResult = Apollo.QueryResult<GetWorkspacesQuery, GetWorkspacesQueryVariables>;
export const GetWorkspacesNameListDocument = gql`
    query GetWorkspacesNameList($organizationId: String, $limit: Int, $cursor: String, $filters: WorkspaceFilter) {
  getWorkspaces(
    organizationId: $organizationId
    limit: $limit
    cursor: $cursor
    filters: $filters
  ) {
    name
    workspaceId
  }
}
    `;

/**
 * __useGetWorkspacesNameListQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesNameListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesNameListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesNameListQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspacesNameListQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspacesNameListQuery, GetWorkspacesNameListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspacesNameListQuery, GetWorkspacesNameListQueryVariables>(GetWorkspacesNameListDocument, options);
      }
export function useGetWorkspacesNameListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspacesNameListQuery, GetWorkspacesNameListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspacesNameListQuery, GetWorkspacesNameListQueryVariables>(GetWorkspacesNameListDocument, options);
        }
export type GetWorkspacesNameListQueryHookResult = ReturnType<typeof useGetWorkspacesNameListQuery>;
export type GetWorkspacesNameListLazyQueryHookResult = ReturnType<typeof useGetWorkspacesNameListLazyQuery>;
export type GetWorkspacesNameListQueryResult = Apollo.QueryResult<GetWorkspacesNameListQuery, GetWorkspacesNameListQueryVariables>;
export const GetWorkspaceSettingsDocument = gql`
    query GetWorkspaceSettings($workspaceId: String!, $setting: String) {
  getWorkspaceSettings(workspaceId: $workspaceId, setting: $setting) {
    workspaceId
    setting
    limit
    usage
    units
  }
}
    `;

/**
 * __useGetWorkspaceSettingsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSettingsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      setting: // value for 'setting'
 *   },
 * });
 */
export function useGetWorkspaceSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>(GetWorkspaceSettingsDocument, options);
      }
export function useGetWorkspaceSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>(GetWorkspaceSettingsDocument, options);
        }
export type GetWorkspaceSettingsQueryHookResult = ReturnType<typeof useGetWorkspaceSettingsQuery>;
export type GetWorkspaceSettingsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceSettingsLazyQuery>;
export type GetWorkspaceSettingsQueryResult = Apollo.QueryResult<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>;
export const GetWorkspaceNameDocument = gql`
    query GetWorkspaceName($workspaceId: String) {
  getWorkspaces(workspaceId: $workspaceId) {
    name
    workspaceId
  }
}
    `;

/**
 * __useGetWorkspaceNameQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceNameQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceNameQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>(GetWorkspaceNameDocument, options);
      }
export function useGetWorkspaceNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>(GetWorkspaceNameDocument, options);
        }
export type GetWorkspaceNameQueryHookResult = ReturnType<typeof useGetWorkspaceNameQuery>;
export type GetWorkspaceNameLazyQueryHookResult = ReturnType<typeof useGetWorkspaceNameLazyQuery>;
export type GetWorkspaceNameQueryResult = Apollo.QueryResult<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>;
export const GetWorkspaceContextDataDocument = gql`
    query GetWorkspaceContextData($workspaceId: String) {
  getWorkspaces(workspaceId: $workspaceId) {
    description
    name
    organizationId
    status
    tags
    workspaceId
  }
}
    `;

/**
 * __useGetWorkspaceContextDataQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceContextDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceContextDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceContextDataQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceContextDataQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceContextDataQuery, GetWorkspaceContextDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceContextDataQuery, GetWorkspaceContextDataQueryVariables>(GetWorkspaceContextDataDocument, options);
      }
export function useGetWorkspaceContextDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceContextDataQuery, GetWorkspaceContextDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceContextDataQuery, GetWorkspaceContextDataQueryVariables>(GetWorkspaceContextDataDocument, options);
        }
export type GetWorkspaceContextDataQueryHookResult = ReturnType<typeof useGetWorkspaceContextDataQuery>;
export type GetWorkspaceContextDataLazyQueryHookResult = ReturnType<typeof useGetWorkspaceContextDataLazyQuery>;
export type GetWorkspaceContextDataQueryResult = Apollo.QueryResult<GetWorkspaceContextDataQuery, GetWorkspaceContextDataQueryVariables>;
export const GetOrganizationExpirationDataDocument = gql`
    query GetOrganizationExpirationData($organizationId: String) {
  getOrganizations(organizationId: $organizationId) {
    role
    expirationDate
    expired
    organizationId
  }
}
    `;

/**
 * __useGetOrganizationExpirationDataQuery__
 *
 * To run a query within a React component, call `useGetOrganizationExpirationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationExpirationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationExpirationDataQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationExpirationDataQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationExpirationDataQuery, GetOrganizationExpirationDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationExpirationDataQuery, GetOrganizationExpirationDataQueryVariables>(GetOrganizationExpirationDataDocument, options);
      }
export function useGetOrganizationExpirationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationExpirationDataQuery, GetOrganizationExpirationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationExpirationDataQuery, GetOrganizationExpirationDataQueryVariables>(GetOrganizationExpirationDataDocument, options);
        }
export type GetOrganizationExpirationDataQueryHookResult = ReturnType<typeof useGetOrganizationExpirationDataQuery>;
export type GetOrganizationExpirationDataLazyQueryHookResult = ReturnType<typeof useGetOrganizationExpirationDataLazyQuery>;
export type GetOrganizationExpirationDataQueryResult = Apollo.QueryResult<GetOrganizationExpirationDataQuery, GetOrganizationExpirationDataQueryVariables>;
export const GetLandingPageRecentWorkspacesDocument = gql`
    query GetLandingPageRecentWorkspaces($cursor: String, $limit: Int) {
  getWorkspaces(cursor: $cursor, limit: $limit) {
    name
    organization
    organizationId
    previewThumbnail
    status
    updatedAt
    workspaceId
  }
}
    `;

/**
 * __useGetLandingPageRecentWorkspacesQuery__
 *
 * To run a query within a React component, call `useGetLandingPageRecentWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLandingPageRecentWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLandingPageRecentWorkspacesQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetLandingPageRecentWorkspacesQuery(baseOptions?: Apollo.QueryHookOptions<GetLandingPageRecentWorkspacesQuery, GetLandingPageRecentWorkspacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLandingPageRecentWorkspacesQuery, GetLandingPageRecentWorkspacesQueryVariables>(GetLandingPageRecentWorkspacesDocument, options);
      }
export function useGetLandingPageRecentWorkspacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLandingPageRecentWorkspacesQuery, GetLandingPageRecentWorkspacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLandingPageRecentWorkspacesQuery, GetLandingPageRecentWorkspacesQueryVariables>(GetLandingPageRecentWorkspacesDocument, options);
        }
export type GetLandingPageRecentWorkspacesQueryHookResult = ReturnType<typeof useGetLandingPageRecentWorkspacesQuery>;
export type GetLandingPageRecentWorkspacesLazyQueryHookResult = ReturnType<typeof useGetLandingPageRecentWorkspacesLazyQuery>;
export type GetLandingPageRecentWorkspacesQueryResult = Apollo.QueryResult<GetLandingPageRecentWorkspacesQuery, GetLandingPageRecentWorkspacesQueryVariables>;
export const GetChannelDataForEditDocument = gql`
    query GetChannelDataForEdit($channelId: String!, $organizationId: String!) {
  getChannels(channelId: $channelId, organizationId: $organizationId) {
    channelId
    volumes
    timeout
  }
}
    `;

/**
 * __useGetChannelDataForEditQuery__
 *
 * To run a query within a React component, call `useGetChannelDataForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelDataForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelDataForEditQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetChannelDataForEditQuery(baseOptions: Apollo.QueryHookOptions<GetChannelDataForEditQuery, GetChannelDataForEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelDataForEditQuery, GetChannelDataForEditQueryVariables>(GetChannelDataForEditDocument, options);
      }
export function useGetChannelDataForEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelDataForEditQuery, GetChannelDataForEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelDataForEditQuery, GetChannelDataForEditQueryVariables>(GetChannelDataForEditDocument, options);
        }
export type GetChannelDataForEditQueryHookResult = ReturnType<typeof useGetChannelDataForEditQuery>;
export type GetChannelDataForEditLazyQueryHookResult = ReturnType<typeof useGetChannelDataForEditLazyQuery>;
export type GetChannelDataForEditQueryResult = Apollo.QueryResult<GetChannelDataForEditQuery, GetChannelDataForEditQueryVariables>;
export const GetOrganizationRemoteDevelopmentSessionsDocument = gql`
    query GetOrganizationRemoteDevelopmentSessions {
  listRemoteDevelopment {
    channelId
    ...ChannelTableRowSessionFragment
  }
}
    ${ChannelTableRowSessionFragmentFragmentDoc}`;

/**
 * __useGetOrganizationRemoteDevelopmentSessionsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationRemoteDevelopmentSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationRemoteDevelopmentSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationRemoteDevelopmentSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationRemoteDevelopmentSessionsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationRemoteDevelopmentSessionsQuery, GetOrganizationRemoteDevelopmentSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationRemoteDevelopmentSessionsQuery, GetOrganizationRemoteDevelopmentSessionsQueryVariables>(GetOrganizationRemoteDevelopmentSessionsDocument, options);
      }
export function useGetOrganizationRemoteDevelopmentSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationRemoteDevelopmentSessionsQuery, GetOrganizationRemoteDevelopmentSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationRemoteDevelopmentSessionsQuery, GetOrganizationRemoteDevelopmentSessionsQueryVariables>(GetOrganizationRemoteDevelopmentSessionsDocument, options);
        }
export type GetOrganizationRemoteDevelopmentSessionsQueryHookResult = ReturnType<typeof useGetOrganizationRemoteDevelopmentSessionsQuery>;
export type GetOrganizationRemoteDevelopmentSessionsLazyQueryHookResult = ReturnType<typeof useGetOrganizationRemoteDevelopmentSessionsLazyQuery>;
export type GetOrganizationRemoteDevelopmentSessionsQueryResult = Apollo.QueryResult<GetOrganizationRemoteDevelopmentSessionsQuery, GetOrganizationRemoteDevelopmentSessionsQueryVariables>;
export const GetOrganizationChannelsDocument = gql`
    query GetOrganizationChannels($organizationId: String, $filters: ChannelFilter, $limit: Int, $cursor: String) {
  getChannels(
    organizationId: $organizationId
    filters: $filters
    limit: $limit
    cursor: $cursor
  ) {
    channelId
    ...ChannelTableRowChannelFragment
  }
}
    ${ChannelTableRowChannelFragmentFragmentDoc}`;

/**
 * __useGetOrganizationChannelsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationChannelsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetOrganizationChannelsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationChannelsQuery, GetOrganizationChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationChannelsQuery, GetOrganizationChannelsQueryVariables>(GetOrganizationChannelsDocument, options);
      }
export function useGetOrganizationChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationChannelsQuery, GetOrganizationChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationChannelsQuery, GetOrganizationChannelsQueryVariables>(GetOrganizationChannelsDocument, options);
        }
export type GetOrganizationChannelsQueryHookResult = ReturnType<typeof useGetOrganizationChannelsQuery>;
export type GetOrganizationChannelsLazyQueryHookResult = ReturnType<typeof useGetOrganizationChannelsLazyQuery>;
export type GetOrganizationChannelsQueryResult = Apollo.QueryResult<GetOrganizationChannelsQuery, GetOrganizationChannelsQueryVariables>;
export const GetOrganizationJobsDocument = gql`
    query GetOrganizationJobs($organizationId: String) {
  getDatasetJobs(organizationId: $organizationId) {
    datasetId
    workspaceId
    name
    runs
    status
    createdAt
    estimatedEndAt
  }
}
    `;

/**
 * __useGetOrganizationJobsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationJobsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>(GetOrganizationJobsDocument, options);
      }
export function useGetOrganizationJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>(GetOrganizationJobsDocument, options);
        }
export type GetOrganizationJobsQueryHookResult = ReturnType<typeof useGetOrganizationJobsQuery>;
export type GetOrganizationJobsLazyQueryHookResult = ReturnType<typeof useGetOrganizationJobsLazyQuery>;
export type GetOrganizationJobsQueryResult = Apollo.QueryResult<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>;
export const GetWorkspacesSearchDetailDocument = gql`
    query GetWorkspacesSearchDetail($organizationId: String!, $filters: WorkspaceFilter) {
  getWorkspacesSearchDetail(organizationId: $organizationId, filters: $filters) {
    channels {
      value
      display
    }
    users {
      value
      display
    }
    tags {
      value
      display
    }
  }
}
    `;

/**
 * __useGetWorkspacesSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspacesSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables>(GetWorkspacesSearchDetailDocument, options);
      }
export function useGetWorkspacesSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables>(GetWorkspacesSearchDetailDocument, options);
        }
export type GetWorkspacesSearchDetailQueryHookResult = ReturnType<typeof useGetWorkspacesSearchDetailQuery>;
export type GetWorkspacesSearchDetailLazyQueryHookResult = ReturnType<typeof useGetWorkspacesSearchDetailLazyQuery>;
export type GetWorkspacesSearchDetailQueryResult = Apollo.QueryResult<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables>;
export const GetChannelsSearchDetailDocument = gql`
    query GetChannelsSearchDetail($organizationId: String, $filters: ChannelFilter, $workspaceId: String) {
  getChannelsSearchDetail(
    organizationId: $organizationId
    filters: $filters
    workspaceId: $workspaceId
  ) {
    users {
      value
      display
    }
    tags {
      value
      display
    }
  }
}
    `;

/**
 * __useGetChannelsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetChannelsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelsSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      filters: // value for 'filters'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetChannelsSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>(GetChannelsSearchDetailDocument, options);
      }
export function useGetChannelsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>(GetChannelsSearchDetailDocument, options);
        }
export type GetChannelsSearchDetailQueryHookResult = ReturnType<typeof useGetChannelsSearchDetailQuery>;
export type GetChannelsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetChannelsSearchDetailLazyQuery>;
export type GetChannelsSearchDetailQueryResult = Apollo.QueryResult<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>;
export const GetVolumesSearchDetailDocument = gql`
    query GetVolumesSearchDetail($organizationId: String, $workspaceId: String, $filters: VolumeFilter) {
  getVolumesSearchDetail(
    organizationId: $organizationId
    workspaceId: $workspaceId
    filters: $filters
  ) {
    tags {
      value
      display
    }
    users {
      value
      display
    }
  }
}
    `;

/**
 * __useGetVolumesSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetVolumesSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolumesSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolumesSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetVolumesSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>(GetVolumesSearchDetailDocument, options);
      }
export function useGetVolumesSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>(GetVolumesSearchDetailDocument, options);
        }
export type GetVolumesSearchDetailQueryHookResult = ReturnType<typeof useGetVolumesSearchDetailQuery>;
export type GetVolumesSearchDetailLazyQueryHookResult = ReturnType<typeof useGetVolumesSearchDetailLazyQuery>;
export type GetVolumesSearchDetailQueryResult = Apollo.QueryResult<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>;
export const GetAnnotationMapsSearchDetailDocument = gql`
    query GetAnnotationMapsSearchDetail($organizationId: String, $workspaceId: String, $filters: AnnotationMapFilter) {
  getAnnotationMapsSearchDetail(
    organizationId: $organizationId
    workspaceId: $workspaceId
    filters: $filters
  ) {
    users {
      value
      display
    }
    tags {
      value
      display
    }
  }
}
    `;

/**
 * __useGetAnnotationMapsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetAnnotationMapsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationMapsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationMapsSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAnnotationMapsSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>(GetAnnotationMapsSearchDetailDocument, options);
      }
export function useGetAnnotationMapsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>(GetAnnotationMapsSearchDetailDocument, options);
        }
export type GetAnnotationMapsSearchDetailQueryHookResult = ReturnType<typeof useGetAnnotationMapsSearchDetailQuery>;
export type GetAnnotationMapsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetAnnotationMapsSearchDetailLazyQuery>;
export type GetAnnotationMapsSearchDetailQueryResult = Apollo.QueryResult<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>;
export const GetGANModelsSearchDetailDocument = gql`
    query GetGANModelsSearchDetail($organizationId: String, $workspaceId: String, $filters: GANModelFilter) {
  getGANModelsSearchDetail(
    organizationId: $organizationId
    workspaceId: $workspaceId
    filters: $filters
  ) {
    users {
      value
      display
    }
    tags {
      value
      display
    }
  }
}
    `;

/**
 * __useGetGANModelsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetGANModelsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGANModelsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGANModelsSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetGANModelsSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetGANModelsSearchDetailQuery, GetGANModelsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGANModelsSearchDetailQuery, GetGANModelsSearchDetailQueryVariables>(GetGANModelsSearchDetailDocument, options);
      }
export function useGetGANModelsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGANModelsSearchDetailQuery, GetGANModelsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGANModelsSearchDetailQuery, GetGANModelsSearchDetailQueryVariables>(GetGANModelsSearchDetailDocument, options);
        }
export type GetGANModelsSearchDetailQueryHookResult = ReturnType<typeof useGetGANModelsSearchDetailQuery>;
export type GetGANModelsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetGANModelsSearchDetailLazyQuery>;
export type GetGANModelsSearchDetailQueryResult = Apollo.QueryResult<GetGANModelsSearchDetailQuery, GetGANModelsSearchDetailQueryVariables>;
export const GetContentCodesDocument = gql`
    query GetContentCodes {
  getContentCodes {
    code
    name
    description
    thumbnail
    link
    featured
    contactUs
    expiresAt
  }
}
    `;

/**
 * __useGetContentCodesQuery__
 *
 * To run a query within a React component, call `useGetContentCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContentCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetContentCodesQuery, GetContentCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentCodesQuery, GetContentCodesQueryVariables>(GetContentCodesDocument, options);
      }
export function useGetContentCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentCodesQuery, GetContentCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentCodesQuery, GetContentCodesQueryVariables>(GetContentCodesDocument, options);
        }
export type GetContentCodesQueryHookResult = ReturnType<typeof useGetContentCodesQuery>;
export type GetContentCodesLazyQueryHookResult = ReturnType<typeof useGetContentCodesLazyQuery>;
export type GetContentCodesQueryResult = Apollo.QueryResult<GetContentCodesQuery, GetContentCodesQueryVariables>;
export const GetWorkspaceTableWorkspaceChannelsDocument = gql`
    query GetWorkspaceTableWorkspaceChannels($workspaceId: String!) {
  getChannels(workspaceId: $workspaceId) {
    channelId
    name
  }
}
    `;

/**
 * __useGetWorkspaceTableWorkspaceChannelsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceTableWorkspaceChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceTableWorkspaceChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceTableWorkspaceChannelsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceTableWorkspaceChannelsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceTableWorkspaceChannelsQuery, GetWorkspaceTableWorkspaceChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceTableWorkspaceChannelsQuery, GetWorkspaceTableWorkspaceChannelsQueryVariables>(GetWorkspaceTableWorkspaceChannelsDocument, options);
      }
export function useGetWorkspaceTableWorkspaceChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceTableWorkspaceChannelsQuery, GetWorkspaceTableWorkspaceChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceTableWorkspaceChannelsQuery, GetWorkspaceTableWorkspaceChannelsQueryVariables>(GetWorkspaceTableWorkspaceChannelsDocument, options);
        }
export type GetWorkspaceTableWorkspaceChannelsQueryHookResult = ReturnType<typeof useGetWorkspaceTableWorkspaceChannelsQuery>;
export type GetWorkspaceTableWorkspaceChannelsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceTableWorkspaceChannelsLazyQuery>;
export type GetWorkspaceTableWorkspaceChannelsQueryResult = Apollo.QueryResult<GetWorkspaceTableWorkspaceChannelsQuery, GetWorkspaceTableWorkspaceChannelsQueryVariables>;
export const CreateRemoteSessionGetUserOrgsDocument = gql`
    query CreateRemoteSessionGetUserOrgs {
  getOrganizations {
    expired
    name
    organizationId
  }
}
    `;

/**
 * __useCreateRemoteSessionGetUserOrgsQuery__
 *
 * To run a query within a React component, call `useCreateRemoteSessionGetUserOrgsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateRemoteSessionGetUserOrgsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateRemoteSessionGetUserOrgsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateRemoteSessionGetUserOrgsQuery(baseOptions?: Apollo.QueryHookOptions<CreateRemoteSessionGetUserOrgsQuery, CreateRemoteSessionGetUserOrgsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateRemoteSessionGetUserOrgsQuery, CreateRemoteSessionGetUserOrgsQueryVariables>(CreateRemoteSessionGetUserOrgsDocument, options);
      }
export function useCreateRemoteSessionGetUserOrgsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateRemoteSessionGetUserOrgsQuery, CreateRemoteSessionGetUserOrgsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateRemoteSessionGetUserOrgsQuery, CreateRemoteSessionGetUserOrgsQueryVariables>(CreateRemoteSessionGetUserOrgsDocument, options);
        }
export type CreateRemoteSessionGetUserOrgsQueryHookResult = ReturnType<typeof useCreateRemoteSessionGetUserOrgsQuery>;
export type CreateRemoteSessionGetUserOrgsLazyQueryHookResult = ReturnType<typeof useCreateRemoteSessionGetUserOrgsLazyQuery>;
export type CreateRemoteSessionGetUserOrgsQueryResult = Apollo.QueryResult<CreateRemoteSessionGetUserOrgsQuery, CreateRemoteSessionGetUserOrgsQueryVariables>;
export const CreateRemoteSessionGetOrgChannelsDocument = gql`
    query CreateRemoteSessionGetOrgChannels($organizationId: String) {
  getChannels(organizationId: $organizationId) {
    channelId
    instanceType
    name
    organizationId
    state
    version
  }
}
    `;

/**
 * __useCreateRemoteSessionGetOrgChannelsQuery__
 *
 * To run a query within a React component, call `useCreateRemoteSessionGetOrgChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateRemoteSessionGetOrgChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateRemoteSessionGetOrgChannelsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCreateRemoteSessionGetOrgChannelsQuery(baseOptions?: Apollo.QueryHookOptions<CreateRemoteSessionGetOrgChannelsQuery, CreateRemoteSessionGetOrgChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateRemoteSessionGetOrgChannelsQuery, CreateRemoteSessionGetOrgChannelsQueryVariables>(CreateRemoteSessionGetOrgChannelsDocument, options);
      }
export function useCreateRemoteSessionGetOrgChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateRemoteSessionGetOrgChannelsQuery, CreateRemoteSessionGetOrgChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateRemoteSessionGetOrgChannelsQuery, CreateRemoteSessionGetOrgChannelsQueryVariables>(CreateRemoteSessionGetOrgChannelsDocument, options);
        }
export type CreateRemoteSessionGetOrgChannelsQueryHookResult = ReturnType<typeof useCreateRemoteSessionGetOrgChannelsQuery>;
export type CreateRemoteSessionGetOrgChannelsLazyQueryHookResult = ReturnType<typeof useCreateRemoteSessionGetOrgChannelsLazyQuery>;
export type CreateRemoteSessionGetOrgChannelsQueryResult = Apollo.QueryResult<CreateRemoteSessionGetOrgChannelsQuery, CreateRemoteSessionGetOrgChannelsQueryVariables>;
export const GetAPIKeysDocument = gql`
    query GetAPIKeys {
  getAPIKeys {
    createdAt
    expiresAt
    name
    organizationId
    scope
    workspaceId
  }
}
    `;

/**
 * __useGetAPIKeysQuery__
 *
 * To run a query within a React component, call `useGetAPIKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAPIKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAPIKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAPIKeysQuery(baseOptions?: Apollo.QueryHookOptions<GetAPIKeysQuery, GetAPIKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAPIKeysQuery, GetAPIKeysQueryVariables>(GetAPIKeysDocument, options);
      }
export function useGetAPIKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAPIKeysQuery, GetAPIKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAPIKeysQuery, GetAPIKeysQueryVariables>(GetAPIKeysDocument, options);
        }
export type GetAPIKeysQueryHookResult = ReturnType<typeof useGetAPIKeysQuery>;
export type GetAPIKeysLazyQueryHookResult = ReturnType<typeof useGetAPIKeysLazyQuery>;
export type GetAPIKeysQueryResult = Apollo.QueryResult<GetAPIKeysQuery, GetAPIKeysQueryVariables>;
export const GetSSHKeysDocument = gql`
    query GetSSHKeys {
  getSSHKeys {
    name
    key
    createdAt
  }
}
    `;

/**
 * __useGetSSHKeysQuery__
 *
 * To run a query within a React component, call `useGetSSHKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSSHKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSSHKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSSHKeysQuery(baseOptions?: Apollo.QueryHookOptions<GetSSHKeysQuery, GetSSHKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSSHKeysQuery, GetSSHKeysQueryVariables>(GetSSHKeysDocument, options);
      }
export function useGetSSHKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSSHKeysQuery, GetSSHKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSSHKeysQuery, GetSSHKeysQueryVariables>(GetSSHKeysDocument, options);
        }
export type GetSSHKeysQueryHookResult = ReturnType<typeof useGetSSHKeysQuery>;
export type GetSSHKeysLazyQueryHookResult = ReturnType<typeof useGetSSHKeysLazyQuery>;
export type GetSSHKeysQueryResult = Apollo.QueryResult<GetSSHKeysQuery, GetSSHKeysQueryVariables>;
export const GetVolumeDetailsVolumeDataDocument = gql`
    query GetVolumeDetailsVolumeData($volumeId: String) {
  getVolumes(volumeId: $volumeId) {
    volumeId
    name
    permission
  }
}
    `;

/**
 * __useGetVolumeDetailsVolumeDataQuery__
 *
 * To run a query within a React component, call `useGetVolumeDetailsVolumeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolumeDetailsVolumeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolumeDetailsVolumeDataQuery({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *   },
 * });
 */
export function useGetVolumeDetailsVolumeDataQuery(baseOptions?: Apollo.QueryHookOptions<GetVolumeDetailsVolumeDataQuery, GetVolumeDetailsVolumeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVolumeDetailsVolumeDataQuery, GetVolumeDetailsVolumeDataQueryVariables>(GetVolumeDetailsVolumeDataDocument, options);
      }
export function useGetVolumeDetailsVolumeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVolumeDetailsVolumeDataQuery, GetVolumeDetailsVolumeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVolumeDetailsVolumeDataQuery, GetVolumeDetailsVolumeDataQueryVariables>(GetVolumeDetailsVolumeDataDocument, options);
        }
export type GetVolumeDetailsVolumeDataQueryHookResult = ReturnType<typeof useGetVolumeDetailsVolumeDataQuery>;
export type GetVolumeDetailsVolumeDataLazyQueryHookResult = ReturnType<typeof useGetVolumeDetailsVolumeDataLazyQuery>;
export type GetVolumeDetailsVolumeDataQueryResult = Apollo.QueryResult<GetVolumeDetailsVolumeDataQuery, GetVolumeDetailsVolumeDataQueryVariables>;
export const GetDatasetRunsCountDocument = gql`
    query GetDatasetRunsCount($workspaceId: String!, $datasetId: String!) {
  getDatasets(workspaceId: $workspaceId, datasetId: $datasetId) {
    datasetId
    runs
  }
}
    `;

/**
 * __useGetDatasetRunsCountQuery__
 *
 * To run a query within a React component, call `useGetDatasetRunsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetRunsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetRunsCountQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetRunsCountQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetRunsCountQuery, GetDatasetRunsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetRunsCountQuery, GetDatasetRunsCountQueryVariables>(GetDatasetRunsCountDocument, options);
      }
export function useGetDatasetRunsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetRunsCountQuery, GetDatasetRunsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetRunsCountQuery, GetDatasetRunsCountQueryVariables>(GetDatasetRunsCountDocument, options);
        }
export type GetDatasetRunsCountQueryHookResult = ReturnType<typeof useGetDatasetRunsCountQuery>;
export type GetDatasetRunsCountLazyQueryHookResult = ReturnType<typeof useGetDatasetRunsCountLazyQuery>;
export type GetDatasetRunsCountQueryResult = Apollo.QueryResult<GetDatasetRunsCountQuery, GetDatasetRunsCountQueryVariables>;
export const GetWorkspaceAnalyticsDocument = gql`
    query GetWorkspaceAnalytics($workspaceId: String!, $cursor: String, $limit: Int, $filters: AnalyticsFilter) {
  getAnalytics(
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    analyticsId
    createdAt
    createdBy
    dataset
    datasetId
    result
    status
    tags
    type
    workspaceId
  }
}
    `;

/**
 * __useGetWorkspaceAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceAnalyticsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspaceAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables>(GetWorkspaceAnalyticsDocument, options);
      }
export function useGetWorkspaceAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables>(GetWorkspaceAnalyticsDocument, options);
        }
export type GetWorkspaceAnalyticsQueryHookResult = ReturnType<typeof useGetWorkspaceAnalyticsQuery>;
export type GetWorkspaceAnalyticsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceAnalyticsLazyQuery>;
export type GetWorkspaceAnalyticsQueryResult = Apollo.QueryResult<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables>;
export const GetAnalyticsSearchDetailDocument = gql`
    query GetAnalyticsSearchDetail($workspaceId: String!, $filters: AnalyticsFilter, $datasetId: String) {
  getAnalyticsSearchDetail(
    workspaceId: $workspaceId
    filters: $filters
    datasetId: $datasetId
  ) {
    status {
      display
      value
    }
    tags {
      value
      display
    }
    users {
      value
      display
    }
  }
}
    `;

/**
 * __useGetAnalyticsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsSearchDetailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetAnalyticsSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables>(GetAnalyticsSearchDetailDocument, options);
      }
export function useGetAnalyticsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables>(GetAnalyticsSearchDetailDocument, options);
        }
export type GetAnalyticsSearchDetailQueryHookResult = ReturnType<typeof useGetAnalyticsSearchDetailQuery>;
export type GetAnalyticsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetAnalyticsSearchDetailLazyQuery>;
export type GetAnalyticsSearchDetailQueryResult = Apollo.QueryResult<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables>;
export const GetWorkspaceUMAPsDocument = gql`
    query GetWorkspaceUMAPs($workspaceId: String!, $cursor: String, $limit: Int, $filters: UMAPFilter) {
  getUMAPs(
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    createdAt
    createdBy
    datasets {
      dataset
      datasetId
    }
    name
    results
    samples
    seed
    status
    tags
    umapId
    workspaceId
  }
}
    `;

/**
 * __useGetWorkspaceUMAPsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceUMAPsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceUMAPsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceUMAPsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspaceUMAPsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceUMAPsQuery, GetWorkspaceUMAPsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceUMAPsQuery, GetWorkspaceUMAPsQueryVariables>(GetWorkspaceUMAPsDocument, options);
      }
export function useGetWorkspaceUMAPsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceUMAPsQuery, GetWorkspaceUMAPsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceUMAPsQuery, GetWorkspaceUMAPsQueryVariables>(GetWorkspaceUMAPsDocument, options);
        }
export type GetWorkspaceUMAPsQueryHookResult = ReturnType<typeof useGetWorkspaceUMAPsQuery>;
export type GetWorkspaceUMAPsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceUMAPsLazyQuery>;
export type GetWorkspaceUMAPsQueryResult = Apollo.QueryResult<GetWorkspaceUMAPsQuery, GetWorkspaceUMAPsQueryVariables>;
export const GetUMAPsSearchDetailDocument = gql`
    query GetUMAPsSearchDetail($workspaceId: String!, $datasetId: String, $filters: UMAPFilter) {
  getUMAPsSearchDetail(
    workspaceId: $workspaceId
    datasetId: $datasetId
    filters: $filters
  ) {
    users {
      value
      display
    }
    tags {
      value
      display
    }
    status {
      value
      display
    }
  }
}
    `;

/**
 * __useGetUMAPsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetUMAPsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUMAPsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUMAPsSearchDetailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetUMAPsSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetUMAPsSearchDetailQuery, GetUMAPsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUMAPsSearchDetailQuery, GetUMAPsSearchDetailQueryVariables>(GetUMAPsSearchDetailDocument, options);
      }
export function useGetUMAPsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUMAPsSearchDetailQuery, GetUMAPsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUMAPsSearchDetailQuery, GetUMAPsSearchDetailQueryVariables>(GetUMAPsSearchDetailDocument, options);
        }
export type GetUMAPsSearchDetailQueryHookResult = ReturnType<typeof useGetUMAPsSearchDetailQuery>;
export type GetUMAPsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetUMAPsSearchDetailLazyQuery>;
export type GetUMAPsSearchDetailQueryResult = Apollo.QueryResult<GetUMAPsSearchDetailQuery, GetUMAPsSearchDetailQueryVariables>;
export const GetWorkspaceMLModelsDocument = gql`
    query GetWorkspaceMLModels($workspaceId: String!, $cursor: String, $limit: Int, $filters: MLModelFilter) {
  getMLModels(
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    architecture
    architectureId
    checkpoints
    classes
    createdBy
    createdAt
    dataset
    datasetId
    description
    map
    mapId
    metrics
    modelId
    name
    parameters
    status
    tags
  }
}
    `;

/**
 * __useGetWorkspaceMLModelsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceMLModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceMLModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceMLModelsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspaceMLModelsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceMLModelsQuery, GetWorkspaceMLModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceMLModelsQuery, GetWorkspaceMLModelsQueryVariables>(GetWorkspaceMLModelsDocument, options);
      }
export function useGetWorkspaceMLModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceMLModelsQuery, GetWorkspaceMLModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceMLModelsQuery, GetWorkspaceMLModelsQueryVariables>(GetWorkspaceMLModelsDocument, options);
        }
export type GetWorkspaceMLModelsQueryHookResult = ReturnType<typeof useGetWorkspaceMLModelsQuery>;
export type GetWorkspaceMLModelsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceMLModelsLazyQuery>;
export type GetWorkspaceMLModelsQueryResult = Apollo.QueryResult<GetWorkspaceMLModelsQuery, GetWorkspaceMLModelsQueryVariables>;
export const GetMLModelsSearchDetailDocument = gql`
    query GetMLModelsSearchDetail($workspaceId: String!, $datasetId: String, $filters: MLModelFilter) {
  getMLModelsSearchDetail(
    workspaceId: $workspaceId
    datasetId: $datasetId
    filters: $filters
  ) {
    users {
      value
      display
    }
    tags {
      value
      display
    }
    status {
      value
      display
    }
    architectures {
      value
      display
    }
  }
}
    `;

/**
 * __useGetMLModelsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetMLModelsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMLModelsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMLModelsSearchDetailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMLModelsSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetMLModelsSearchDetailQuery, GetMLModelsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMLModelsSearchDetailQuery, GetMLModelsSearchDetailQueryVariables>(GetMLModelsSearchDetailDocument, options);
      }
export function useGetMLModelsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMLModelsSearchDetailQuery, GetMLModelsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMLModelsSearchDetailQuery, GetMLModelsSearchDetailQueryVariables>(GetMLModelsSearchDetailDocument, options);
        }
export type GetMLModelsSearchDetailQueryHookResult = ReturnType<typeof useGetMLModelsSearchDetailQuery>;
export type GetMLModelsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetMLModelsSearchDetailLazyQuery>;
export type GetMLModelsSearchDetailQueryResult = Apollo.QueryResult<GetMLModelsSearchDetailQuery, GetMLModelsSearchDetailQueryVariables>;
export const GetWorkspaceMLInferencesDocument = gql`
    query GetWorkspaceMLInferences($workspaceId: String!, $cursor: String, $limit: Int, $filters: MLInferenceFilter) {
  getMLInferences(
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    datasetId
    dataset
    map
    mapId
    metrics
    model
    modelId
    status
    inferenceId
    workspaceId
    createdBy
    createdAt
    tags
  }
}
    `;

/**
 * __useGetWorkspaceMLInferencesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceMLInferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceMLInferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceMLInferencesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspaceMLInferencesQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceMLInferencesQuery, GetWorkspaceMLInferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceMLInferencesQuery, GetWorkspaceMLInferencesQueryVariables>(GetWorkspaceMLInferencesDocument, options);
      }
export function useGetWorkspaceMLInferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceMLInferencesQuery, GetWorkspaceMLInferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceMLInferencesQuery, GetWorkspaceMLInferencesQueryVariables>(GetWorkspaceMLInferencesDocument, options);
        }
export type GetWorkspaceMLInferencesQueryHookResult = ReturnType<typeof useGetWorkspaceMLInferencesQuery>;
export type GetWorkspaceMLInferencesLazyQueryHookResult = ReturnType<typeof useGetWorkspaceMLInferencesLazyQuery>;
export type GetWorkspaceMLInferencesQueryResult = Apollo.QueryResult<GetWorkspaceMLInferencesQuery, GetWorkspaceMLInferencesQueryVariables>;
export const GetMLInferencesSearchDetailDocument = gql`
    query GetMLInferencesSearchDetail($workspaceId: String!, $datasetId: String, $filters: MLInferenceFilter) {
  getMLInferencesSearchDetail(
    workspaceId: $workspaceId
    datasetId: $datasetId
    filters: $filters
  ) {
    users {
      value
      display
    }
    tags {
      value
      display
    }
    status {
      value
      display
    }
    architectures {
      value
      display
    }
  }
}
    `;

/**
 * __useGetMLInferencesSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetMLInferencesSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMLInferencesSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMLInferencesSearchDetailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMLInferencesSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetMLInferencesSearchDetailQuery, GetMLInferencesSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMLInferencesSearchDetailQuery, GetMLInferencesSearchDetailQueryVariables>(GetMLInferencesSearchDetailDocument, options);
      }
export function useGetMLInferencesSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMLInferencesSearchDetailQuery, GetMLInferencesSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMLInferencesSearchDetailQuery, GetMLInferencesSearchDetailQueryVariables>(GetMLInferencesSearchDetailDocument, options);
        }
export type GetMLInferencesSearchDetailQueryHookResult = ReturnType<typeof useGetMLInferencesSearchDetailQuery>;
export type GetMLInferencesSearchDetailLazyQueryHookResult = ReturnType<typeof useGetMLInferencesSearchDetailLazyQuery>;
export type GetMLInferencesSearchDetailQueryResult = Apollo.QueryResult<GetMLInferencesSearchDetailQuery, GetMLInferencesSearchDetailQueryVariables>;
export const GetMLModelInferencesDocument = gql`
    query GetMLModelInferences($workspaceId: String!, $modelId: String) {
  getMLInferences(workspaceId: $workspaceId, modelId: $modelId) {
    datasetId
    dataset
    model
    modelId
    status
    inferenceId
    tags
    workspaceId
  }
}
    `;

/**
 * __useGetMLModelInferencesQuery__
 *
 * To run a query within a React component, call `useGetMLModelInferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMLModelInferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMLModelInferencesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useGetMLModelInferencesQuery(baseOptions: Apollo.QueryHookOptions<GetMLModelInferencesQuery, GetMLModelInferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMLModelInferencesQuery, GetMLModelInferencesQueryVariables>(GetMLModelInferencesDocument, options);
      }
export function useGetMLModelInferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMLModelInferencesQuery, GetMLModelInferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMLModelInferencesQuery, GetMLModelInferencesQueryVariables>(GetMLModelInferencesDocument, options);
        }
export type GetMLModelInferencesQueryHookResult = ReturnType<typeof useGetMLModelInferencesQuery>;
export type GetMLModelInferencesLazyQueryHookResult = ReturnType<typeof useGetMLModelInferencesLazyQuery>;
export type GetMLModelInferencesQueryResult = Apollo.QueryResult<GetMLModelInferencesQuery, GetMLModelInferencesQueryVariables>;
export const GetDatasetFilesCountDocument = gql`
    query GetDatasetFilesCount($workspaceId: String!, $datasetId: String!) {
  getDatasets(workspaceId: $workspaceId, datasetId: $datasetId) {
    datasetId
    files
  }
}
    `;

/**
 * __useGetDatasetFilesCountQuery__
 *
 * To run a query within a React component, call `useGetDatasetFilesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetFilesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetFilesCountQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetFilesCountQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetFilesCountQuery, GetDatasetFilesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetFilesCountQuery, GetDatasetFilesCountQueryVariables>(GetDatasetFilesCountDocument, options);
      }
export function useGetDatasetFilesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetFilesCountQuery, GetDatasetFilesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetFilesCountQuery, GetDatasetFilesCountQueryVariables>(GetDatasetFilesCountDocument, options);
        }
export type GetDatasetFilesCountQueryHookResult = ReturnType<typeof useGetDatasetFilesCountQuery>;
export type GetDatasetFilesCountLazyQueryHookResult = ReturnType<typeof useGetDatasetFilesCountLazyQuery>;
export type GetDatasetFilesCountQueryResult = Apollo.QueryResult<GetDatasetFilesCountQuery, GetDatasetFilesCountQueryVariables>;
export const GetAddGraphAvailableChannelsDocument = gql`
    query GetAddGraphAvailableChannels($workspaceId: String!) {
  getChannels(workspaceId: $workspaceId) {
    channelId
    name
  }
}
    `;

/**
 * __useGetAddGraphAvailableChannelsQuery__
 *
 * To run a query within a React component, call `useGetAddGraphAvailableChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddGraphAvailableChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddGraphAvailableChannelsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetAddGraphAvailableChannelsQuery(baseOptions: Apollo.QueryHookOptions<GetAddGraphAvailableChannelsQuery, GetAddGraphAvailableChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddGraphAvailableChannelsQuery, GetAddGraphAvailableChannelsQueryVariables>(GetAddGraphAvailableChannelsDocument, options);
      }
export function useGetAddGraphAvailableChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddGraphAvailableChannelsQuery, GetAddGraphAvailableChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddGraphAvailableChannelsQuery, GetAddGraphAvailableChannelsQueryVariables>(GetAddGraphAvailableChannelsDocument, options);
        }
export type GetAddGraphAvailableChannelsQueryHookResult = ReturnType<typeof useGetAddGraphAvailableChannelsQuery>;
export type GetAddGraphAvailableChannelsLazyQueryHookResult = ReturnType<typeof useGetAddGraphAvailableChannelsLazyQuery>;
export type GetAddGraphAvailableChannelsQueryResult = Apollo.QueryResult<GetAddGraphAvailableChannelsQuery, GetAddGraphAvailableChannelsQueryVariables>;
export const GraphUpdatedDocument = gql`
    subscription GraphUpdated($workspaceId: String!, $graphId: String!, $uid: String!) {
  graphUpdates(workspaceId: $workspaceId, graphId: $graphId, uid: $uid) {
    name
    description
    graphId
    graph
  }
}
    `;

/**
 * __useGraphUpdatedSubscription__
 *
 * To run a query within a React component, call `useGraphUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGraphUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGraphUpdatedSubscription({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGraphUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<GraphUpdatedSubscription, GraphUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GraphUpdatedSubscription, GraphUpdatedSubscriptionVariables>(GraphUpdatedDocument, options);
      }
export type GraphUpdatedSubscriptionHookResult = ReturnType<typeof useGraphUpdatedSubscription>;
export type GraphUpdatedSubscriptionResult = Apollo.SubscriptionResult<GraphUpdatedSubscription>;
export const GetGraphsDocument = gql`
    query GetGraphs($workspaceId: String!, $staged: Boolean, $cursor: String, $limit: Int) {
  getGraphs(
    workspaceId: $workspaceId
    staged: $staged
    cursor: $cursor
    limit: $limit
  ) {
    channel
    createdAt
    createdBy
    description
    graphId
    name
    tags
    thumbnail
    updatedAt
    workspaceId
  }
}
    `;

/**
 * __useGetGraphsQuery__
 *
 * To run a query within a React component, call `useGetGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      staged: // value for 'staged'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetGraphsQuery(baseOptions: Apollo.QueryHookOptions<GetGraphsQuery, GetGraphsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphsQuery, GetGraphsQueryVariables>(GetGraphsDocument, options);
      }
export function useGetGraphsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphsQuery, GetGraphsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphsQuery, GetGraphsQueryVariables>(GetGraphsDocument, options);
        }
export type GetGraphsQueryHookResult = ReturnType<typeof useGetGraphsQuery>;
export type GetGraphsLazyQueryHookResult = ReturnType<typeof useGetGraphsLazyQuery>;
export type GetGraphsQueryResult = Apollo.QueryResult<GetGraphsQuery, GetGraphsQueryVariables>;
export const GetGraphMetadataDocument = gql`
    query GetGraphMetadata($workspaceId: String!, $graphId: String) {
  getGraphs(workspaceId: $workspaceId, graphId: $graphId) {
    channel
    channelId
    description
    graphId
    name
    previewId
    readOnly
    showPreview
    tags
    workspaceId
    updatedAt
  }
}
    `;

/**
 * __useGetGraphMetadataQuery__
 *
 * To run a query within a React component, call `useGetGraphMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphMetadataQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *   },
 * });
 */
export function useGetGraphMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetGraphMetadataQuery, GetGraphMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphMetadataQuery, GetGraphMetadataQueryVariables>(GetGraphMetadataDocument, options);
      }
export function useGetGraphMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphMetadataQuery, GetGraphMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphMetadataQuery, GetGraphMetadataQueryVariables>(GetGraphMetadataDocument, options);
        }
export type GetGraphMetadataQueryHookResult = ReturnType<typeof useGetGraphMetadataQuery>;
export type GetGraphMetadataLazyQueryHookResult = ReturnType<typeof useGetGraphMetadataLazyQuery>;
export type GetGraphMetadataQueryResult = Apollo.QueryResult<GetGraphMetadataQuery, GetGraphMetadataQueryVariables>;
export const GetPreviewDocument = gql`
    query GetPreview($workspaceId: String!, $previewId: String!) {
  getPreview(workspaceId: $workspaceId, previewId: $previewId) {
    status
    previewId
    thumbnail
    updatedAt
    workspaceId
  }
}
    `;

/**
 * __useGetPreviewQuery__
 *
 * To run a query within a React component, call `useGetPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      previewId: // value for 'previewId'
 *   },
 * });
 */
export function useGetPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetPreviewQuery, GetPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviewQuery, GetPreviewQueryVariables>(GetPreviewDocument, options);
      }
export function useGetPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviewQuery, GetPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviewQuery, GetPreviewQueryVariables>(GetPreviewDocument, options);
        }
export type GetPreviewQueryHookResult = ReturnType<typeof useGetPreviewQuery>;
export type GetPreviewLazyQueryHookResult = ReturnType<typeof useGetPreviewLazyQuery>;
export type GetPreviewQueryResult = Apollo.QueryResult<GetPreviewQuery, GetPreviewQueryVariables>;
export const GetGraphLastUpdatedDocument = gql`
    query GetGraphLastUpdated($workspaceId: String!, $graphId: String) {
  getGraphs(workspaceId: $workspaceId, graphId: $graphId) {
    graphId
    updatedAt
  }
}
    `;

/**
 * __useGetGraphLastUpdatedQuery__
 *
 * To run a query within a React component, call `useGetGraphLastUpdatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphLastUpdatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphLastUpdatedQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *   },
 * });
 */
export function useGetGraphLastUpdatedQuery(baseOptions: Apollo.QueryHookOptions<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables>(GetGraphLastUpdatedDocument, options);
      }
export function useGetGraphLastUpdatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables>(GetGraphLastUpdatedDocument, options);
        }
export type GetGraphLastUpdatedQueryHookResult = ReturnType<typeof useGetGraphLastUpdatedQuery>;
export type GetGraphLastUpdatedLazyQueryHookResult = ReturnType<typeof useGetGraphLastUpdatedLazyQuery>;
export type GetGraphLastUpdatedQueryResult = Apollo.QueryResult<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables>;
export const GetChannelSchemaDocument = gql`
    query GetChannelSchema($channelId: String) {
  getChannelSchema(channelId: $channelId)
}
    `;

/**
 * __useGetChannelSchemaQuery__
 *
 * To run a query within a React component, call `useGetChannelSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelSchemaQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetChannelSchemaQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>(GetChannelSchemaDocument, options);
      }
export function useGetChannelSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>(GetChannelSchemaDocument, options);
        }
export type GetChannelSchemaQueryHookResult = ReturnType<typeof useGetChannelSchemaQuery>;
export type GetChannelSchemaLazyQueryHookResult = ReturnType<typeof useGetChannelSchemaLazyQuery>;
export type GetChannelSchemaQueryResult = Apollo.QueryResult<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>;
export const GetPreviewLogDocument = gql`
    query GetPreviewLog($workspaceId: String!, $previewId: String!) {
  getPreviewLog(workspaceId: $workspaceId, previewId: $previewId) {
    log
    previewId
    status
  }
}
    `;

/**
 * __useGetPreviewLogQuery__
 *
 * To run a query within a React component, call `useGetPreviewLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      previewId: // value for 'previewId'
 *   },
 * });
 */
export function useGetPreviewLogQuery(baseOptions: Apollo.QueryHookOptions<GetPreviewLogQuery, GetPreviewLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviewLogQuery, GetPreviewLogQueryVariables>(GetPreviewLogDocument, options);
      }
export function useGetPreviewLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviewLogQuery, GetPreviewLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviewLogQuery, GetPreviewLogQueryVariables>(GetPreviewLogDocument, options);
        }
export type GetPreviewLogQueryHookResult = ReturnType<typeof useGetPreviewLogQuery>;
export type GetPreviewLogLazyQueryHookResult = ReturnType<typeof useGetPreviewLogLazyQuery>;
export type GetPreviewLogQueryResult = Apollo.QueryResult<GetPreviewLogQuery, GetPreviewLogQueryVariables>;
export const GetGraphsWithFiltersDocument = gql`
    query GetGraphsWithFilters($workspaceId: String!, $filters: GraphFilter, $staged: Boolean, $cursor: String, $limit: Int) {
  getGraphs(
    workspaceId: $workspaceId
    filters: $filters
    staged: $staged
    cursor: $cursor
    limit: $limit
  ) {
    channel
    createdAt
    createdBy
    description
    graphId
    name
    tags
    thumbnail
    updatedAt
    workspaceId
  }
}
    `;

/**
 * __useGetGraphsWithFiltersQuery__
 *
 * To run a query within a React component, call `useGetGraphsWithFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphsWithFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphsWithFiltersQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *      staged: // value for 'staged'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetGraphsWithFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables>(GetGraphsWithFiltersDocument, options);
      }
export function useGetGraphsWithFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables>(GetGraphsWithFiltersDocument, options);
        }
export type GetGraphsWithFiltersQueryHookResult = ReturnType<typeof useGetGraphsWithFiltersQuery>;
export type GetGraphsWithFiltersLazyQueryHookResult = ReturnType<typeof useGetGraphsWithFiltersLazyQuery>;
export type GetGraphsWithFiltersQueryResult = Apollo.QueryResult<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables>;
export const GetGraphsSearchDetailDocument = gql`
    query GetGraphsSearchDetail($workspaceId: String!, $staged: Boolean, $filters: GraphFilter) {
  getGraphsSearchDetail(
    workspaceId: $workspaceId
    staged: $staged
    filters: $filters
  ) {
    tags {
      value
      display
    }
    channels {
      value
      display
    }
    users {
      value
      display
    }
  }
}
    `;

/**
 * __useGetGraphsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetGraphsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphsSearchDetailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      staged: // value for 'staged'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetGraphsSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables>(GetGraphsSearchDetailDocument, options);
      }
export function useGetGraphsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables>(GetGraphsSearchDetailDocument, options);
        }
export type GetGraphsSearchDetailQueryHookResult = ReturnType<typeof useGetGraphsSearchDetailQuery>;
export type GetGraphsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetGraphsSearchDetailLazyQuery>;
export type GetGraphsSearchDetailQueryResult = Apollo.QueryResult<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables>;
export const GetJobsDocument = gql`
    query GetJobs($workspaceId: String!, $cursor: String, $limit: Int, $filters: DatasetJobFilter) {
  getDatasetJobs(
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    name
    datasetId
    status
    priority
    graphId
    channelId
    workspaceId
    averageRuntime
    instancesQueued
    instancesRunning
    instancesStarting
    runsSuccess
    runsTimeout
    seed
    runsRunning
    runsFailed
    runsCancelled
    runs
    runsStarting
    runsQueued
    updatedAt
    estimatedEndAt
    createdBy
    createdAt
    channel
  }
}
    `;

/**
 * __useGetJobsQuery__
 *
 * To run a query within a React component, call `useGetJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetJobsQuery(baseOptions: Apollo.QueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
      }
export function useGetJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
        }
export type GetJobsQueryHookResult = ReturnType<typeof useGetJobsQuery>;
export type GetJobsLazyQueryHookResult = ReturnType<typeof useGetJobsLazyQuery>;
export type GetJobsQueryResult = Apollo.QueryResult<GetJobsQuery, GetJobsQueryVariables>;
export const GetStagedGraphsDocument = gql`
    query GetStagedGraphs($workspaceId: String!, $staged: Boolean, $cursor: String, $limit: Int, $filters: GraphFilter) {
  getGraphs(
    workspaceId: $workspaceId
    staged: $staged
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    channel
    channelId
    createdAt
    createdBy
    description
    graphId
    name
    tags
    thumbnail
    workspaceId
    updatedAt
  }
}
    `;

/**
 * __useGetStagedGraphsQuery__
 *
 * To run a query within a React component, call `useGetStagedGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStagedGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStagedGraphsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      staged: // value for 'staged'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetStagedGraphsQuery(baseOptions: Apollo.QueryHookOptions<GetStagedGraphsQuery, GetStagedGraphsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStagedGraphsQuery, GetStagedGraphsQueryVariables>(GetStagedGraphsDocument, options);
      }
export function useGetStagedGraphsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStagedGraphsQuery, GetStagedGraphsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStagedGraphsQuery, GetStagedGraphsQueryVariables>(GetStagedGraphsDocument, options);
        }
export type GetStagedGraphsQueryHookResult = ReturnType<typeof useGetStagedGraphsQuery>;
export type GetStagedGraphsLazyQueryHookResult = ReturnType<typeof useGetStagedGraphsLazyQuery>;
export type GetStagedGraphsQueryResult = Apollo.QueryResult<GetStagedGraphsQuery, GetStagedGraphsQueryVariables>;
export const GetDatasetJobsSearchDetailDocument = gql`
    query GetDatasetJobsSearchDetail($organizationId: String, $workspaceId: String, $filters: DatasetJobFilter) {
  getDatasetJobsSearchDetail(
    organizationId: $organizationId
    workspaceId: $workspaceId
    filters: $filters
  ) {
    tags {
      value
      display
    }
    users {
      value
      display
    }
    channels {
      value
      display
    }
    type {
      value
      display
    }
  }
}
    `;

/**
 * __useGetDatasetJobsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetDatasetJobsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetJobsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetJobsSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetDatasetJobsSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>(GetDatasetJobsSearchDetailDocument, options);
      }
export function useGetDatasetJobsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>(GetDatasetJobsSearchDetailDocument, options);
        }
export type GetDatasetJobsSearchDetailQueryHookResult = ReturnType<typeof useGetDatasetJobsSearchDetailQuery>;
export type GetDatasetJobsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetDatasetJobsSearchDetailLazyQuery>;
export type GetDatasetJobsSearchDetailQueryResult = Apollo.QueryResult<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>;
export const GetGraphThumbnailsDocument = gql`
    query GetGraphThumbnails($workspaceId: String!) {
  getGraphs(workspaceId: $workspaceId) {
    graphId
    thumbnail
  }
}
    `;

/**
 * __useGetGraphThumbnailsQuery__
 *
 * To run a query within a React component, call `useGetGraphThumbnailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphThumbnailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphThumbnailsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetGraphThumbnailsQuery(baseOptions: Apollo.QueryHookOptions<GetGraphThumbnailsQuery, GetGraphThumbnailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphThumbnailsQuery, GetGraphThumbnailsQueryVariables>(GetGraphThumbnailsDocument, options);
      }
export function useGetGraphThumbnailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphThumbnailsQuery, GetGraphThumbnailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphThumbnailsQuery, GetGraphThumbnailsQueryVariables>(GetGraphThumbnailsDocument, options);
        }
export type GetGraphThumbnailsQueryHookResult = ReturnType<typeof useGetGraphThumbnailsQuery>;
export type GetGraphThumbnailsLazyQueryHookResult = ReturnType<typeof useGetGraphThumbnailsLazyQuery>;
export type GetGraphThumbnailsQueryResult = Apollo.QueryResult<GetGraphThumbnailsQuery, GetGraphThumbnailsQueryVariables>;
export const GetWorkspaceThumbnailDocument = gql`
    query GetWorkspaceThumbnail($workspaceId: String) {
  getWorkspaces(workspaceId: $workspaceId) {
    workspaceId
    previewThumbnail
  }
}
    `;

/**
 * __useGetWorkspaceThumbnailQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceThumbnailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceThumbnailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceThumbnailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceThumbnailQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceThumbnailQuery, GetWorkspaceThumbnailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceThumbnailQuery, GetWorkspaceThumbnailQueryVariables>(GetWorkspaceThumbnailDocument, options);
      }
export function useGetWorkspaceThumbnailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceThumbnailQuery, GetWorkspaceThumbnailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceThumbnailQuery, GetWorkspaceThumbnailQueryVariables>(GetWorkspaceThumbnailDocument, options);
        }
export type GetWorkspaceThumbnailQueryHookResult = ReturnType<typeof useGetWorkspaceThumbnailQuery>;
export type GetWorkspaceThumbnailLazyQueryHookResult = ReturnType<typeof useGetWorkspaceThumbnailLazyQuery>;
export type GetWorkspaceThumbnailQueryResult = Apollo.QueryResult<GetWorkspaceThumbnailQuery, GetWorkspaceThumbnailQueryVariables>;
export const GetRecentJobsDocument = gql`
    query GetRecentJobs($workspaceId: String!) {
  getDatasetJobs(workspaceId: $workspaceId, limit: 15) {
    createdAt
    datasetId
    estimatedEndAt
    name
    status
  }
}
    `;

/**
 * __useGetRecentJobsQuery__
 *
 * To run a query within a React component, call `useGetRecentJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentJobsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetRecentJobsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentJobsQuery, GetRecentJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentJobsQuery, GetRecentJobsQueryVariables>(GetRecentJobsDocument, options);
      }
export function useGetRecentJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentJobsQuery, GetRecentJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentJobsQuery, GetRecentJobsQueryVariables>(GetRecentJobsDocument, options);
        }
export type GetRecentJobsQueryHookResult = ReturnType<typeof useGetRecentJobsQuery>;
export type GetRecentJobsLazyQueryHookResult = ReturnType<typeof useGetRecentJobsLazyQuery>;
export type GetRecentJobsQueryResult = Apollo.QueryResult<GetRecentJobsQuery, GetRecentJobsQueryVariables>;
export const GetRecentGraphsDocument = gql`
    query GetRecentGraphs($workspaceId: String!, $staged: Boolean) {
  getGraphs(workspaceId: $workspaceId, staged: $staged, limit: 15) {
    channel
    channelId
    createdAt
    createdBy
    description
    graphId
    name
    tags
    thumbnail
    updatedAt
    workspaceId
  }
}
    `;

/**
 * __useGetRecentGraphsQuery__
 *
 * To run a query within a React component, call `useGetRecentGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentGraphsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      staged: // value for 'staged'
 *   },
 * });
 */
export function useGetRecentGraphsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentGraphsQuery, GetRecentGraphsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentGraphsQuery, GetRecentGraphsQueryVariables>(GetRecentGraphsDocument, options);
      }
export function useGetRecentGraphsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentGraphsQuery, GetRecentGraphsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentGraphsQuery, GetRecentGraphsQueryVariables>(GetRecentGraphsDocument, options);
        }
export type GetRecentGraphsQueryHookResult = ReturnType<typeof useGetRecentGraphsQuery>;
export type GetRecentGraphsLazyQueryHookResult = ReturnType<typeof useGetRecentGraphsLazyQuery>;
export type GetRecentGraphsQueryResult = Apollo.QueryResult<GetRecentGraphsQuery, GetRecentGraphsQueryVariables>;
export const GetRecentDatasetsDocument = gql`
    query GetRecentDatasets($workspaceId: String!) {
  getDatasets(workspaceId: $workspaceId, limit: 30) {
    createdAt
    datasetId
    name
    runs
  }
}
    `;

/**
 * __useGetRecentDatasetsQuery__
 *
 * To run a query within a React component, call `useGetRecentDatasetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentDatasetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentDatasetsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetRecentDatasetsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables>(GetRecentDatasetsDocument, options);
      }
export function useGetRecentDatasetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables>(GetRecentDatasetsDocument, options);
        }
export type GetRecentDatasetsQueryHookResult = ReturnType<typeof useGetRecentDatasetsQuery>;
export type GetRecentDatasetsLazyQueryHookResult = ReturnType<typeof useGetRecentDatasetsLazyQuery>;
export type GetRecentDatasetsQueryResult = Apollo.QueryResult<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables>;
export const GetWorkspaceResourcesAvailableChannelsDocument = gql`
    query GetWorkspaceResourcesAvailableChannels($organizationId: String) {
  getChannels(organizationId: $organizationId) {
    channelId
    name
  }
}
    `;

/**
 * __useGetWorkspaceResourcesAvailableChannelsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceResourcesAvailableChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceResourcesAvailableChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceResourcesAvailableChannelsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetWorkspaceResourcesAvailableChannelsQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceResourcesAvailableChannelsQuery, GetWorkspaceResourcesAvailableChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceResourcesAvailableChannelsQuery, GetWorkspaceResourcesAvailableChannelsQueryVariables>(GetWorkspaceResourcesAvailableChannelsDocument, options);
      }
export function useGetWorkspaceResourcesAvailableChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceResourcesAvailableChannelsQuery, GetWorkspaceResourcesAvailableChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceResourcesAvailableChannelsQuery, GetWorkspaceResourcesAvailableChannelsQueryVariables>(GetWorkspaceResourcesAvailableChannelsDocument, options);
        }
export type GetWorkspaceResourcesAvailableChannelsQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesAvailableChannelsQuery>;
export type GetWorkspaceResourcesAvailableChannelsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesAvailableChannelsLazyQuery>;
export type GetWorkspaceResourcesAvailableChannelsQueryResult = Apollo.QueryResult<GetWorkspaceResourcesAvailableChannelsQuery, GetWorkspaceResourcesAvailableChannelsQueryVariables>;
export const GetWorkspaceResourcesWorkspaceChannelsDocument = gql`
    query GetWorkspaceResourcesWorkspaceChannels($workspaceId: String) {
  getChannels(workspaceId: $workspaceId) {
    channelId
    name
  }
}
    `;

/**
 * __useGetWorkspaceResourcesWorkspaceChannelsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceResourcesWorkspaceChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceResourcesWorkspaceChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceResourcesWorkspaceChannelsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceResourcesWorkspaceChannelsQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceResourcesWorkspaceChannelsQuery, GetWorkspaceResourcesWorkspaceChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceResourcesWorkspaceChannelsQuery, GetWorkspaceResourcesWorkspaceChannelsQueryVariables>(GetWorkspaceResourcesWorkspaceChannelsDocument, options);
      }
export function useGetWorkspaceResourcesWorkspaceChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceResourcesWorkspaceChannelsQuery, GetWorkspaceResourcesWorkspaceChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceResourcesWorkspaceChannelsQuery, GetWorkspaceResourcesWorkspaceChannelsQueryVariables>(GetWorkspaceResourcesWorkspaceChannelsDocument, options);
        }
export type GetWorkspaceResourcesWorkspaceChannelsQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesWorkspaceChannelsQuery>;
export type GetWorkspaceResourcesWorkspaceChannelsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesWorkspaceChannelsLazyQuery>;
export type GetWorkspaceResourcesWorkspaceChannelsQueryResult = Apollo.QueryResult<GetWorkspaceResourcesWorkspaceChannelsQuery, GetWorkspaceResourcesWorkspaceChannelsQueryVariables>;
export const GetWorkspaceResourcesAvailableVolumesDocument = gql`
    query GetWorkspaceResourcesAvailableVolumes($organizationId: String) {
  getVolumes(organizationId: $organizationId) {
    volumeId
    name
  }
}
    `;

/**
 * __useGetWorkspaceResourcesAvailableVolumesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceResourcesAvailableVolumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceResourcesAvailableVolumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceResourcesAvailableVolumesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetWorkspaceResourcesAvailableVolumesQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceResourcesAvailableVolumesQuery, GetWorkspaceResourcesAvailableVolumesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceResourcesAvailableVolumesQuery, GetWorkspaceResourcesAvailableVolumesQueryVariables>(GetWorkspaceResourcesAvailableVolumesDocument, options);
      }
export function useGetWorkspaceResourcesAvailableVolumesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceResourcesAvailableVolumesQuery, GetWorkspaceResourcesAvailableVolumesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceResourcesAvailableVolumesQuery, GetWorkspaceResourcesAvailableVolumesQueryVariables>(GetWorkspaceResourcesAvailableVolumesDocument, options);
        }
export type GetWorkspaceResourcesAvailableVolumesQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesAvailableVolumesQuery>;
export type GetWorkspaceResourcesAvailableVolumesLazyQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesAvailableVolumesLazyQuery>;
export type GetWorkspaceResourcesAvailableVolumesQueryResult = Apollo.QueryResult<GetWorkspaceResourcesAvailableVolumesQuery, GetWorkspaceResourcesAvailableVolumesQueryVariables>;
export const GetWorkspaceResourcesWorkspaceVolumesDocument = gql`
    query GetWorkspaceResourcesWorkspaceVolumes($workspaceId: String) {
  getVolumes(workspaceId: $workspaceId) {
    volumeId
    name
  }
}
    `;

/**
 * __useGetWorkspaceResourcesWorkspaceVolumesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceResourcesWorkspaceVolumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceResourcesWorkspaceVolumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceResourcesWorkspaceVolumesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceResourcesWorkspaceVolumesQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceResourcesWorkspaceVolumesQuery, GetWorkspaceResourcesWorkspaceVolumesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceResourcesWorkspaceVolumesQuery, GetWorkspaceResourcesWorkspaceVolumesQueryVariables>(GetWorkspaceResourcesWorkspaceVolumesDocument, options);
      }
export function useGetWorkspaceResourcesWorkspaceVolumesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceResourcesWorkspaceVolumesQuery, GetWorkspaceResourcesWorkspaceVolumesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceResourcesWorkspaceVolumesQuery, GetWorkspaceResourcesWorkspaceVolumesQueryVariables>(GetWorkspaceResourcesWorkspaceVolumesDocument, options);
        }
export type GetWorkspaceResourcesWorkspaceVolumesQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesWorkspaceVolumesQuery>;
export type GetWorkspaceResourcesWorkspaceVolumesLazyQueryHookResult = ReturnType<typeof useGetWorkspaceResourcesWorkspaceVolumesLazyQuery>;
export type GetWorkspaceResourcesWorkspaceVolumesQueryResult = Apollo.QueryResult<GetWorkspaceResourcesWorkspaceVolumesQuery, GetWorkspaceResourcesWorkspaceVolumesQueryVariables>;
export const GetDatasetImageFilenamesDocument = gql`
    query GetDatasetImageFilenames($workspaceId: String!, $datasetId: String!, $path: String, $cursor: String, $limit: Int) {
  getDatasetFiles(
    workspaceId: $workspaceId
    datasetId: $datasetId
    path: $path
    cursor: $cursor
    limit: $limit
  )
}
    `;

/**
 * __useGetDatasetImageFilenamesQuery__
 *
 * To run a query within a React component, call `useGetDatasetImageFilenamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetImageFilenamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetImageFilenamesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      path: // value for 'path'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDatasetImageFilenamesQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables>(GetDatasetImageFilenamesDocument, options);
      }
export function useGetDatasetImageFilenamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables>(GetDatasetImageFilenamesDocument, options);
        }
export type GetDatasetImageFilenamesQueryHookResult = ReturnType<typeof useGetDatasetImageFilenamesQuery>;
export type GetDatasetImageFilenamesLazyQueryHookResult = ReturnType<typeof useGetDatasetImageFilenamesLazyQuery>;
export type GetDatasetImageFilenamesQueryResult = Apollo.QueryResult<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables>;
export const GetImageInferenceDocument = gql`
    query GetImageInference($workspaceId: String!, $inferenceId: String!, $filename: String!) {
  getImageInference(
    workspaceId: $workspaceId
    inferenceId: $inferenceId
    filename: $filename
  ) {
    image
    inferences {
      bbox
      class
      className
      confidence
    }
  }
}
    `;

/**
 * __useGetImageInferenceQuery__
 *
 * To run a query within a React component, call `useGetImageInferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageInferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageInferenceQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      inferenceId: // value for 'inferenceId'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGetImageInferenceQuery(baseOptions: Apollo.QueryHookOptions<GetImageInferenceQuery, GetImageInferenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImageInferenceQuery, GetImageInferenceQueryVariables>(GetImageInferenceDocument, options);
      }
export function useGetImageInferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImageInferenceQuery, GetImageInferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImageInferenceQuery, GetImageInferenceQueryVariables>(GetImageInferenceDocument, options);
        }
export type GetImageInferenceQueryHookResult = ReturnType<typeof useGetImageInferenceQuery>;
export type GetImageInferenceLazyQueryHookResult = ReturnType<typeof useGetImageInferenceLazyQuery>;
export type GetImageInferenceQueryResult = Apollo.QueryResult<GetImageInferenceQuery, GetImageInferenceQueryVariables>;
export const GetImageAnnotationDocument = gql`
    query GetImageAnnotation($workspaceId: String!, $datasetId: String!, $filename: String!) {
  getImageAnnotation(
    workspaceId: $workspaceId
    datasetId: $datasetId
    filename: $filename
  ) {
    data
    datasetId
    filename
  }
}
    `;

/**
 * __useGetImageAnnotationQuery__
 *
 * To run a query within a React component, call `useGetImageAnnotationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageAnnotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageAnnotationQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGetImageAnnotationQuery(baseOptions: Apollo.QueryHookOptions<GetImageAnnotationQuery, GetImageAnnotationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImageAnnotationQuery, GetImageAnnotationQueryVariables>(GetImageAnnotationDocument, options);
      }
export function useGetImageAnnotationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImageAnnotationQuery, GetImageAnnotationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImageAnnotationQuery, GetImageAnnotationQueryVariables>(GetImageAnnotationDocument, options);
        }
export type GetImageAnnotationQueryHookResult = ReturnType<typeof useGetImageAnnotationQuery>;
export type GetImageAnnotationLazyQueryHookResult = ReturnType<typeof useGetImageAnnotationLazyQuery>;
export type GetImageAnnotationQueryResult = Apollo.QueryResult<GetImageAnnotationQuery, GetImageAnnotationQueryVariables>;
export const GetDatasetsForMixDocument = gql`
    query GetDatasetsForMix($workspaceId: String!, $cursor: String, $limit: Int) {
  getDatasets(workspaceId: $workspaceId, cursor: $cursor, limit: $limit) {
    classes
    datasetId
    files
    name
  }
}
    `;

/**
 * __useGetDatasetsForMixQuery__
 *
 * To run a query within a React component, call `useGetDatasetsForMixQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetsForMixQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetsForMixQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDatasetsForMixQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetsForMixQuery, GetDatasetsForMixQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetsForMixQuery, GetDatasetsForMixQueryVariables>(GetDatasetsForMixDocument, options);
      }
export function useGetDatasetsForMixLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetsForMixQuery, GetDatasetsForMixQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetsForMixQuery, GetDatasetsForMixQueryVariables>(GetDatasetsForMixDocument, options);
        }
export type GetDatasetsForMixQueryHookResult = ReturnType<typeof useGetDatasetsForMixQuery>;
export type GetDatasetsForMixLazyQueryHookResult = ReturnType<typeof useGetDatasetsForMixLazyQuery>;
export type GetDatasetsForMixQueryResult = Apollo.QueryResult<GetDatasetsForMixQuery, GetDatasetsForMixQueryVariables>;
export const GetDatasetDetailsAnalyticsDocument = gql`
    query GetDatasetDetailsAnalytics($workspaceId: String!, $datasetId: String) {
  getAnalytics(workspaceId: $workspaceId, datasetId: $datasetId) {
    analyticsId
    datasetId
    status
    tags
    type
    workspaceId
  }
}
    `;

/**
 * __useGetDatasetDetailsAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetDatasetDetailsAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetDetailsAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetDetailsAnalyticsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetDetailsAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables>(GetDatasetDetailsAnalyticsDocument, options);
      }
export function useGetDatasetDetailsAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables>(GetDatasetDetailsAnalyticsDocument, options);
        }
export type GetDatasetDetailsAnalyticsQueryHookResult = ReturnType<typeof useGetDatasetDetailsAnalyticsQuery>;
export type GetDatasetDetailsAnalyticsLazyQueryHookResult = ReturnType<typeof useGetDatasetDetailsAnalyticsLazyQuery>;
export type GetDatasetDetailsAnalyticsQueryResult = Apollo.QueryResult<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables>;
export const GetAnnotationsDocument = gql`
    query GetAnnotations($workspaceId: String!, $datasetId: String) {
  getAnnotations(workspaceId: $workspaceId, datasetId: $datasetId) {
    annotationId
    datasetId
    format
    map
    status
    tags
    updatedAt
    workspaceId
  }
}
    `;

/**
 * __useGetAnnotationsQuery__
 *
 * To run a query within a React component, call `useGetAnnotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetAnnotationsQuery(baseOptions: Apollo.QueryHookOptions<GetAnnotationsQuery, GetAnnotationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnotationsQuery, GetAnnotationsQueryVariables>(GetAnnotationsDocument, options);
      }
export function useGetAnnotationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnotationsQuery, GetAnnotationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnotationsQuery, GetAnnotationsQueryVariables>(GetAnnotationsDocument, options);
        }
export type GetAnnotationsQueryHookResult = ReturnType<typeof useGetAnnotationsQuery>;
export type GetAnnotationsLazyQueryHookResult = ReturnType<typeof useGetAnnotationsLazyQuery>;
export type GetAnnotationsQueryResult = Apollo.QueryResult<GetAnnotationsQuery, GetAnnotationsQueryVariables>;
export const GetDatasetDetailsGANDatasetsDocument = gql`
    query GetDatasetDetailsGANDatasets($workspaceId: String!, $datasetId: String) {
  getGANDatasets(workspaceId: $workspaceId, datasetId: $datasetId) {
    datasetId
    description
    model
    name
    status
    tags
    updatedAt
    workspaceId
  }
}
    `;

/**
 * __useGetDatasetDetailsGANDatasetsQuery__
 *
 * To run a query within a React component, call `useGetDatasetDetailsGANDatasetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetDetailsGANDatasetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetDetailsGANDatasetsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetDetailsGANDatasetsQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetDetailsGANDatasetsQuery, GetDatasetDetailsGANDatasetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetDetailsGANDatasetsQuery, GetDatasetDetailsGANDatasetsQueryVariables>(GetDatasetDetailsGANDatasetsDocument, options);
      }
export function useGetDatasetDetailsGANDatasetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetDetailsGANDatasetsQuery, GetDatasetDetailsGANDatasetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetDetailsGANDatasetsQuery, GetDatasetDetailsGANDatasetsQueryVariables>(GetDatasetDetailsGANDatasetsDocument, options);
        }
export type GetDatasetDetailsGANDatasetsQueryHookResult = ReturnType<typeof useGetDatasetDetailsGANDatasetsQuery>;
export type GetDatasetDetailsGANDatasetsLazyQueryHookResult = ReturnType<typeof useGetDatasetDetailsGANDatasetsLazyQuery>;
export type GetDatasetDetailsGANDatasetsQueryResult = Apollo.QueryResult<GetDatasetDetailsGANDatasetsQuery, GetDatasetDetailsGANDatasetsQueryVariables>;
export const GetDatasetDetailsUMAPsDocument = gql`
    query GetDatasetDetailsUMAPs($workspaceId: String!, $datasetId: String) {
  getUMAPs(workspaceId: $workspaceId, datasetId: $datasetId) {
    name
    status
    tags
    umapId
  }
}
    `;

/**
 * __useGetDatasetDetailsUMAPsQuery__
 *
 * To run a query within a React component, call `useGetDatasetDetailsUMAPsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetDetailsUMAPsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetDetailsUMAPsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetDetailsUMAPsQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetDetailsUMAPsQuery, GetDatasetDetailsUMAPsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetDetailsUMAPsQuery, GetDatasetDetailsUMAPsQueryVariables>(GetDatasetDetailsUMAPsDocument, options);
      }
export function useGetDatasetDetailsUMAPsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetDetailsUMAPsQuery, GetDatasetDetailsUMAPsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetDetailsUMAPsQuery, GetDatasetDetailsUMAPsQueryVariables>(GetDatasetDetailsUMAPsDocument, options);
        }
export type GetDatasetDetailsUMAPsQueryHookResult = ReturnType<typeof useGetDatasetDetailsUMAPsQuery>;
export type GetDatasetDetailsUMAPsLazyQueryHookResult = ReturnType<typeof useGetDatasetDetailsUMAPsLazyQuery>;
export type GetDatasetDetailsUMAPsQueryResult = Apollo.QueryResult<GetDatasetDetailsUMAPsQuery, GetDatasetDetailsUMAPsQueryVariables>;
export const GetDatasetInferencesDocument = gql`
    query GetDatasetInferences($workspaceId: String!, $datasetId: String) {
  getMLInferences(workspaceId: $workspaceId, datasetId: $datasetId) {
    inferenceId
    dataset
    datasetId
    modelId
    model
    status
    tags
    workspaceId
  }
}
    `;

/**
 * __useGetDatasetInferencesQuery__
 *
 * To run a query within a React component, call `useGetDatasetInferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetInferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetInferencesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetInferencesQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables>(GetDatasetInferencesDocument, options);
      }
export function useGetDatasetInferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables>(GetDatasetInferencesDocument, options);
        }
export type GetDatasetInferencesQueryHookResult = ReturnType<typeof useGetDatasetInferencesQuery>;
export type GetDatasetInferencesLazyQueryHookResult = ReturnType<typeof useGetDatasetInferencesLazyQuery>;
export type GetDatasetInferencesQueryResult = Apollo.QueryResult<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables>;
export const GetDatasetModelsDocument = gql`
    query GetDatasetModels($workspaceId: String!, $datasetId: String) {
  getMLModels(workspaceId: $workspaceId, datasetId: $datasetId) {
    modelId
    name
    status
    tags
    workspaceId
  }
}
    `;

/**
 * __useGetDatasetModelsQuery__
 *
 * To run a query within a React component, call `useGetDatasetModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetModelsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetModelsQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetModelsQuery, GetDatasetModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetModelsQuery, GetDatasetModelsQueryVariables>(GetDatasetModelsDocument, options);
      }
export function useGetDatasetModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetModelsQuery, GetDatasetModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetModelsQuery, GetDatasetModelsQueryVariables>(GetDatasetModelsDocument, options);
        }
export type GetDatasetModelsQueryHookResult = ReturnType<typeof useGetDatasetModelsQuery>;
export type GetDatasetModelsLazyQueryHookResult = ReturnType<typeof useGetDatasetModelsLazyQuery>;
export type GetDatasetModelsQueryResult = Apollo.QueryResult<GetDatasetModelsQuery, GetDatasetModelsQueryVariables>;
export const GetDatasetsWithFilterDocument = gql`
    query GetDatasetsWithFilter($workspaceId: String!, $cursor: String, $limit: Int, $filters: DatasetFilter) {
  getDatasets(
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    channel
    channelId
    classes
    createdAt
    createdBy
    datasetId
    description
    files
    graphId
    name
    runs
    seed
    size
    source
    status
    tags
    type
  }
}
    `;

/**
 * __useGetDatasetsWithFilterQuery__
 *
 * To run a query within a React component, call `useGetDatasetsWithFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetsWithFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetsWithFilterQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetDatasetsWithFilterQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables>(GetDatasetsWithFilterDocument, options);
      }
export function useGetDatasetsWithFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables>(GetDatasetsWithFilterDocument, options);
        }
export type GetDatasetsWithFilterQueryHookResult = ReturnType<typeof useGetDatasetsWithFilterQuery>;
export type GetDatasetsWithFilterLazyQueryHookResult = ReturnType<typeof useGetDatasetsWithFilterLazyQuery>;
export type GetDatasetsWithFilterQueryResult = Apollo.QueryResult<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables>;
export const GetDatasetsSearchDetailDocument = gql`
    query GetDatasetsSearchDetail($workspaceId: String!, $filters: DatasetFilter) {
  getDatasetsSearchDetail(workspaceId: $workspaceId, filters: $filters) {
    channels {
      value
      display
    }
    tags {
      value
      display
    }
    type {
      value
      display
    }
    users {
      value
      display
    }
  }
}
    `;

/**
 * __useGetDatasetsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetDatasetsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetsSearchDetailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetDatasetsSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables>(GetDatasetsSearchDetailDocument, options);
      }
export function useGetDatasetsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables>(GetDatasetsSearchDetailDocument, options);
        }
export type GetDatasetsSearchDetailQueryHookResult = ReturnType<typeof useGetDatasetsSearchDetailQuery>;
export type GetDatasetsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetDatasetsSearchDetailLazyQuery>;
export type GetDatasetsSearchDetailQueryResult = Apollo.QueryResult<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables>;
export const GetAvailableChannelsForNewWorkspaceDocument = gql`
    query GetAvailableChannelsForNewWorkspace($organizationId: String!) {
  getChannels(organizationId: $organizationId) {
    channelId
    name
  }
}
    `;

/**
 * __useGetAvailableChannelsForNewWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetAvailableChannelsForNewWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableChannelsForNewWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableChannelsForNewWorkspaceQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetAvailableChannelsForNewWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableChannelsForNewWorkspaceQuery, GetAvailableChannelsForNewWorkspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableChannelsForNewWorkspaceQuery, GetAvailableChannelsForNewWorkspaceQueryVariables>(GetAvailableChannelsForNewWorkspaceDocument, options);
      }
export function useGetAvailableChannelsForNewWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableChannelsForNewWorkspaceQuery, GetAvailableChannelsForNewWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableChannelsForNewWorkspaceQuery, GetAvailableChannelsForNewWorkspaceQueryVariables>(GetAvailableChannelsForNewWorkspaceDocument, options);
        }
export type GetAvailableChannelsForNewWorkspaceQueryHookResult = ReturnType<typeof useGetAvailableChannelsForNewWorkspaceQuery>;
export type GetAvailableChannelsForNewWorkspaceLazyQueryHookResult = ReturnType<typeof useGetAvailableChannelsForNewWorkspaceLazyQuery>;
export type GetAvailableChannelsForNewWorkspaceQueryResult = Apollo.QueryResult<GetAvailableChannelsForNewWorkspaceQuery, GetAvailableChannelsForNewWorkspaceQueryVariables>;